// tslint:disable
/**
 * API Praksisstedbruker API
 * ALP api for Stuidestedbrukere
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import { COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbstractSignatarDto
 */
export interface AbstractSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'fornavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'etternavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof AbstractSignatarDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AvtalestatusDto = {
    IkkeAktiv: 'IkkeAktiv',
    Aktiv: 'Aktiv',
    SendtTilSignering: 'SendtTilSignering',
    InnhenterOpplysninger: 'InnhenterOpplysninger',
    Kansellert: 'Kansellert',
    Avsluttet: 'Avsluttet',
    Utkast: 'Utkast',
    Feil: 'FEIL'
} as const;

export type AvtalestatusDto = typeof AvtalestatusDto[keyof typeof AvtalestatusDto];


/**
 * Et gitt praksissted som er avtalestedet (toppnoden) for et praksissted hierarki. Definerer også om avtalen er omfattet, så betyr bare de angitte praksisstedene
 * @export
 * @interface AvtalestederMedMuligeOmfattedePraksisstedDto
 */
export interface AvtalestederMedMuligeOmfattedePraksisstedDto {
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstedDto
     */
    'avtalestedforelder'?: MinimalPraksisstedDto;
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstedDto
     */
    'omfattetPraksisstedsteder'?: Array<MinimalPraksisstedDto>;
}
/**
 * Et gitt praksissted som er avtalestedet (toppnoden) for et praksissted hierarki. Definerer også om avtalen er omfattet, så betyr bare de angitte praksisstedene
 * @export
 * @interface AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto
 */
export interface AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto {
    /**
     * 
     * @type {MinimalPraksisstedMedHierarkiDto}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto
     */
    'avtalestedforelder': MinimalPraksisstedMedHierarkiDto;
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto
     */
    'omfattetPraksisstedsteder'?: Array<MinimalPraksisstedDto>;
}
/**
 * 
 * @export
 * @interface BrukerinfoDto
 */
export interface BrukerinfoDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'telefonnummer': string;
    /**
     * 
     * @type {BrukerinnstillingerDto}
     * @memberof BrukerinfoDto
     */
    'innstillinger': BrukerinnstillingerDto;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof BrukerinfoDto
     */
    'hoeyesteRettighet': BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface BrukerinnstillingerDto
 */
export interface BrukerinnstillingerDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerinnstillingerDto
     */
    'spraakvalg'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrukerinnstillingerDto
     */
    'harGodtattBetingelser'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BrukerrollerDto = {
    Administrator: 'Administrator',
    Skriverettighet: 'Skriverettighet',
    Leserettighet: 'Leserettighet'
} as const;

export type BrukerrollerDto = typeof BrukerrollerDto[keyof typeof BrukerrollerDto];


/**
 * 
 * @export
 * @enum {string}
 */

export const BrukerstatusDto = {
    Aktiv: 'Aktiv',
    Invitert: 'Invitert'
} as const;

export type BrukerstatusDto = typeof BrukerstatusDto[keyof typeof BrukerstatusDto];


/**
 * Institusjon/studiested som eier avtalen, og hvilke studiesteder den gjelder for
 * @export
 * @interface EierAvtalestedMedMuligeOmfattedeStudiestedDto
 */
export interface EierAvtalestedMedMuligeOmfattedeStudiestedDto {
    /**
     * 
     * @type {MinimalStudiestedDto}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedDto
     */
    'avtalestedforelder'?: MinimalStudiestedDto;
    /**
     * 
     * @type {Array<MinimalStudiestedDto>}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedDto
     */
    'omfattetStudiesteder'?: Array<MinimalStudiestedDto>;
}
/**
 * Institusjon/studiested som eier avtalen, og hvilke studiesteder den gjelder for
 * @export
 * @interface EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto
 */
export interface EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto {
    /**
     * 
     * @type {MinimalStudiestedHierarkiDto}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto
     */
    'avtalestedforelder': MinimalStudiestedHierarkiDto;
    /**
     * 
     * @type {Array<MinimalStudiestedDto>}
     * @memberof EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto
     */
    'omfattetStudiesteder'?: Array<MinimalStudiestedDto>;
}
/**
 * 
 * @export
 * @interface EksternSignatarDto
 */
export interface EksternSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'fornavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'etternavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof EksternSignatarDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @interface EmneDto
 */
export interface EmneDto {
    /**
     * 
     * @type {string}
     * @memberof EmneDto
     */
    'kode': string;
    /**
     * 
     * @type {string}
     * @memberof EmneDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface HalPraksisavtaleVedleggMinimalListDto
 */
export interface HalPraksisavtaleVedleggMinimalListDto {
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof HalPraksisavtaleVedleggMinimalListDto
     */
    'items'?: Array<PraksisavtaleVedleggMinimalDto>;
}
/**
 * @type HalPraksisstedavtaleDto
 * @export
 */
export type HalPraksisstedavtaleDto = PraksisstedavtaleDto | PraksisstedavtaleMedStedForelderHierarkiDto;

/**
 * 
 * @export
 * @interface HalPraksisstedavtalerDto
 */
export interface HalPraksisstedavtalerDto {
    /**
     * 
     * @type {Array<PraksisstedavtaleDto>}
     * @memberof HalPraksisstedavtalerDto
     */
    'avtaler'?: Array<PraksisstedavtaleDto>;
}
/**
 * 
 * @export
 * @interface MinimalAktivitetInfoDto
 */
export interface MinimalAktivitetInfoDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'aktivitetId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'emnekode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'praksistypenavn': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'praksisklassenavn': string;
    /**
     * 
     * @type {number}
     * @memberof MinimalAktivitetInfoDto
     */
    'studenter'?: number;
    /**
     * 
     * @type {string}
     * @memberof MinimalAktivitetInfoDto
     */
    'aktivitetVurderingStatus': MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum;
}

export const MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum = {
    Gjennomfoert: 'Gjennomfoert',
    Aktiv: 'Aktiv',
    Framtidig: 'Framtidig'
} as const;

export type MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum = typeof MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum[keyof typeof MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum];

/**
 * 
 * @export
 * @interface MinimalAktiviteterDto
 */
export interface MinimalAktiviteterDto {
    /**
     * 
     * @type {Array<MinimalAktivitetInfoDto>}
     * @memberof MinimalAktiviteterDto
     */
    'aktiviteter'?: Array<MinimalAktivitetInfoDto>;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedDto
 */
export interface MinimalPraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedMedHierarkiDto
 */
export interface MinimalPraksisstedMedHierarkiDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'orgnr'?: string;
    /**
     * 
     * @type {MinimalPraksisstedMedHierarkiNoderDto}
     * @memberof MinimalPraksisstedMedHierarkiDto
     */
    'noder': MinimalPraksisstedMedHierarkiNoderDto;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedMedHierarkiNoderDto
 */
export interface MinimalPraksisstedMedHierarkiNoderDto {
    /**
     * 
     * @type {MinimalPraksisstedMedHierarkiDto}
     * @memberof MinimalPraksisstedMedHierarkiNoderDto
     */
    'over'?: MinimalPraksisstedMedHierarkiDto;
    /**
     * 
     * @type {Array<MinimalPraksisstedMedHierarkiDto>}
     * @memberof MinimalPraksisstedMedHierarkiNoderDto
     */
    'under': Array<MinimalPraksisstedMedHierarkiDto>;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedprofilDto
 */
export interface MinimalPraksisstedprofilDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedprofilDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedprofilDto
     */
    'navn': string;
    /**
     * base64-kodet bilde
     * @type {string}
     * @memberof MinimalPraksisstedprofilDto
     */
    'bilde': string;
}
/**
 * 
 * @export
 * @interface MinimalStudiestedDto
 */
export interface MinimalStudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface MinimalStudiestedHierarkiDto
 */
export interface MinimalStudiestedHierarkiDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedHierarkiDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedHierarkiDto
     */
    'navn': string;
    /**
     * 
     * @type {MinimalStudiestedHierarkiNoderDto}
     * @memberof MinimalStudiestedHierarkiDto
     */
    'noder': MinimalStudiestedHierarkiNoderDto;
}
/**
 * 
 * @export
 * @interface MinimalStudiestedHierarkiNoderDto
 */
export interface MinimalStudiestedHierarkiNoderDto {
    /**
     * 
     * @type {Array<MinimalStudiestedHierarkiDto>}
     * @memberof MinimalStudiestedHierarkiNoderDto
     */
    'over': Array<MinimalStudiestedHierarkiDto>;
    /**
     * 
     * @type {Array<MinimalStudiestedHierarkiDto>}
     * @memberof MinimalStudiestedHierarkiNoderDto
     */
    'under': Array<MinimalStudiestedHierarkiDto>;
}
/**
 * 
 * @export
 * @interface MuligPraksisstedDto
 */
export interface MuligPraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof MuligPraksisstedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MuligPraksisstedDto
     */
    'navn': string;
    /**
     * 
     * @type {number}
     * @memberof MuligPraksisstedDto
     */
    'dybde'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MuligPraksisstedDto
     */
    'endenode'?: boolean;
    /**
     * Om praksisstedet skal merkes som deaktivert ved opplisting
     * @type {boolean}
     * @memberof MuligPraksisstedDto
     */
    'deaktivert': boolean;
}
/**
 * 
 * @export
 * @interface MultiSignatarerDto
 */
export interface MultiSignatarerDto {
    /**
     * 
     * @type {Array<EksternSignatarDto>}
     * @memberof MultiSignatarerDto
     */
    'eksternbrukere'?: Array<EksternSignatarDto>;
    /**
     * 
     * @type {Array<StudiestedbrukerSignatarDto>}
     * @memberof MultiSignatarerDto
     */
    'studiestedbrukere'?: Array<StudiestedbrukerSignatarDto>;
    /**
     * 
     * @type {Array<PraksisstedbrukerSignatarDto>}
     * @memberof MultiSignatarerDto
     */
    'praksisstedbrukere'?: Array<PraksisstedbrukerSignatarDto>;
}
/**
 * 
 * @export
 * @interface NyPraksisstedbrukerInvitasjonDto
 */
export interface NyPraksisstedbrukerInvitasjonDto {
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'fnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof NyPraksisstedbrukerInvitasjonDto
     */
    'tilgangsrolle': BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface NyRolleDto
 */
export interface NyRolleDto {
    /**
     * 
     * @type {string}
     * @memberof NyRolleDto
     */
    'praksisstedbrukerId'?: string;
    /**
     * 
     * @type {PraksisstedRollerDto}
     * @memberof NyRolleDto
     */
    'type'?: PraksisstedRollerDto;
}


/**
 * 
 * @export
 * @interface PersonDto
 */
export interface PersonDto {
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'fsId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    'etternavn': string;
}
/**
 * 
 * @export
 * @interface PraksisDto
 */
export interface PraksisDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisDto
     */
    'kode': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetDto
 */
export interface PraksisaktivitetDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetDto
     */
    'totalBestilling': number;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetDto
     */
    'totalKapasitet': number;
    /**
     * 
     * @type {Array<PraksisavtaleStedDto>}
     * @memberof PraksisaktivitetDto
     */
    'praksissteder': Array<PraksisavtaleStedDto>;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'krav'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'organisasjonsNavn': string;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'publisertTilFs': boolean;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksisaktivitetDto
     */
    'status'?: PraksisaktivitetStatusDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'fritekst'?: string;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om Identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisaktivitetDto
     */
    'delIdentitetsnummer'?: boolean;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetInfoDetaljertPsDto
 */
export interface PraksisaktivitetInfoDetaljertPsDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'bestilling'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'krav'?: string;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'status'?: PraksisaktivitetStatusDto;
    /**
     * 
     * @type {Array<PraksisstedRollerDto>}
     * @memberof PraksisaktivitetInfoDetaljertPsDto
     */
    'rolle'?: Array<PraksisstedRollerDto>;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetInfoDetaljertUhDto
 */
export interface PraksisaktivitetInfoDetaljertUhDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'bestilling': number;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'krav'?: string;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'status'?: PraksisaktivitetStatusDto;
    /**
     * 
     * @type {Array<StudiestedRollerDto>}
     * @memberof PraksisaktivitetInfoDetaljertUhDto
     */
    'rolle'?: Array<StudiestedRollerDto>;
}


/**
 * 
 * @export
 * @interface PraksisaktivitetInfoDto
 */
export interface PraksisaktivitetInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDto
     */
    'id': string;
    /**
     * 
     * @type {StudiestedDto}
     * @memberof PraksisaktivitetInfoDto
     */
    'sted': StudiestedDto;
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisaktivitetInfoDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {PraksisklasseDto}
     * @memberof PraksisaktivitetInfoDto
     */
    'klasse': PraksisklasseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetInfoDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetInfoDto
     */
    'bestilling': number;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetPutBesvarelseDto
 */
export interface PraksisaktivitetPutBesvarelseDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutBesvarelseDto
     */
    'bestillingId': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetPutBesvarelseDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetPutBesvarelseDto
     */
    'kapasitet': number;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetPutDto
 */
export interface PraksisaktivitetPutDto {
    /**
     * 
     * @type {boolean}
     * @memberof PraksisaktivitetPutDto
     */
    'bekreftet'?: boolean;
    /**
     * 
     * @type {Array<PraksisaktivitetPutBesvarelseDto>}
     * @memberof PraksisaktivitetPutDto
     */
    'besvarelser'?: Array<PraksisaktivitetPutBesvarelseDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisaktivitetStatusDto = {
    KanBekreftes: 'KanBekreftes',
    BekreftetMenManglerKapasitet: 'BekreftetMenManglerKapasitet',
    BekreftetOgHarKapasitet: 'BekreftetOgHarKapasitet',
    BekreftetOverstyrtKapasitet: 'BekreftetOverstyrtKapasitet',
    BekreftetMenManglerFordeling: 'BekreftetMenManglerFordeling',
    KlarForGjennomfoering: 'KlarForGjennomfoering',
    Gjennomfoert: 'Gjennomfoert',
    Avtalefeil: 'Avtalefeil'
} as const;

export type PraksisaktivitetStatusDto = typeof PraksisaktivitetStatusDto[keyof typeof PraksisaktivitetStatusDto];


/**
 * 
 * @export
 * @interface PraksisaktiviteterDto
 */
export interface PraksisaktiviteterDto {
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterDto
     */
    'gamle'?: Array<PraksisaktivitetInfoDto>;
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterDto
     */
    'aktive'?: Array<PraksisaktivitetInfoDto>;
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterDto
     */
    'fremtidige'?: Array<PraksisaktivitetInfoDto>;
}
/**
 * 
 * @export
 * @interface PraksisaktiviteterInfoDto
 */
export interface PraksisaktiviteterInfoDto {
    /**
     * 
     * @type {Array<PraksisaktivitetInfoDto>}
     * @memberof PraksisaktiviteterInfoDto
     */
    'aktiviteter'?: Array<PraksisaktivitetInfoDto>;
}
/**
 * 
 * @export
 * @interface PraksisavtaleStedDto
 */
export interface PraksisavtaleStedDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'navn': string;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisavtaleStedDto
     */
    'kanEndre'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'avtalenavn': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisavtaleStedDto
     */
    'bestilling': number;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'bestillingId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisavtaleStedDto
     */
    'kapasitet'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleStedDto
     */
    'kapasitetstype'?: PraksisavtaleStedDtoKapasitetstypeDtoEnum;
    /**
     * 
     * @type {PraksisavtalestedStatusDto}
     * @memberof PraksisavtaleStedDto
     */
    'status': PraksisavtalestedStatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleStedDto>}
     * @memberof PraksisavtaleStedDto
     */
    'undernoder': Array<PraksisavtaleStedDto>;
}

export const PraksisavtaleStedDtoKapasitetstypeDtoEnum = {
    Praksissted: 'Praksissted',
    Studiested: 'Studiested'
} as const;

export type PraksisavtaleStedDtoKapasitetstypeDtoEnum = typeof PraksisavtaleStedDtoKapasitetstypeDtoEnum[keyof typeof PraksisavtaleStedDtoKapasitetstypeDtoEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtaleValideringfeiltypeDto = {
    Avtalenavn: 'MANGLER_AVTALENAVN',
    Avtalested: 'MANGLER_AVTALESTED',
    AvtaleVersjon: 'MANGLER_AVTALE_VERSJON',
    AvtalePraksistyper: 'MANGLER_AVTALE_PRAKSISTYPER',
    Avtaleeier: 'MANGLER_AVTALEEIER',
    AvtaleDato: 'MANGLER_AVTALE_DATO',
    AvtaleData: 'MANGLER_AVTALE_DATA'
} as const;

export type PraksisavtaleValideringfeiltypeDto = typeof PraksisavtaleValideringfeiltypeDto[keyof typeof PraksisavtaleValideringfeiltypeDto];


/**
 * 
 * @export
 * @interface PraksisavtaleValideringsfeilDto
 */
export interface PraksisavtaleValideringsfeilDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleValideringsfeilDto
     */
    'message': string;
    /**
     * 
     * @type {PraksisavtaleValideringfeiltypeDto}
     * @memberof PraksisavtaleValideringsfeilDto
     */
    'errorType': PraksisavtaleValideringfeiltypeDto;
}


/**
 * 
 * @export
 * @interface PraksisavtaleVedleggDto
 */
export interface PraksisavtaleVedleggDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggDto
     */
    'navn': string;
    /**
     * 
     * @type {PraksisavtaleVedleggTypeDto}
     * @memberof PraksisavtaleVedleggDto
     */
    'type': PraksisavtaleVedleggTypeDto;
    /**
     * Filstørrelse gitt i antall bytes
     * @type {number}
     * @memberof PraksisavtaleVedleggDto
     */
    'filStorrelse': number;
    /**
     * Signert URI som fungerer som billett for å få laste ned vedlegg. Billett utløper etter 10 minutter, og kan bare brukes en gang. 
     * @type {string}
     * @memberof PraksisavtaleVedleggDto
     */
    'vedlegg': string;
}


/**
 * 
 * @export
 * @interface PraksisavtaleVedleggMinimalDto
 */
export interface PraksisavtaleVedleggMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'navn': string;
    /**
     * 
     * @type {PraksisavtaleVedleggTypeDto}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'type': PraksisavtaleVedleggTypeDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisavtaleVedleggMinimalDto
     */
    'resourceLink': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtaleVedleggTypeDto = {
    Samarbeidsavtale: 'Samarbeidsavtale',
    Databehandleravtale: 'Databehandleravtale',
    Annet: 'Annet'
} as const;

export type PraksisavtaleVedleggTypeDto = typeof PraksisavtaleVedleggTypeDto[keyof typeof PraksisavtaleVedleggTypeDto];


/**
 * 
 * @export
 * @interface PraksisavtalerDto
 */
export interface PraksisavtalerDto {
    /**
     * 
     * @type {Array<PraksisstedavtaleDto>}
     * @memberof PraksisavtalerDto
     */
    'avtaler'?: Array<PraksisstedavtaleDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtalestedStatusDto = {
    Ubekreftet: 'Ubekreftet',
    Bekreftet: 'Bekreftet',
    Avtalefeil: 'Avtalefeil',
    UtenBesvarelse: 'UtenBesvarelse'
} as const;

export type PraksisavtalestedStatusDto = typeof PraksisavtalestedStatusDto[keyof typeof PraksisavtalestedStatusDto];


/**
 * 
 * @export
 * @interface PraksisgruppeDto
 */
export interface PraksisgruppeDto {
    /**
     * 
     * @type {PraksisDto}
     * @memberof PraksisgruppeDto
     */
    'praksis': PraksisDto;
    /**
     * 
     * @type {Array<PraksiskalenderInstitusjonerDto>}
     * @memberof PraksisgruppeDto
     */
    'institusjoner': Array<PraksiskalenderInstitusjonerDto>;
}
/**
 * 
 * @export
 * @interface PraksiskalenderAktivitetDto
 */
export interface PraksiskalenderAktivitetDto {
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'klasseId': string;
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderAktivitetDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {boolean}
     * @memberof PraksiskalenderAktivitetDto
     */
    'bekreftet': boolean;
    /**
     * 
     * @type {number}
     * @memberof PraksiskalenderAktivitetDto
     */
    'behov': number;
    /**
     * 
     * @type {number}
     * @memberof PraksiskalenderAktivitetDto
     */
    'kapasitet': number;
    /**
     * 
     * @type {PraksisaktivitetStatusDto}
     * @memberof PraksiskalenderAktivitetDto
     */
    'status'?: PraksisaktivitetStatusDto;
}


/**
 * 
 * @export
 * @interface PraksiskalenderDto
 */
export interface PraksiskalenderDto {
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderDto
     */
    'praksisstednavn': string;
    /**
     * 
     * @type {Array<PraksisgruppeDto>}
     * @memberof PraksiskalenderDto
     */
    'praksisgrupper': Array<PraksisgruppeDto>;
    /**
     * 
     * @type {Array<PraksiskalenderAktivitetDto>}
     * @memberof PraksiskalenderDto
     */
    'aktiviteter': Array<PraksiskalenderAktivitetDto>;
}
/**
 * 
 * @export
 * @interface PraksiskalenderInstitusjonerDto
 */
export interface PraksiskalenderInstitusjonerDto {
    /**
     * 
     * @type {string}
     * @memberof PraksiskalenderInstitusjonerDto
     */
    'institusjonsnavn': string;
    /**
     * 
     * @type {Array<PraksisklasseDto>}
     * @memberof PraksiskalenderInstitusjonerDto
     */
    'klasser': Array<PraksisklasseDto>;
}
/**
 * 
 * @export
 * @interface PraksisklasseDto
 */
export interface PraksisklasseDto {
    /**
     * 
     * @type {EmneDto}
     * @memberof PraksisklasseDto
     */
    'emne': EmneDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisklasseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisklasseDto
     */
    'bokstav': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisklasseDto
     */
    'presentertNavn'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedInfoPutDto
 */
export interface PraksisstedInfoPutDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'adresselinje1': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'adresselinje2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'postnr': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'poststed': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'telefonlandnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedInfoPutDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisstedRollerDto = {
    Koordinator: 'Koordinator',
    Veileder: 'Veileder'
} as const;

export type PraksisstedRollerDto = typeof PraksisstedRollerDto[keyof typeof PraksisstedRollerDto];


/**
 * 
 * @export
 * @interface PraksisstedTilgangerDto
 */
export interface PraksisstedTilgangerDto {
    /**
     * Om innlogget bruker har lov til å slette tilgangen
     * @type {boolean}
     * @memberof PraksisstedTilgangerDto
     */
    'kanRedigere': boolean;
    /**
     * 
     * @type {MuligPraksisstedDto}
     * @memberof PraksisstedTilgangerDto
     */
    'praksissted': MuligPraksisstedDto;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof PraksisstedTilgangerDto
     */
    'brukerrolle': BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface PraksisstedUndernodeDto
 */
export interface PraksisstedUndernodeDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedUndernodeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedUndernodeDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedUndernodeDto
     */
    'status'?: PraksisstedUndernodeDtoStatusDtoEnum;
    /**
     * 
     * @type {Array<PraksisstedUndernodeDto>}
     * @memberof PraksisstedUndernodeDto
     */
    'under': Array<PraksisstedUndernodeDto>;
}

export const PraksisstedUndernodeDtoStatusDtoEnum = {
    Active: 'active',
    Deleted: 'deleted'
} as const;

export type PraksisstedUndernodeDtoStatusDtoEnum = typeof PraksisstedUndernodeDtoStatusDtoEnum[keyof typeof PraksisstedUndernodeDtoStatusDtoEnum];

/**
 * 
 * @export
 * @interface PraksisstedavtaleAllOfDto
 */
export interface PraksisstedavtaleAllOfDto {
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedDto}
     * @memberof PraksisstedavtaleAllOfDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }}
     * @memberof PraksisstedavtaleAllOfDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; };
}
/**
 * 
 * @export
 * @interface PraksisstedavtaleCommonDto
 */
export interface PraksisstedavtaleCommonDto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof PraksisstedavtaleCommonDto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof PraksisstedavtaleCommonDto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleCommonDto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof PraksisstedavtaleCommonDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof PraksisstedavtaleCommonDto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisstedavtaleCommonDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisstedavtaleCommonDto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof PraksisstedavtaleCommonDto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof PraksisstedavtaleCommonDto
     */
    'kanEndre': boolean;
}


/**
 * 
 * @export
 * @interface PraksisstedavtaleDto
 */
export interface PraksisstedavtaleDto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof PraksisstedavtaleDto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof PraksisstedavtaleDto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleDto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof PraksisstedavtaleDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof PraksisstedavtaleDto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof PraksisstedavtaleDto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisstedavtaleDto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof PraksisstedavtaleDto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof PraksisstedavtaleDto
     */
    'kanEndre': boolean;
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedDto}
     * @memberof PraksisstedavtaleDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }}
     * @memberof PraksisstedavtaleDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; };
}


/**
 * 
 * @export
 * @interface PraksisstedavtaleMedStedForelderHierarkiAllOfDto
 */
export interface PraksisstedavtaleMedStedForelderHierarkiAllOfDto {
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiAllOfDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiAllOfDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; };
}
/**
 * 
 * @export
 * @interface PraksisstedavtaleMedStedForelderHierarkiDto
 */
export interface PraksisstedavtaleMedStedForelderHierarkiDto {
    /**
     * 
     * @type {PraksisstedavtaleViewDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'view': PraksisstedavtaleViewDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {number}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleversjon'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalenavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {MultiSignatarerDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'signatarer'?: MultiSignatarerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'saksansvarlig'?: string;
    /**
     * Antall avtaleparter som er med i avtalen
     * @type {number}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleparter'?: number;
    /**
     * 
     * @type {Array<PraksistypeDto>}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'praksistyper'?: Array<PraksistypeDto>;
    /**
     * 
     * @type {AvtalestatusDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalestatus': AvtalestatusDto;
    /**
     * 
     * @type {Array<PraksisavtaleValideringsfeilDto>}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'valideringsfeil': Array<PraksisavtaleValideringsfeilDto>;
    /**
     * Om avtalen er allerede signert av alle parter
     * @type {boolean}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleErSignertAvAlle'?: boolean;
    /**
     * Om identitetsnummer kan lastes ned av administratorer på avtalestedene
     * @type {boolean}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'delIdentitetsnummer'?: boolean;
    /**
     * 
     * @type {Array<PraksisavtaleVedleggMinimalDto>}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'vedlegg'?: Array<PraksisavtaleVedleggMinimalDto>;
    /**
     * Om brukeren som henter avtalen kan endre på den
     * @type {boolean}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'kanEndre': boolean;
    /**
     * 
     * @type {EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtaleeier': EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto;
    /**
     * Avtalesteder (toppnoder for avtalen) med evt tilhørende omfattet praksissteder
     * @type {{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }}
     * @memberof PraksisstedavtaleMedStedForelderHierarkiDto
     */
    'avtalesteder': { [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; };
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisstedavtaleViewDto = {
    Praksisstedavtale: 'Praksisstedavtale',
    PraksisstedavtaleMedStedForelderHierarki: 'PraksisstedavtaleMedStedForelderHierarki'
} as const;

export type PraksisstedavtaleViewDto = typeof PraksisstedavtaleViewDto[keyof typeof PraksisstedavtaleViewDto];


/**
 * 
 * @export
 * @interface PraksisstedbrukerDto
 */
export interface PraksisstedbrukerDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerDto
     */
    'telefonnummer': string;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof PraksisstedbrukerDto
     */
    'tilgangsrolle': BrukerrollerDto;
    /**
     * 
     * @type {BrukerstatusDto}
     * @memberof PraksisstedbrukerDto
     */
    'status'?: BrukerstatusDto;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisstedbrukerDto
     */
    'kanSlette'?: boolean;
    /**
     * 
     * @type {PraksisstedTilgangerDto}
     * @memberof PraksisstedbrukerDto
     */
    'tilhorighet'?: PraksisstedTilgangerDto;
}


/**
 * 
 * @export
 * @interface PraksisstedbrukerSignatarDto
 */
export interface PraksisstedbrukerSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'praksisstedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'fornavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'etternavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerSignatarDto
     */
    'telefonnummer'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedbrukerprofilDto
 */
export interface PraksisstedbrukerprofilDto {
    /**
     * 
     * @type {PraksisstedbrukerDto}
     * @memberof PraksisstedbrukerprofilDto
     */
    'bruker': PraksisstedbrukerDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilDto
     */
    'omMeg'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilDto
     */
    'bildeUrl'?: string;
    /**
     * Om innlogget bruker har lov til å redigere profilen
     * @type {boolean}
     * @memberof PraksisstedbrukerprofilDto
     */
    'kanRedigere': boolean;
    /**
     * 
     * @type {Array<PraksisstedTilgangerDto>}
     * @memberof PraksisstedbrukerprofilDto
     */
    'tilganger': Array<PraksisstedTilgangerDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedbrukerprofilPutDto
 */
export interface PraksisstedbrukerprofilPutDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'omMeg'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'fornavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'etternavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'telefonnummer'?: string;
    /**
     * 
     * @type {Array<PraksisstedbrukerprofilPutTilgangerInnerDto>}
     * @memberof PraksisstedbrukerprofilPutDto
     */
    'tilganger'?: Array<PraksisstedbrukerprofilPutTilgangerInnerDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedbrukerprofilPutTilgangerInnerDto
 */
export interface PraksisstedbrukerprofilPutTilgangerInnerDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedbrukerprofilPutTilgangerInnerDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {BrukerrollerDto}
     * @memberof PraksisstedbrukerprofilPutTilgangerInnerDto
     */
    'tilgangsrolle': BrukerrollerDto;
}


/**
 * 
 * @export
 * @interface PraksisstedprofilAdresseDto
 */
export interface PraksisstedprofilAdresseDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'adresselinje1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'adresselinje2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'postnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'poststed'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilDto
 */
export interface PraksisstedprofilDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'orgnr'?: string;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisstedprofilDto
     */
    'avdeling'?: MinimalPraksisstedDto;
    /**
     * 
     * @type {PraksisstedprofilAdresseDto}
     * @memberof PraksisstedprofilDto
     */
    'adresse'?: PraksisstedprofilAdresseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'nettsideUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'telefonnummer'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'telefonlandnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'bildeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'krav'?: string;
    /**
     * 
     * @type {PraksisstedprofilNoderDto}
     * @memberof PraksisstedprofilDto
     */
    'noder': PraksisstedprofilNoderDto;
    /**
     * Om innlogget bruker har lov til å redigere profilen
     * @type {boolean}
     * @memberof PraksisstedprofilDto
     */
    'kanRedigere': boolean;
    /**
     * Om innlogget bruker er administrator for denne profilen
     * @type {boolean}
     * @memberof PraksisstedprofilDto
     */
    'erAdmin': boolean;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'sistEndret'?: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof PraksisstedprofilDto
     */
    'sistEndretAvStudiestedbruker'?: PersonDto;
    /**
     * 
     * @type {PersonDto}
     * @memberof PraksisstedprofilDto
     */
    'sistEndretAvPraksisstedbruker'?: PersonDto;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilNoderDto
 */
export interface PraksisstedprofilNoderDto {
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof PraksisstedprofilNoderDto
     */
    'over': Array<MinimalPraksisstedDto>;
    /**
     * 
     * @type {Array<MinimalPraksisstedprofilDto>}
     * @memberof PraksisstedprofilNoderDto
     */
    'under': Array<MinimalPraksisstedprofilDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilPutDto
 */
export interface PraksisstedprofilPutDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilPutDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilPutDto
     */
    'krav'?: string;
}
/**
 * 
 * @export
 * @interface PraksistypeDto
 */
export interface PraksistypeDto {
    /**
     * 
     * @type {string}
     * @memberof PraksistypeDto
     */
    'kode': string;
    /**
     * 
     * @type {string}
     * @memberof PraksistypeDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface RolleDto
 */
export interface RolleDto {
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof RolleDto
     */
    'telefonnummer'?: string;
    /**
     * 
     * @type {RolleTypeDto}
     * @memberof RolleDto
     */
    'type': RolleTypeDto;
    /**
     * Om brukeren er slettet
     * @type {boolean}
     * @memberof RolleDto
     */
    'slettet': boolean;
}
/**
 * 
 * @export
 * @interface RolleTypeDto
 */
export interface RolleTypeDto {
    /**
     * 
     * @type {StudiestedRollerDto}
     * @memberof RolleTypeDto
     */
    'studiestedrolle'?: StudiestedRollerDto;
    /**
     * 
     * @type {PraksisstedRollerDto}
     * @memberof RolleTypeDto
     */
    'praksisstedrolle'?: PraksisstedRollerDto;
}


/**
 * 
 * @export
 * @interface StudentPaaPraksisstedDto
 */
export interface StudentPaaPraksisstedDto {
    /**
     * 
     * @type {StudentbrukerDto}
     * @memberof StudentPaaPraksisstedDto
     */
    'student': StudentbrukerDto;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof StudentPaaPraksisstedDto
     */
    'praksissted': MinimalPraksisstedDto;
    /**
     * 
     * @type {EmneDto}
     * @memberof StudentPaaPraksisstedDto
     */
    'emne': EmneDto;
    /**
     * 
     * @type {string}
     * @memberof StudentPaaPraksisstedDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof StudentPaaPraksisstedDto
     */
    'sluttDato': string;
}
/**
 * 
 * @export
 * @interface StudentVurderingDto
 */
export interface StudentVurderingDto {
    /**
     * 
     * @type {string}
     * @memberof StudentVurderingDto
     */
    'studentVurderingId': string;
    /**
     * 
     * @type {VurderingStudentDto}
     * @memberof StudentVurderingDto
     */
    'student': VurderingStudentDto;
    /**
     * 
     * @type {string}
     * @memberof StudentVurderingDto
     */
    'vurderingsstatus': StudentVurderingDtoVurderingsstatusDtoEnum;
    /**
     * 
     * @type {string}
     * @memberof StudentVurderingDto
     */
    'studiestedNavn': string;
}

export const StudentVurderingDtoVurderingsstatusDtoEnum = {
    Aktiv: 'Aktiv',
    AvbruttPraksis: 'Avbrutt Praksis',
    PraksisFullfrt: 'Praksis Fullført'
} as const;

export type StudentVurderingDtoVurderingsstatusDtoEnum = typeof StudentVurderingDtoVurderingsstatusDtoEnum[keyof typeof StudentVurderingDtoVurderingsstatusDtoEnum];

/**
 * 
 * @export
 * @interface StudentbrukerDto
 */
export interface StudentbrukerDto {
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'studiestednavn'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof StudentbrukerDto
     */
    'telefonnummer': string;
}
/**
 * 
 * @export
 * @interface StudentbrukerprofilDto
 */
export interface StudentbrukerprofilDto {
    /**
     * 
     * @type {StudentbrukerDto}
     * @memberof StudentbrukerprofilDto
     */
    'bruker': StudentbrukerDto;
}
/**
 * 
 * @export
 * @interface StudenterForVurderingDto
 */
export interface StudenterForVurderingDto {
    /**
     * 
     * @type {Array<StudentVurderingDto>}
     * @memberof StudenterForVurderingDto
     */
    'studenter': Array<StudentVurderingDto>;
}
/**
 * 
 * @export
 * @interface StudenterPaaPraksisstedDto
 */
export interface StudenterPaaPraksisstedDto {
    /**
     * 
     * @type {Array<StudentPaaPraksisstedDto>}
     * @memberof StudenterPaaPraksisstedDto
     */
    'gamle'?: Array<StudentPaaPraksisstedDto>;
    /**
     * 
     * @type {Array<StudentPaaPraksisstedDto>}
     * @memberof StudenterPaaPraksisstedDto
     */
    'aktive'?: Array<StudentPaaPraksisstedDto>;
    /**
     * 
     * @type {Array<StudentPaaPraksisstedDto>}
     * @memberof StudenterPaaPraksisstedDto
     */
    'fremtidige'?: Array<StudentPaaPraksisstedDto>;
}
/**
 * 
 * @export
 * @interface StudentfordelingDto
 */
export interface StudentfordelingDto {
    /**
     * 
     * @type {PersonDto}
     * @memberof StudentfordelingDto
     */
    'student': PersonDto;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof StudentfordelingDto
     */
    'undervisere': Array<PersonDto>;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof StudentfordelingDto
     */
    'praksissted': MinimalPraksisstedDto;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof StudentfordelingDto
     */
    'veiledere': Array<PersonDto>;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof StudentfordelingDto
     */
    'muligeVeiledere': Array<PersonDto>;
    /**
     * Om fordelt praksisplass er ugyldig pga. feil i avtale
     * @type {boolean}
     * @memberof StudentfordelingDto
     */
    'avtalefeil': boolean;
}
/**
 * 
 * @export
 * @interface StudentfordelingMedValgDto
 */
export interface StudentfordelingMedValgDto {
    /**
     * 
     * @type {Array<StudentfordelingDto>}
     * @memberof StudentfordelingMedValgDto
     */
    'studentfordeling': Array<StudentfordelingDto>;
}
/**
 * 
 * @export
 * @interface StudentfordelingPutDto
 */
export interface StudentfordelingPutDto {
    /**
     * 
     * @type {string}
     * @memberof StudentfordelingPutDto
     */
    'studentId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudentfordelingPutDto
     */
    'veilederIder': Array<string>;
}
/**
 * 
 * @export
 * @interface StudiestedDto
 */
export interface StudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedDto
     */
    'id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StudiestedDto
     */
    'navn': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StudiestedRollerDto = {
    Koordinator: 'Koordinator',
    Underviser: 'Underviser'
} as const;

export type StudiestedRollerDto = typeof StudiestedRollerDto[keyof typeof StudiestedRollerDto];


/**
 * 
 * @export
 * @interface StudiestedbrukerDto
 */
export interface StudiestedbrukerDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerDto
     */
    'telefonnummer': string;
}
/**
 * 
 * @export
 * @interface StudiestedbrukerSignatarDto
 */
export interface StudiestedbrukerSignatarDto {
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'studiestedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'studiestedbrukerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerSignatarDto
     */
    'telefonnummer': string;
}
/**
 * 
 * @export
 * @interface StudiestedbrukerprofilDto
 */
export interface StudiestedbrukerprofilDto {
    /**
     * 
     * @type {StudiestedbrukerDto}
     * @memberof StudiestedbrukerprofilDto
     */
    'bruker': StudiestedbrukerDto;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilDto
     */
    'omMeg'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilDto
     */
    'bildeUrl'?: string;
    /**
     * Om innlogget bruker har lov til å redigere profilen
     * @type {boolean}
     * @memberof StudiestedbrukerprofilDto
     */
    'kanRedigere'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StudiestedbrukerprofilDto
     */
    'studiestedNavn': string;
}
/**
 * 
 * @export
 * @interface VurderingOppsummeringDto
 */
export interface VurderingOppsummeringDto {
    /**
     * 
     * @type {string}
     * @memberof VurderingOppsummeringDto
     */
    'oppsummering': string;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingOppsummeringDto
     */
    'ikkeBestatt': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingOppsummeringDto
     */
    'samletVurderingDelt': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VurderingOppsummeringDto
     */
    'vurderingBekreftet': boolean;
    /**
     * 
     * @type {number}
     * @memberof VurderingOppsummeringDto
     */
    'timerFravaer'?: number;
}
/**
 * 
 * @export
 * @interface VurderingStudentDto
 */
export interface VurderingStudentDto {
    /**
     * Id pointing to a specific evaluation for a student.
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'fsStudentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'etternavn': string;
    /**
     * 
     * @type {number}
     * @memberof VurderingStudentDto
     */
    'studentnr'?: number;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof VurderingStudentDto
     */
    'telefon'?: string;
}

        /**
        * AktivitetApi - object-oriented interface
        * @export
        * @class AktivitetApiInterface
        * @extends {BaseAPI}
        */
        export interface AktivitetApiInterface {
            /**
            * 
                * @summary Henter alle studenter som er fordelt, med nåværende studentfordeling som text/csv
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AktivitetApi
            */
            praksisaktivitetAktivitetIdFordelingCsvdownloadGet(params: { 
                pathParams: { aktivitetId: string,  },
                queryParams?: { skipHeaderline: 'false' | 'true', includeIdentitetsnummer?: 'false' | 'true',  },
            options?: any
            }): Promise<string>;
            }
        /**
        * AktivitetApi - object-oriented interface
        * @export
        * @class AktivitetApi
        * @extends {BaseAPI}
        */
            export class AktivitetApi extends BaseAPI implements AktivitetApiInterface {
            /**
            * 
                * @summary Henter alle studenter som er fordelt, med nåværende studentfordeling som text/csv
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AktivitetApi
            */
            public async praksisaktivitetAktivitetIdFordelingCsvdownloadGet(params: { 
                pathParams: { aktivitetId: string,  },
                queryParams?: { skipHeaderline: 'false' | 'true', includeIdentitetsnummer?: 'false' | 'true',  },
            options?: any
            }): Promise<string> {
            return await this.GET(
        this.path("/praksisaktivitet/{aktivitetId}/fordeling/csvdownload", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
        }
            export function mockAktivitetApi(operations: {
            praksisaktivitetAktivitetIdFordelingCsvdownloadGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                    queryParams?: { skipHeaderline: 'false' | 'true', includeIdentitetsnummer?: 'false' | 'true',  },
                options?: any
                }) => Promise<string>
            }): AktivitetApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisaktivitetAktivitetIdFordelingCsvdownloadGet: (operations.praksisaktivitetAktivitetIdFordelingCsvdownloadGet || reject("praksisaktivitetAktivitetIdFordelingCsvdownloadGet")),
            };
            }


        /**
        * AvtaleApi - object-oriented interface
        * @export
        * @class AvtaleApiInterface
        * @extends {BaseAPI}
        */
        export interface AvtaleApiInterface {
            /**
            * 
                * @summary Henter alle vedlegg til praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggGet(params: { 
                pathParams: { avtaleId: string,  },
            options?: any
            }): Promise<HalPraksisavtaleVedleggMinimalListDto>;
            /**
            * 
                * @summary Henter gitt avtalevedlegg ved gyldig nedlasting billett
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<File>;
            /**
            * 
                * @summary Henter en avtalevedlegg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            avtalerPraksisAvtaleIdVedleggVedleggIdGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<PraksisavtaleVedleggDto>;
            }
        /**
        * AvtaleApi - object-oriented interface
        * @export
        * @class AvtaleApi
        * @extends {BaseAPI}
        */
            export class AvtaleApi extends BaseAPI implements AvtaleApiInterface {
            /**
            * 
                * @summary Henter alle vedlegg til praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggGet(params: { 
                pathParams: { avtaleId: string,  },
            options?: any
            }): Promise<HalPraksisavtaleVedleggMinimalListDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter gitt avtalevedlegg ved gyldig nedlasting billett
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<File> {
            return await this.GET(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg/{vedleggId}/download", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter en avtalevedlegg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof AvtaleApi
            */
            public async avtalerPraksisAvtaleIdVedleggVedleggIdGet(params: { 
                pathParams: { avtaleId: string, vedleggId: string,  },
            options?: any
            }): Promise<PraksisavtaleVedleggDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{avtaleId}/vedlegg/{vedleggId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockAvtaleApi(operations: {
            avtalerPraksisAvtaleIdVedleggGet?: (params: { 
                    pathParams: { avtaleId: string,  },
                options?: any
                }) => Promise<HalPraksisavtaleVedleggMinimalListDto>
            avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet?: (params: { 
                    pathParams: { avtaleId: string, vedleggId: string,  },
                options?: any
                }) => Promise<File>
            avtalerPraksisAvtaleIdVedleggVedleggIdGet?: (params: { 
                    pathParams: { avtaleId: string, vedleggId: string,  },
                options?: any
                }) => Promise<PraksisavtaleVedleggDto>
            }): AvtaleApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            avtalerPraksisAvtaleIdVedleggGet: (operations.avtalerPraksisAvtaleIdVedleggGet || reject("avtalerPraksisAvtaleIdVedleggGet")),
            avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet: (operations.avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet || reject("avtalerPraksisAvtaleIdVedleggVedleggIdDownloadGet")),
            avtalerPraksisAvtaleIdVedleggVedleggIdGet: (operations.avtalerPraksisAvtaleIdVedleggVedleggIdGet || reject("avtalerPraksisAvtaleIdVedleggVedleggIdGet")),
            };
            }


        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApiInterface
        * @extends {BaseAPI}
        */
        export interface BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om bruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            brukerinfoGet(params?: { 
            options?: any
            }): Promise<BrukerinfoDto>;
            /**
            * 
                * @summary endre innstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            brukerinfoInnstillingerPut(params: { 
                brukerinnstillingerDto: BrukerinnstillingerDto,
            options?: any
            }): Promise<BrukerinfoDto>;
            /**
            * 
                * @summary Henter alle aktiviteter som brukeren kan se med oppstart inntil et halvår før fraDato (m. detaljert info)
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            dashbordPraksisaktiviteterGet(params: { 
                queryParams?: { fraDato: number,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertPsDto>>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter praksisstedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            praksisaktiviteterDetaljertPsIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertPsDto>>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter studiestedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            praksisaktiviteterDetaljertUhIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertUhDto>>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter brukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            praksisaktiviteterIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterDto>;
            }
        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApi
        * @extends {BaseAPI}
        */
            export class BrukerApi extends BaseAPI implements BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om bruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async brukerinfoGet(params?: { 
            options?: any
            }): Promise<BrukerinfoDto> {
            return await this.GET(
        "/brukerinfo",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary endre innstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async brukerinfoInnstillingerPut(params: { 
            brukerinnstillingerDto: BrukerinnstillingerDto,
            options?: any
            }): Promise<BrukerinfoDto> {
            return await this.PUT(
        "/brukerinfo/innstillinger",
        {},
        { body: params.brukerinnstillingerDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle aktiviteter som brukeren kan se med oppstart inntil et halvår før fraDato (m. detaljert info)
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async dashbordPraksisaktiviteterGet(params: { 
                queryParams?: { fraDato: number,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertPsDto>> {
            return await this.GET(
        "/dashbord/praksisaktiviteter",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter praksisstedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async praksisaktiviteterDetaljertPsIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertPsDto>> {
            return await this.GET(
        this.path("/praksisaktiviteter/detaljert/ps/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter studiestedbrukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async praksisaktiviteterDetaljertUhIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<PraksisaktivitetInfoDetaljertUhDto>> {
            return await this.GET(
        this.path("/praksisaktiviteter/detaljert/uh/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter brukeren med gitt id er tilknyttet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async praksisaktiviteterIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterDto> {
            return await this.GET(
        this.path("/praksisaktiviteter/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockBrukerApi(operations: {
            brukerinfoGet?: (params?: { 
                options?: any
                }) => Promise<BrukerinfoDto>
            brukerinfoInnstillingerPut?: (params: { 
                brukerinnstillingerDto: BrukerinnstillingerDto,
                options?: any
                }) => Promise<BrukerinfoDto>
            dashbordPraksisaktiviteterGet?: (params: { 
                    queryParams?: { fraDato: number,  },
                options?: any
                }) => Promise<Array<PraksisaktivitetInfoDetaljertPsDto>>
            praksisaktiviteterDetaljertPsIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<PraksisaktivitetInfoDetaljertPsDto>>
            praksisaktiviteterDetaljertUhIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<PraksisaktivitetInfoDetaljertUhDto>>
            praksisaktiviteterIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisaktiviteterDto>
            }): BrukerApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            brukerinfoGet: (operations.brukerinfoGet || reject("brukerinfoGet")),
            brukerinfoInnstillingerPut: (operations.brukerinfoInnstillingerPut || reject("brukerinfoInnstillingerPut")),
            dashbordPraksisaktiviteterGet: (operations.dashbordPraksisaktiviteterGet || reject("dashbordPraksisaktiviteterGet")),
            praksisaktiviteterDetaljertPsIdGet: (operations.praksisaktiviteterDetaljertPsIdGet || reject("praksisaktiviteterDetaljertPsIdGet")),
            praksisaktiviteterDetaljertUhIdGet: (operations.praksisaktiviteterDetaljertUhIdGet || reject("praksisaktiviteterDetaljertUhIdGet")),
            praksisaktiviteterIdGet: (operations.praksisaktiviteterIdGet || reject("praksisaktiviteterIdGet")),
            };
            }


        /**
        * PraksiskalenderApi - object-oriented interface
        * @export
        * @class PraksiskalenderApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksiskalenderApiInterface {
            /**
            * 
                * @summary Henter alle studenter som er fordelt, med nåværende fordelingsregler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdFordelingGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentfordelingMedValgDto>;
            /**
            * 
                * @summary Endre veiledere for aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdFordelingPut(params: { 
                pathParams: { id: string,  },
                studentfordelingPutDto: Array<StudentfordelingPutDto>,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktivitetDto>;
            /**
            * 
                * @summary Endre praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdPut(params: { 
                pathParams: { id: string,  },
                praksisaktivitetPutDto: PraksisaktivitetPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Sletter praksisstedrolle fra gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdRolleDelete(params: { 
                pathParams: { id: string,  },
                queryParams?: { praksisstedbrukerId: string, type: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter alle roller for en aktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdRolleGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<RolleDto>>;
            /**
            * 
                * @summary Legg til rolle på gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksisaktivitetIdRollePost(params: { 
                pathParams: { id: string,  },
                nyRolleDto: NyRolleDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent csv-fil med alle praksisaktiviteter brukeren har tilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksiskalenderDownloadGet(params: { 
                queryParams?: { fromDate: string, toDate?: string, skipHeader?: boolean,  },
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Alle aktiviteter som brukeren kan se med oppstart etter dato, samt info om klassene disse ligger i
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            praksiskalenderGet(params: { 
                queryParams?: { fromDate: number,  },
            options?: any
            }): Promise<PraksiskalenderDto>;
            }
        /**
        * PraksiskalenderApi - object-oriented interface
        * @export
        * @class PraksiskalenderApi
        * @extends {BaseAPI}
        */
            export class PraksiskalenderApi extends BaseAPI implements PraksiskalenderApiInterface {
            /**
            * 
                * @summary Henter alle studenter som er fordelt, med nåværende fordelingsregler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdFordelingGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentfordelingMedValgDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/fordeling", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre veiledere for aktiviteten
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdFordelingPut(params: { 
                pathParams: { id: string,  },
            studentfordelingPutDto: Array<StudentfordelingPutDto>,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}/fordeling", params.pathParams),
        {},
        { body: params.studentfordelingPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktivitetDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endre praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdPut(params: { 
                pathParams: { id: string,  },
            praksisaktivitetPutDto: PraksisaktivitetPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}", params.pathParams),
        {},
        { body: params.praksisaktivitetPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter praksisstedrolle fra gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdRolleDelete(params: { 
                pathParams: { id: string,  },
                queryParams?: { praksisstedbrukerId: string, type: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{id}/rolle", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle roller for en aktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdRolleGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<Array<RolleDto>> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}/rolle", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legg til rolle på gitt praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksisaktivitetIdRollePost(params: { 
                pathParams: { id: string,  },
            nyRolleDto: NyRolleDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        this.path("/praksisaktivitet/{id}/rolle", params.pathParams),
        {},
        { body: params.nyRolleDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent csv-fil med alle praksisaktiviteter brukeren har tilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksiskalenderDownloadGet(params: { 
                queryParams?: { fromDate: string, toDate?: string, skipHeader?: boolean,  },
            options?: any
            }): Promise<string> {
            return await this.GET(
        "/praksiskalender/download",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Alle aktiviteter som brukeren kan se med oppstart etter dato, samt info om klassene disse ligger i
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksiskalenderApi
            */
            public async praksiskalenderGet(params: { 
                queryParams?: { fromDate: number,  },
            options?: any
            }): Promise<PraksiskalenderDto> {
            return await this.GET(
        "/praksiskalender",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
        }
            export function mockPraksiskalenderApi(operations: {
            praksisaktivitetIdFordelingGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<StudentfordelingMedValgDto>
            praksisaktivitetIdFordelingPut?: (params: { 
                    pathParams: { id: string,  },
                studentfordelingPutDto: Array<StudentfordelingPutDto>,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisaktivitetDto>
            praksisaktivitetIdPut?: (params: { 
                    pathParams: { id: string,  },
                praksisaktivitetPutDto: PraksisaktivitetPutDto,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdRolleDelete?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { praksisstedbrukerId: string, type: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdRolleGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<Array<RolleDto>>
            praksisaktivitetIdRollePost?: (params: { 
                    pathParams: { id: string,  },
                nyRolleDto: NyRolleDto,
                options?: any
                }) => Promise<void>
            praksiskalenderDownloadGet?: (params: { 
                    queryParams?: { fromDate: string, toDate?: string, skipHeader?: boolean,  },
                options?: any
                }) => Promise<string>
            praksiskalenderGet?: (params: { 
                    queryParams?: { fromDate: number,  },
                options?: any
                }) => Promise<PraksiskalenderDto>
            }): PraksiskalenderApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisaktivitetIdFordelingGet: (operations.praksisaktivitetIdFordelingGet || reject("praksisaktivitetIdFordelingGet")),
            praksisaktivitetIdFordelingPut: (operations.praksisaktivitetIdFordelingPut || reject("praksisaktivitetIdFordelingPut")),
            praksisaktivitetIdGet: (operations.praksisaktivitetIdGet || reject("praksisaktivitetIdGet")),
            praksisaktivitetIdPut: (operations.praksisaktivitetIdPut || reject("praksisaktivitetIdPut")),
            praksisaktivitetIdRolleDelete: (operations.praksisaktivitetIdRolleDelete || reject("praksisaktivitetIdRolleDelete")),
            praksisaktivitetIdRolleGet: (operations.praksisaktivitetIdRolleGet || reject("praksisaktivitetIdRolleGet")),
            praksisaktivitetIdRollePost: (operations.praksisaktivitetIdRollePost || reject("praksisaktivitetIdRollePost")),
            praksiskalenderDownloadGet: (operations.praksiskalenderDownloadGet || reject("praksiskalenderDownloadGet")),
            praksiskalenderGet: (operations.praksiskalenderGet || reject("praksiskalenderGet")),
            };
            }


        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksisstedApiInterface {
            /**
            * 
                * @summary Hent praksissteder jeg har administrasjonstilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            administrertePraksistederGet(params?: { 
            options?: any
            }): Promise<Array<MuligPraksisstedDto>>;
            /**
            * 
                * @summary Henter avdelings-hierarkiet for innlogget praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avdelingerGet(params?: { 
            options?: any
            }): Promise<PraksisstedUndernodeDto>;
            /**
            * 
                * @summary Hent praksisavtaler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisGet(params?: { 
            options?: any
            }): Promise<HalPraksisstedavtalerDto>;
            /**
            * 
                * @summary Vis informasjon om praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisIdGet(params: { 
                pathParams: { id: string,  },
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
            options?: any
            }): Promise<HalPraksisstedavtaleDto>;
            /**
            * 
                * @summary Henter alle praksisaktiviteter knyttet til avtale med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            avtalerPraksisIdPraksisaktiviteterGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterInfoDto>;
            /**
            * 
                * @summary Inviter ny PSA bruker til ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            inviterPraksisstedbrukerPost(params: { 
                nyPraksisstedbrukerInvitasjonDto: NyPraksisstedbrukerInvitasjonDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Sletter praksisstedbruker på ditt praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedbrukerIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Alle praksisstedbrukere på ditt praksissted, deres høyeste tilgangsrolle og (valgfritt) deres høyeste tilgangsnivå
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedbrukereGet(params?: { 
            options?: any
            }): Promise<Array<PraksisstedbrukerDto>>;
            /**
            * 
                * @summary Hent en praksisstedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedbrukerprofilDto>;
            /**
            * 
                * @summary Lagre profil for praksisstedbruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedbrukerprofilIdPut(params: { 
                pathParams: { id: string,  },
                praksisstedbrukerprofilPutDto: PraksisstedbrukerprofilPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Slett bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdBildeBildeIdDelete(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdBildeBildeIdGet(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Legg inn bilde til praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdBildePost(params: { 
                pathParams: { id: string,  },
                body: string,
            options?: any
            }): Promise<string>;
            /**
            * 
                * @summary Hent en praksisstedprofil, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto>;
            /**
            * 
                * @summary Oppdater informasjon om praksissted i FS
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdInfoPut(params: { 
                pathParams: { id: string,  },
                praksisstedInfoPutDto: PraksisstedInfoPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Lagre praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdPut(params: { 
                pathParams: { id: string,  },
                praksisstedprofilPutDto: PraksisstedprofilPutDto,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Praksisstedbruker kan slette seg selv
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            slettmegDelete(params?: { 
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Hent alle studenter som skal til praksisstedet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            studenterGet(params?: { 
            options?: any
            }): Promise<StudenterPaaPraksisstedDto>;
            }
        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApi
        * @extends {BaseAPI}
        */
            export class PraksisstedApi extends BaseAPI implements PraksisstedApiInterface {
            /**
            * 
                * @summary Hent praksissteder jeg har administrasjonstilgang til
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async administrertePraksistederGet(params?: { 
            options?: any
            }): Promise<Array<MuligPraksisstedDto>> {
            return await this.GET(
        "/administrertePraksisteder",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter avdelings-hierarkiet for innlogget praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avdelingerGet(params?: { 
            options?: any
            }): Promise<PraksisstedUndernodeDto> {
            return await this.GET(
        "/avdelinger",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent praksisavtaler
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisGet(params?: { 
            options?: any
            }): Promise<HalPraksisstedavtalerDto> {
            return await this.GET(
        "/avtaler/praksis",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Vis informasjon om praksisavtale
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisIdGet(params: { 
                pathParams: { id: string,  },
                queryParams?: { view?: PraksisstedavtaleViewDto,  },
            options?: any
            }): Promise<HalPraksisstedavtaleDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{id}", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksisaktiviteter knyttet til avtale med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async avtalerPraksisIdPraksisaktiviteterGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktiviteterInfoDto> {
            return await this.GET(
        this.path("/avtaler/praksis/{id}/praksisaktiviteter", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Inviter ny PSA bruker til ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async inviterPraksisstedbrukerPost(params: { 
            nyPraksisstedbrukerInvitasjonDto: NyPraksisstedbrukerInvitasjonDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        "/inviterPraksisstedbruker",
        {},
        { body: params.nyPraksisstedbrukerInvitasjonDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Sletter praksisstedbruker på ditt praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedbrukerIdDelete(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisstedbruker/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Alle praksisstedbrukere på ditt praksissted, deres høyeste tilgangsrolle og (valgfritt) deres høyeste tilgangsnivå
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedbrukereGet(params?: { 
            options?: any
            }): Promise<Array<PraksisstedbrukerDto>> {
            return await this.GET(
        "/praksisstedbrukere",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en praksisstedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedbrukerprofilDto> {
            return await this.GET(
        this.path("/praksisstedbrukerprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lagre profil for praksisstedbruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedbrukerprofilIdPut(params: { 
                pathParams: { id: string,  },
            praksisstedbrukerprofilPutDto: PraksisstedbrukerprofilPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisstedbrukerprofil/{id}", params.pathParams),
        {},
        { body: params.praksisstedbrukerprofilPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Slett bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdBildeBildeIdDelete(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisstedprofil/{id}/bilde/{bildeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent bilde på praksissted
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdBildeBildeIdGet(params: { 
                pathParams: { id: string, bildeId: string,  },
            options?: any
            }): Promise<string> {
            return await this.GET(
        this.path("/praksisstedprofil/{id}/bilde/{bildeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legg inn bilde til praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdBildePost(params: { 
                pathParams: { id: string,  },
            body: string,
            options?: any
            }): Promise<string> {
            return await this.POST(
        this.path("/praksisstedprofil/{id}/bilde", params.pathParams),
        {},
        { body: params.body, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en praksisstedprofil, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto> {
            return await this.GET(
        this.path("/praksisstedprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Oppdater informasjon om praksissted i FS
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdInfoPut(params: { 
                pathParams: { id: string,  },
            praksisstedInfoPutDto: PraksisstedInfoPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisstedprofil/{id}/info", params.pathParams),
        {},
        { body: params.praksisstedInfoPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lagre praksisstedprofil
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdPut(params: { 
                pathParams: { id: string,  },
            praksisstedprofilPutDto: PraksisstedprofilPutDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisstedprofil/{id}", params.pathParams),
        {},
        { body: params.praksisstedprofilPutDto, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Praksisstedbruker kan slette seg selv
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async slettmegDelete(params?: { 
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        "/slettmeg",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent alle studenter som skal til praksisstedet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async studenterGet(params?: { 
            options?: any
            }): Promise<StudenterPaaPraksisstedDto> {
            return await this.GET(
        "/studenter",
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockPraksisstedApi(operations: {
            administrertePraksistederGet?: (params?: { 
                options?: any
                }) => Promise<Array<MuligPraksisstedDto>>
            avdelingerGet?: (params?: { 
                options?: any
                }) => Promise<PraksisstedUndernodeDto>
            avtalerPraksisGet?: (params?: { 
                options?: any
                }) => Promise<HalPraksisstedavtalerDto>
            avtalerPraksisIdGet?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { view?: PraksisstedavtaleViewDto,  },
                options?: any
                }) => Promise<HalPraksisstedavtaleDto>
            avtalerPraksisIdPraksisaktiviteterGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisaktiviteterInfoDto>
            inviterPraksisstedbrukerPost?: (params: { 
                nyPraksisstedbrukerInvitasjonDto: NyPraksisstedbrukerInvitasjonDto,
                options?: any
                }) => Promise<void>
            praksisstedbrukerIdDelete?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<void>
            praksisstedbrukereGet?: (params?: { 
                options?: any
                }) => Promise<Array<PraksisstedbrukerDto>>
            praksisstedbrukerprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisstedbrukerprofilDto>
            praksisstedbrukerprofilIdPut?: (params: { 
                    pathParams: { id: string,  },
                praksisstedbrukerprofilPutDto: PraksisstedbrukerprofilPutDto,
                options?: any
                }) => Promise<void>
            praksisstedprofilIdBildeBildeIdDelete?: (params: { 
                    pathParams: { id: string, bildeId: string,  },
                options?: any
                }) => Promise<void>
            praksisstedprofilIdBildeBildeIdGet?: (params: { 
                    pathParams: { id: string, bildeId: string,  },
                options?: any
                }) => Promise<string>
            praksisstedprofilIdBildePost?: (params: { 
                    pathParams: { id: string,  },
                body: string,
                options?: any
                }) => Promise<string>
            praksisstedprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisstedprofilDto>
            praksisstedprofilIdInfoPut?: (params: { 
                    pathParams: { id: string,  },
                praksisstedInfoPutDto: PraksisstedInfoPutDto,
                options?: any
                }) => Promise<void>
            praksisstedprofilIdPut?: (params: { 
                    pathParams: { id: string,  },
                praksisstedprofilPutDto: PraksisstedprofilPutDto,
                options?: any
                }) => Promise<void>
            slettmegDelete?: (params?: { 
                options?: any
                }) => Promise<void>
            studenterGet?: (params?: { 
                options?: any
                }) => Promise<StudenterPaaPraksisstedDto>
            }): PraksisstedApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            administrertePraksistederGet: (operations.administrertePraksistederGet || reject("administrertePraksistederGet")),
            avdelingerGet: (operations.avdelingerGet || reject("avdelingerGet")),
            avtalerPraksisGet: (operations.avtalerPraksisGet || reject("avtalerPraksisGet")),
            avtalerPraksisIdGet: (operations.avtalerPraksisIdGet || reject("avtalerPraksisIdGet")),
            avtalerPraksisIdPraksisaktiviteterGet: (operations.avtalerPraksisIdPraksisaktiviteterGet || reject("avtalerPraksisIdPraksisaktiviteterGet")),
            inviterPraksisstedbrukerPost: (operations.inviterPraksisstedbrukerPost || reject("inviterPraksisstedbrukerPost")),
            praksisstedbrukerIdDelete: (operations.praksisstedbrukerIdDelete || reject("praksisstedbrukerIdDelete")),
            praksisstedbrukereGet: (operations.praksisstedbrukereGet || reject("praksisstedbrukereGet")),
            praksisstedbrukerprofilIdGet: (operations.praksisstedbrukerprofilIdGet || reject("praksisstedbrukerprofilIdGet")),
            praksisstedbrukerprofilIdPut: (operations.praksisstedbrukerprofilIdPut || reject("praksisstedbrukerprofilIdPut")),
            praksisstedprofilIdBildeBildeIdDelete: (operations.praksisstedprofilIdBildeBildeIdDelete || reject("praksisstedprofilIdBildeBildeIdDelete")),
            praksisstedprofilIdBildeBildeIdGet: (operations.praksisstedprofilIdBildeBildeIdGet || reject("praksisstedprofilIdBildeBildeIdGet")),
            praksisstedprofilIdBildePost: (operations.praksisstedprofilIdBildePost || reject("praksisstedprofilIdBildePost")),
            praksisstedprofilIdGet: (operations.praksisstedprofilIdGet || reject("praksisstedprofilIdGet")),
            praksisstedprofilIdInfoPut: (operations.praksisstedprofilIdInfoPut || reject("praksisstedprofilIdInfoPut")),
            praksisstedprofilIdPut: (operations.praksisstedprofilIdPut || reject("praksisstedprofilIdPut")),
            slettmegDelete: (operations.slettmegDelete || reject("slettmegDelete")),
            studenterGet: (operations.studenterGet || reject("studenterGet")),
            };
            }


        /**
        * StudiestedApi - object-oriented interface
        * @export
        * @class StudiestedApiInterface
        * @extends {BaseAPI}
        */
        export interface StudiestedApiInterface {
            /**
            * 
                * @summary Hent en student med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studentbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentbrukerprofilDto>;
            /**
            * 
                * @summary Hent en studiestedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            studiestedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudiestedbrukerprofilDto>;
            }
        /**
        * StudiestedApi - object-oriented interface
        * @export
        * @class StudiestedApi
        * @extends {BaseAPI}
        */
            export class StudiestedApi extends BaseAPI implements StudiestedApiInterface {
            /**
            * 
                * @summary Hent en student med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studentbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudentbrukerprofilDto> {
            return await this.GET(
        this.path("/studentbrukerprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en studiestedbruker med profil, basert på brukerens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof StudiestedApi
            */
            public async studiestedbrukerprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<StudiestedbrukerprofilDto> {
            return await this.GET(
        this.path("/studiestedbrukerprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockStudiestedApi(operations: {
            studentbrukerprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<StudentbrukerprofilDto>
            studiestedbrukerprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<StudiestedbrukerprofilDto>
            }): StudiestedApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            studentbrukerprofilIdGet: (operations.studentbrukerprofilIdGet || reject("studentbrukerprofilIdGet")),
            studiestedbrukerprofilIdGet: (operations.studiestedbrukerprofilIdGet || reject("studiestedbrukerprofilIdGet")),
            };
            }


        /**
        * VurderingApi - object-oriented interface
        * @export
        * @class VurderingApiInterface
        * @extends {BaseAPI}
        */
        export interface VurderingApiInterface {
            /**
            * 
                * @summary Henter liste av praksisaktiviteter hvor brukeren kan delta på vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingApi
            */
            vurderingAktiviteterGet(params?: { 
            options?: any
            }): Promise<MinimalAktiviteterDto>;
            }
        /**
        * VurderingApi - object-oriented interface
        * @export
        * @class VurderingApi
        * @extends {BaseAPI}
        */
            export class VurderingApi extends BaseAPI implements VurderingApiInterface {
            /**
            * 
                * @summary Henter liste av praksisaktiviteter hvor brukeren kan delta på vurdering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingApi
            */
            public async vurderingAktiviteterGet(params?: { 
            options?: any
            }): Promise<MinimalAktiviteterDto> {
            return await this.GET(
        "/vurdering/aktiviteter",
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockVurderingApi(operations: {
            vurderingAktiviteterGet?: (params?: { 
                options?: any
                }) => Promise<MinimalAktiviteterDto>
            }): VurderingApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            vurderingAktiviteterGet: (operations.vurderingAktiviteterGet || reject("vurderingAktiviteterGet")),
            };
            }


        /**
        * VurderingStudentApi - object-oriented interface
        * @export
        * @class VurderingStudentApiInterface
        * @extends {BaseAPI}
        */
        export interface VurderingStudentApiInterface {
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingAktivitetIdMidtveisStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto>;
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingAktivitetIdSluttStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto>;
            /**
            * 
                * @summary Henter vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingVurderingStatusIdOppsummeringGet(params: { 
                pathParams: { vurderingStatusId: string,  },
            options?: any
            }): Promise<VurderingOppsummeringDto>;
            /**
            * 
                * @summary Lagrer vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            vurderingVurderingStatusIdOppsummeringPut(params: { 
                pathParams: { vurderingStatusId: string,  },
                vurderingOppsummeringDto: VurderingOppsummeringDto,
            options?: any
            }): Promise<void>;
            }
        /**
        * VurderingStudentApi - object-oriented interface
        * @export
        * @class VurderingStudentApi
        * @extends {BaseAPI}
        */
            export class VurderingStudentApi extends BaseAPI implements VurderingStudentApiInterface {
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingAktivitetIdMidtveisStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto> {
            return await this.GET(
        this.path("/vurdering/{aktivitetId}/midtveis/studenter", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle studenter som skal vurderes for denne aktiviteten.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingAktivitetIdSluttStudenterGet(params: { 
                pathParams: { aktivitetId: string,  },
            options?: any
            }): Promise<StudenterForVurderingDto> {
            return await this.GET(
        this.path("/vurdering/{aktivitetId}/slutt/studenter", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingVurderingStatusIdOppsummeringGet(params: { 
                pathParams: { vurderingStatusId: string,  },
            options?: any
            }): Promise<VurderingOppsummeringDto> {
            return await this.GET(
        this.path("/vurdering/{vurderingStatusId}/oppsummering", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Lagrer vurderingsoppsummeringen for en student.
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof VurderingStudentApi
            */
            public async vurderingVurderingStatusIdOppsummeringPut(params: { 
                pathParams: { vurderingStatusId: string,  },
            vurderingOppsummeringDto: VurderingOppsummeringDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/vurdering/{vurderingStatusId}/oppsummering", params.pathParams),
        {},
        { body: params.vurderingOppsummeringDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockVurderingStudentApi(operations: {
            vurderingAktivitetIdMidtveisStudenterGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                options?: any
                }) => Promise<StudenterForVurderingDto>
            vurderingAktivitetIdSluttStudenterGet?: (params: { 
                    pathParams: { aktivitetId: string,  },
                options?: any
                }) => Promise<StudenterForVurderingDto>
            vurderingVurderingStatusIdOppsummeringGet?: (params: { 
                    pathParams: { vurderingStatusId: string,  },
                options?: any
                }) => Promise<VurderingOppsummeringDto>
            vurderingVurderingStatusIdOppsummeringPut?: (params: { 
                    pathParams: { vurderingStatusId: string,  },
                vurderingOppsummeringDto: VurderingOppsummeringDto,
                options?: any
                }) => Promise<void>
            }): VurderingStudentApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            vurderingAktivitetIdMidtveisStudenterGet: (operations.vurderingAktivitetIdMidtveisStudenterGet || reject("vurderingAktivitetIdMidtveisStudenterGet")),
            vurderingAktivitetIdSluttStudenterGet: (operations.vurderingAktivitetIdSluttStudenterGet || reject("vurderingAktivitetIdSluttStudenterGet")),
            vurderingVurderingStatusIdOppsummeringGet: (operations.vurderingVurderingStatusIdOppsummeringGet || reject("vurderingVurderingStatusIdOppsummeringGet")),
            vurderingVurderingStatusIdOppsummeringPut: (operations.vurderingVurderingStatusIdOppsummeringPut || reject("vurderingVurderingStatusIdOppsummeringPut")),
            };
            }



export class Random {
    seed: number;
    constructor(seed: number) {
        this.seed = seed % 2147483647;
        if (this.seed <= 0) this.seed += 2147483646;
    }
    next(): number {
        this.seed = this.seed * 16807 % 2147483647;
        return this.seed;
    }
    nextFloat(): number {
        return (this.next() - 1) / 2147483646;
    }
    nextInt(limit: number): number {
        return this.next() % limit;
    }
    pickOne<T>(options: Array<T>): T {
        return options[this.nextInt(options.length)];
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = this.nextInt(16) | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    nextBoolean() {
        return this.nextInt(2) == 0;
    }
}

type Factory<T> = {
    [P in keyof T]?: ((sampleData: TestSampleData) => T[P])|T[P];
};
type EnumFactory<T> = ((sampleData: TestSampleData) => T)|T;
export interface SampleModelFactories {
    AbstractSignatarDto?: Factory<AbstractSignatarDto> | ((testData: TestSampleData) => AbstractSignatarDto);
    AvtalestatusDto?: Factory<AvtalestatusDto> | ((testData: TestSampleData) => AvtalestatusDto);
    AvtalestederMedMuligeOmfattedePraksisstedDto?: Factory<AvtalestederMedMuligeOmfattedePraksisstedDto> | ((testData: TestSampleData) => AvtalestederMedMuligeOmfattedePraksisstedDto);
    AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto?: Factory<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto> | ((testData: TestSampleData) => AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto);
    BrukerinfoDto?: Factory<BrukerinfoDto> | ((testData: TestSampleData) => BrukerinfoDto);
    BrukerinnstillingerDto?: Factory<BrukerinnstillingerDto> | ((testData: TestSampleData) => BrukerinnstillingerDto);
    BrukerrollerDto?: Factory<BrukerrollerDto> | ((testData: TestSampleData) => BrukerrollerDto);
    BrukerstatusDto?: Factory<BrukerstatusDto> | ((testData: TestSampleData) => BrukerstatusDto);
    EierAvtalestedMedMuligeOmfattedeStudiestedDto?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedDto> | ((testData: TestSampleData) => EierAvtalestedMedMuligeOmfattedeStudiestedDto);
    EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto> | ((testData: TestSampleData) => EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto);
    EksternSignatarDto?: Factory<EksternSignatarDto> | ((testData: TestSampleData) => EksternSignatarDto);
    EmneDto?: Factory<EmneDto> | ((testData: TestSampleData) => EmneDto);
    HalPraksisavtaleVedleggMinimalListDto?: Factory<HalPraksisavtaleVedleggMinimalListDto> | ((testData: TestSampleData) => HalPraksisavtaleVedleggMinimalListDto);
    HalPraksisstedavtaleDto?: Factory<HalPraksisstedavtaleDto> | ((testData: TestSampleData) => HalPraksisstedavtaleDto);
    HalPraksisstedavtalerDto?: Factory<HalPraksisstedavtalerDto> | ((testData: TestSampleData) => HalPraksisstedavtalerDto);
    MinimalAktivitetInfoDto?: Factory<MinimalAktivitetInfoDto> | ((testData: TestSampleData) => MinimalAktivitetInfoDto);
    MinimalAktiviteterDto?: Factory<MinimalAktiviteterDto> | ((testData: TestSampleData) => MinimalAktiviteterDto);
    MinimalPraksisstedDto?: Factory<MinimalPraksisstedDto> | ((testData: TestSampleData) => MinimalPraksisstedDto);
    MinimalPraksisstedMedHierarkiDto?: Factory<MinimalPraksisstedMedHierarkiDto> | ((testData: TestSampleData) => MinimalPraksisstedMedHierarkiDto);
    MinimalPraksisstedMedHierarkiNoderDto?: Factory<MinimalPraksisstedMedHierarkiNoderDto> | ((testData: TestSampleData) => MinimalPraksisstedMedHierarkiNoderDto);
    MinimalPraksisstedprofilDto?: Factory<MinimalPraksisstedprofilDto> | ((testData: TestSampleData) => MinimalPraksisstedprofilDto);
    MinimalStudiestedDto?: Factory<MinimalStudiestedDto> | ((testData: TestSampleData) => MinimalStudiestedDto);
    MinimalStudiestedHierarkiDto?: Factory<MinimalStudiestedHierarkiDto> | ((testData: TestSampleData) => MinimalStudiestedHierarkiDto);
    MinimalStudiestedHierarkiNoderDto?: Factory<MinimalStudiestedHierarkiNoderDto> | ((testData: TestSampleData) => MinimalStudiestedHierarkiNoderDto);
    MuligPraksisstedDto?: Factory<MuligPraksisstedDto> | ((testData: TestSampleData) => MuligPraksisstedDto);
    MultiSignatarerDto?: Factory<MultiSignatarerDto> | ((testData: TestSampleData) => MultiSignatarerDto);
    NyPraksisstedbrukerInvitasjonDto?: Factory<NyPraksisstedbrukerInvitasjonDto> | ((testData: TestSampleData) => NyPraksisstedbrukerInvitasjonDto);
    NyRolleDto?: Factory<NyRolleDto> | ((testData: TestSampleData) => NyRolleDto);
    PersonDto?: Factory<PersonDto> | ((testData: TestSampleData) => PersonDto);
    PraksisDto?: Factory<PraksisDto> | ((testData: TestSampleData) => PraksisDto);
    PraksisaktivitetDto?: Factory<PraksisaktivitetDto> | ((testData: TestSampleData) => PraksisaktivitetDto);
    PraksisaktivitetInfoDetaljertPsDto?: Factory<PraksisaktivitetInfoDetaljertPsDto> | ((testData: TestSampleData) => PraksisaktivitetInfoDetaljertPsDto);
    PraksisaktivitetInfoDetaljertUhDto?: Factory<PraksisaktivitetInfoDetaljertUhDto> | ((testData: TestSampleData) => PraksisaktivitetInfoDetaljertUhDto);
    PraksisaktivitetInfoDto?: Factory<PraksisaktivitetInfoDto> | ((testData: TestSampleData) => PraksisaktivitetInfoDto);
    PraksisaktivitetPutBesvarelseDto?: Factory<PraksisaktivitetPutBesvarelseDto> | ((testData: TestSampleData) => PraksisaktivitetPutBesvarelseDto);
    PraksisaktivitetPutDto?: Factory<PraksisaktivitetPutDto> | ((testData: TestSampleData) => PraksisaktivitetPutDto);
    PraksisaktivitetStatusDto?: Factory<PraksisaktivitetStatusDto> | ((testData: TestSampleData) => PraksisaktivitetStatusDto);
    PraksisaktiviteterDto?: Factory<PraksisaktiviteterDto> | ((testData: TestSampleData) => PraksisaktiviteterDto);
    PraksisaktiviteterInfoDto?: Factory<PraksisaktiviteterInfoDto> | ((testData: TestSampleData) => PraksisaktiviteterInfoDto);
    PraksisavtaleStedDto?: Factory<PraksisavtaleStedDto> | ((testData: TestSampleData) => PraksisavtaleStedDto);
    PraksisavtaleValideringfeiltypeDto?: Factory<PraksisavtaleValideringfeiltypeDto> | ((testData: TestSampleData) => PraksisavtaleValideringfeiltypeDto);
    PraksisavtaleValideringsfeilDto?: Factory<PraksisavtaleValideringsfeilDto> | ((testData: TestSampleData) => PraksisavtaleValideringsfeilDto);
    PraksisavtaleVedleggDto?: Factory<PraksisavtaleVedleggDto> | ((testData: TestSampleData) => PraksisavtaleVedleggDto);
    PraksisavtaleVedleggMinimalDto?: Factory<PraksisavtaleVedleggMinimalDto> | ((testData: TestSampleData) => PraksisavtaleVedleggMinimalDto);
    PraksisavtaleVedleggTypeDto?: Factory<PraksisavtaleVedleggTypeDto> | ((testData: TestSampleData) => PraksisavtaleVedleggTypeDto);
    PraksisavtalerDto?: Factory<PraksisavtalerDto> | ((testData: TestSampleData) => PraksisavtalerDto);
    PraksisavtalestedStatusDto?: Factory<PraksisavtalestedStatusDto> | ((testData: TestSampleData) => PraksisavtalestedStatusDto);
    PraksisgruppeDto?: Factory<PraksisgruppeDto> | ((testData: TestSampleData) => PraksisgruppeDto);
    PraksiskalenderAktivitetDto?: Factory<PraksiskalenderAktivitetDto> | ((testData: TestSampleData) => PraksiskalenderAktivitetDto);
    PraksiskalenderDto?: Factory<PraksiskalenderDto> | ((testData: TestSampleData) => PraksiskalenderDto);
    PraksiskalenderInstitusjonerDto?: Factory<PraksiskalenderInstitusjonerDto> | ((testData: TestSampleData) => PraksiskalenderInstitusjonerDto);
    PraksisklasseDto?: Factory<PraksisklasseDto> | ((testData: TestSampleData) => PraksisklasseDto);
    PraksisstedInfoPutDto?: Factory<PraksisstedInfoPutDto> | ((testData: TestSampleData) => PraksisstedInfoPutDto);
    PraksisstedRollerDto?: Factory<PraksisstedRollerDto> | ((testData: TestSampleData) => PraksisstedRollerDto);
    PraksisstedTilgangerDto?: Factory<PraksisstedTilgangerDto> | ((testData: TestSampleData) => PraksisstedTilgangerDto);
    PraksisstedUndernodeDto?: Factory<PraksisstedUndernodeDto> | ((testData: TestSampleData) => PraksisstedUndernodeDto);
    PraksisstedavtaleAllOfDto?: Factory<PraksisstedavtaleAllOfDto> | ((testData: TestSampleData) => PraksisstedavtaleAllOfDto);
    PraksisstedavtaleCommonDto?: Factory<PraksisstedavtaleCommonDto> | ((testData: TestSampleData) => PraksisstedavtaleCommonDto);
    PraksisstedavtaleDto?: Factory<PraksisstedavtaleDto> | ((testData: TestSampleData) => PraksisstedavtaleDto);
    PraksisstedavtaleMedStedForelderHierarkiAllOfDto?: Factory<PraksisstedavtaleMedStedForelderHierarkiAllOfDto> | ((testData: TestSampleData) => PraksisstedavtaleMedStedForelderHierarkiAllOfDto);
    PraksisstedavtaleMedStedForelderHierarkiDto?: Factory<PraksisstedavtaleMedStedForelderHierarkiDto> | ((testData: TestSampleData) => PraksisstedavtaleMedStedForelderHierarkiDto);
    PraksisstedavtaleViewDto?: Factory<PraksisstedavtaleViewDto> | ((testData: TestSampleData) => PraksisstedavtaleViewDto);
    PraksisstedbrukerDto?: Factory<PraksisstedbrukerDto> | ((testData: TestSampleData) => PraksisstedbrukerDto);
    PraksisstedbrukerSignatarDto?: Factory<PraksisstedbrukerSignatarDto> | ((testData: TestSampleData) => PraksisstedbrukerSignatarDto);
    PraksisstedbrukerprofilDto?: Factory<PraksisstedbrukerprofilDto> | ((testData: TestSampleData) => PraksisstedbrukerprofilDto);
    PraksisstedbrukerprofilPutDto?: Factory<PraksisstedbrukerprofilPutDto> | ((testData: TestSampleData) => PraksisstedbrukerprofilPutDto);
    PraksisstedbrukerprofilPutTilgangerInnerDto?: Factory<PraksisstedbrukerprofilPutTilgangerInnerDto> | ((testData: TestSampleData) => PraksisstedbrukerprofilPutTilgangerInnerDto);
    PraksisstedprofilAdresseDto?: Factory<PraksisstedprofilAdresseDto> | ((testData: TestSampleData) => PraksisstedprofilAdresseDto);
    PraksisstedprofilDto?: Factory<PraksisstedprofilDto> | ((testData: TestSampleData) => PraksisstedprofilDto);
    PraksisstedprofilNoderDto?: Factory<PraksisstedprofilNoderDto> | ((testData: TestSampleData) => PraksisstedprofilNoderDto);
    PraksisstedprofilPutDto?: Factory<PraksisstedprofilPutDto> | ((testData: TestSampleData) => PraksisstedprofilPutDto);
    PraksistypeDto?: Factory<PraksistypeDto> | ((testData: TestSampleData) => PraksistypeDto);
    RolleDto?: Factory<RolleDto> | ((testData: TestSampleData) => RolleDto);
    RolleTypeDto?: Factory<RolleTypeDto> | ((testData: TestSampleData) => RolleTypeDto);
    StudentPaaPraksisstedDto?: Factory<StudentPaaPraksisstedDto> | ((testData: TestSampleData) => StudentPaaPraksisstedDto);
    StudentVurderingDto?: Factory<StudentVurderingDto> | ((testData: TestSampleData) => StudentVurderingDto);
    StudentbrukerDto?: Factory<StudentbrukerDto> | ((testData: TestSampleData) => StudentbrukerDto);
    StudentbrukerprofilDto?: Factory<StudentbrukerprofilDto> | ((testData: TestSampleData) => StudentbrukerprofilDto);
    StudenterForVurderingDto?: Factory<StudenterForVurderingDto> | ((testData: TestSampleData) => StudenterForVurderingDto);
    StudenterPaaPraksisstedDto?: Factory<StudenterPaaPraksisstedDto> | ((testData: TestSampleData) => StudenterPaaPraksisstedDto);
    StudentfordelingDto?: Factory<StudentfordelingDto> | ((testData: TestSampleData) => StudentfordelingDto);
    StudentfordelingMedValgDto?: Factory<StudentfordelingMedValgDto> | ((testData: TestSampleData) => StudentfordelingMedValgDto);
    StudentfordelingPutDto?: Factory<StudentfordelingPutDto> | ((testData: TestSampleData) => StudentfordelingPutDto);
    StudiestedDto?: Factory<StudiestedDto> | ((testData: TestSampleData) => StudiestedDto);
    StudiestedRollerDto?: Factory<StudiestedRollerDto> | ((testData: TestSampleData) => StudiestedRollerDto);
    StudiestedbrukerDto?: Factory<StudiestedbrukerDto> | ((testData: TestSampleData) => StudiestedbrukerDto);
    StudiestedbrukerSignatarDto?: Factory<StudiestedbrukerSignatarDto> | ((testData: TestSampleData) => StudiestedbrukerSignatarDto);
    StudiestedbrukerprofilDto?: Factory<StudiestedbrukerprofilDto> | ((testData: TestSampleData) => StudiestedbrukerprofilDto);
    VurderingOppsummeringDto?: Factory<VurderingOppsummeringDto> | ((testData: TestSampleData) => VurderingOppsummeringDto);
    VurderingStudentDto?: Factory<VurderingStudentDto> | ((testData: TestSampleData) => VurderingStudentDto);
}
export interface SamplePropertyValues {
    [key: string]: (sampleData: TestSampleData) => any;
}

export interface RandomGenerator {
    nextFloat: () => number;
    nextInt: (limit: number) => number;
    nextBoolean: () => boolean;
    pickOne: <T>(options: Array<T>) => T;
    uuidv4: ()  => string;
    randomEmail: () => string;
    randomPastDateTime: (now: Date) => Date;
    generate: (modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean) => any;
}

export interface TestData {
    seed?: number;
    sampleModelProperties?: SampleModelFactories;
    samplePropertyValues?: SamplePropertyValues;
}
export class TestSampleData implements RandomGenerator {
    random: Random;
    sampleModelProperties: any;
    samplePropertyValues: SamplePropertyValues;
    constructor(testData: TestData) {
        this.random = new Random(testData.seed || 100);
        this.sampleModelProperties = testData.sampleModelProperties || {};
        this.samplePropertyValues = testData.samplePropertyValues || {};
    }
    nextFloat() { return this.random.nextFloat(); }
    nextInt(limit: number) { return this.random.nextInt(limit); }
    nextBoolean() { return this.random.nextBoolean(); }
    pickOne<T>(options: Array<T>) { return this.random.pickOne(options); }
    uuidv4() { return this.random.uuidv4(); }
    randomEmail() {
        return this.pickOne(["james", "mary", "john", "patricia", "robert", "jennifer", "michael", "linda"]) +
            "." + this.pickOne(["smith", "williams", "johnson", "jones", "brown", "davis", "miller", "wilson"]) +
            "@" + this.pickOne(["a", "b", "c", "d", "e"]) + ".example." + this.pickOne(["net", "com", "org"]);
    }
    randomPastDateTime(now: Date) {
        return new Date((now.getTime() - this.nextInt(4*7*24*60*60*1000)));
    }
    generate(modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean): any {
        if (this.sampleModelProperties[modelClass]) {
            const propertyFactory: Factory<any> = this.sampleModelProperties[modelClass][modelVar];
            if (propertyFactory && typeof propertyFactory === "function") {
                return propertyFactory(this);
            } else if (propertyFactory) {
                return propertyFactory;
            }
        }
        if (this.samplePropertyValues[modelVar]) {
            return this.samplePropertyValues[modelVar](this);
        }
        if (example && example !== "null") return example;
        if (dataType === "Array<string>") {
            return Array.from({length: this.arrayLength("Array<string>")}).map((i) => "foo " + i);
        }
        if (dataType.startsWith("Array<")) {
            return this.sample(dataType);
        }
        if (modelVar.endsWith("Id") || modelVar === "id") {
            return this.uuidv4();
        }
        if (dataType === "boolean") {
            return this.nextBoolean();
        }
        if (dataType === "number") {
            return this.nextInt(100);
        }
        const key = `sample${dataType}` as keyof TestSampleData;
        if( typeof this[key] === "function"){
            return this[key]();
        }
        return "foo";
    }
    arrayLength(modelClass: string) {
        return this.nextInt(3) + 1;
    }
    sample(modelName: string): any {
        switch(modelName) {
            case "AbstractSignatarDto": return this.sampleAbstractSignatarDto({});
            case "Array<AbstractSignatarDto>": return this.sampleArrayAbstractSignatarDto({});
            case "AvtalestatusDto": return this.sampleAvtalestatusDto();
            case "Array<AvtalestatusDto>": return this.sampleArrayAvtalestatusDto();
            case "AvtalestederMedMuligeOmfattedePraksisstedDto": return this.sampleAvtalestederMedMuligeOmfattedePraksisstedDto({});
            case "Array<AvtalestederMedMuligeOmfattedePraksisstedDto>": return this.sampleArrayAvtalestederMedMuligeOmfattedePraksisstedDto({});
            case "AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto": return this.sampleAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto({});
            case "Array<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto>": return this.sampleArrayAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto({});
            case "BrukerinfoDto": return this.sampleBrukerinfoDto({});
            case "Array<BrukerinfoDto>": return this.sampleArrayBrukerinfoDto({});
            case "BrukerinnstillingerDto": return this.sampleBrukerinnstillingerDto({});
            case "Array<BrukerinnstillingerDto>": return this.sampleArrayBrukerinnstillingerDto({});
            case "BrukerrollerDto": return this.sampleBrukerrollerDto();
            case "Array<BrukerrollerDto>": return this.sampleArrayBrukerrollerDto();
            case "BrukerstatusDto": return this.sampleBrukerstatusDto();
            case "Array<BrukerstatusDto>": return this.sampleArrayBrukerstatusDto();
            case "EierAvtalestedMedMuligeOmfattedeStudiestedDto": return this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedDto({});
            case "Array<EierAvtalestedMedMuligeOmfattedeStudiestedDto>": return this.sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedDto({});
            case "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto": return this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto({});
            case "Array<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto>": return this.sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto({});
            case "EksternSignatarDto": return this.sampleEksternSignatarDto({});
            case "Array<EksternSignatarDto>": return this.sampleArrayEksternSignatarDto({});
            case "EmneDto": return this.sampleEmneDto({});
            case "Array<EmneDto>": return this.sampleArrayEmneDto({});
            case "HalPraksisavtaleVedleggMinimalListDto": return this.sampleHalPraksisavtaleVedleggMinimalListDto({});
            case "Array<HalPraksisavtaleVedleggMinimalListDto>": return this.sampleArrayHalPraksisavtaleVedleggMinimalListDto({});
            case "HalPraksisstedavtaleDto": return this.sampleHalPraksisstedavtaleDto({});
            case "Array<HalPraksisstedavtaleDto>": return this.sampleArrayHalPraksisstedavtaleDto({});
            case "HalPraksisstedavtalerDto": return this.sampleHalPraksisstedavtalerDto({});
            case "Array<HalPraksisstedavtalerDto>": return this.sampleArrayHalPraksisstedavtalerDto({});
            case "MinimalAktivitetInfoDto": return this.sampleMinimalAktivitetInfoDto({});
            case "Array<MinimalAktivitetInfoDto>": return this.sampleArrayMinimalAktivitetInfoDto({});
            case "MinimalAktiviteterDto": return this.sampleMinimalAktiviteterDto({});
            case "Array<MinimalAktiviteterDto>": return this.sampleArrayMinimalAktiviteterDto({});
            case "MinimalPraksisstedDto": return this.sampleMinimalPraksisstedDto({});
            case "Array<MinimalPraksisstedDto>": return this.sampleArrayMinimalPraksisstedDto({});
            case "MinimalPraksisstedMedHierarkiDto": return this.sampleMinimalPraksisstedMedHierarkiDto({});
            case "Array<MinimalPraksisstedMedHierarkiDto>": return this.sampleArrayMinimalPraksisstedMedHierarkiDto({});
            case "MinimalPraksisstedMedHierarkiNoderDto": return this.sampleMinimalPraksisstedMedHierarkiNoderDto({});
            case "Array<MinimalPraksisstedMedHierarkiNoderDto>": return this.sampleArrayMinimalPraksisstedMedHierarkiNoderDto({});
            case "MinimalPraksisstedprofilDto": return this.sampleMinimalPraksisstedprofilDto({});
            case "Array<MinimalPraksisstedprofilDto>": return this.sampleArrayMinimalPraksisstedprofilDto({});
            case "MinimalStudiestedDto": return this.sampleMinimalStudiestedDto({});
            case "Array<MinimalStudiestedDto>": return this.sampleArrayMinimalStudiestedDto({});
            case "MinimalStudiestedHierarkiDto": return this.sampleMinimalStudiestedHierarkiDto({});
            case "Array<MinimalStudiestedHierarkiDto>": return this.sampleArrayMinimalStudiestedHierarkiDto({});
            case "MinimalStudiestedHierarkiNoderDto": return this.sampleMinimalStudiestedHierarkiNoderDto({});
            case "Array<MinimalStudiestedHierarkiNoderDto>": return this.sampleArrayMinimalStudiestedHierarkiNoderDto({});
            case "MuligPraksisstedDto": return this.sampleMuligPraksisstedDto({});
            case "Array<MuligPraksisstedDto>": return this.sampleArrayMuligPraksisstedDto({});
            case "MultiSignatarerDto": return this.sampleMultiSignatarerDto({});
            case "Array<MultiSignatarerDto>": return this.sampleArrayMultiSignatarerDto({});
            case "NyPraksisstedbrukerInvitasjonDto": return this.sampleNyPraksisstedbrukerInvitasjonDto({});
            case "Array<NyPraksisstedbrukerInvitasjonDto>": return this.sampleArrayNyPraksisstedbrukerInvitasjonDto({});
            case "NyRolleDto": return this.sampleNyRolleDto({});
            case "Array<NyRolleDto>": return this.sampleArrayNyRolleDto({});
            case "PersonDto": return this.samplePersonDto({});
            case "Array<PersonDto>": return this.sampleArrayPersonDto({});
            case "PraksisDto": return this.samplePraksisDto({});
            case "Array<PraksisDto>": return this.sampleArrayPraksisDto({});
            case "PraksisaktivitetDto": return this.samplePraksisaktivitetDto({});
            case "Array<PraksisaktivitetDto>": return this.sampleArrayPraksisaktivitetDto({});
            case "PraksisaktivitetInfoDetaljertPsDto": return this.samplePraksisaktivitetInfoDetaljertPsDto({});
            case "Array<PraksisaktivitetInfoDetaljertPsDto>": return this.sampleArrayPraksisaktivitetInfoDetaljertPsDto({});
            case "PraksisaktivitetInfoDetaljertUhDto": return this.samplePraksisaktivitetInfoDetaljertUhDto({});
            case "Array<PraksisaktivitetInfoDetaljertUhDto>": return this.sampleArrayPraksisaktivitetInfoDetaljertUhDto({});
            case "PraksisaktivitetInfoDto": return this.samplePraksisaktivitetInfoDto({});
            case "Array<PraksisaktivitetInfoDto>": return this.sampleArrayPraksisaktivitetInfoDto({});
            case "PraksisaktivitetPutBesvarelseDto": return this.samplePraksisaktivitetPutBesvarelseDto({});
            case "Array<PraksisaktivitetPutBesvarelseDto>": return this.sampleArrayPraksisaktivitetPutBesvarelseDto({});
            case "PraksisaktivitetPutDto": return this.samplePraksisaktivitetPutDto({});
            case "Array<PraksisaktivitetPutDto>": return this.sampleArrayPraksisaktivitetPutDto({});
            case "PraksisaktivitetStatusDto": return this.samplePraksisaktivitetStatusDto();
            case "Array<PraksisaktivitetStatusDto>": return this.sampleArrayPraksisaktivitetStatusDto();
            case "PraksisaktiviteterDto": return this.samplePraksisaktiviteterDto({});
            case "Array<PraksisaktiviteterDto>": return this.sampleArrayPraksisaktiviteterDto({});
            case "PraksisaktiviteterInfoDto": return this.samplePraksisaktiviteterInfoDto({});
            case "Array<PraksisaktiviteterInfoDto>": return this.sampleArrayPraksisaktiviteterInfoDto({});
            case "PraksisavtaleStedDto": return this.samplePraksisavtaleStedDto({});
            case "Array<PraksisavtaleStedDto>": return this.sampleArrayPraksisavtaleStedDto({});
            case "PraksisavtaleValideringfeiltypeDto": return this.samplePraksisavtaleValideringfeiltypeDto();
            case "Array<PraksisavtaleValideringfeiltypeDto>": return this.sampleArrayPraksisavtaleValideringfeiltypeDto();
            case "PraksisavtaleValideringsfeilDto": return this.samplePraksisavtaleValideringsfeilDto({});
            case "Array<PraksisavtaleValideringsfeilDto>": return this.sampleArrayPraksisavtaleValideringsfeilDto({});
            case "PraksisavtaleVedleggDto": return this.samplePraksisavtaleVedleggDto({});
            case "Array<PraksisavtaleVedleggDto>": return this.sampleArrayPraksisavtaleVedleggDto({});
            case "PraksisavtaleVedleggMinimalDto": return this.samplePraksisavtaleVedleggMinimalDto({});
            case "Array<PraksisavtaleVedleggMinimalDto>": return this.sampleArrayPraksisavtaleVedleggMinimalDto({});
            case "PraksisavtaleVedleggTypeDto": return this.samplePraksisavtaleVedleggTypeDto();
            case "Array<PraksisavtaleVedleggTypeDto>": return this.sampleArrayPraksisavtaleVedleggTypeDto();
            case "PraksisavtalerDto": return this.samplePraksisavtalerDto({});
            case "Array<PraksisavtalerDto>": return this.sampleArrayPraksisavtalerDto({});
            case "PraksisavtalestedStatusDto": return this.samplePraksisavtalestedStatusDto();
            case "Array<PraksisavtalestedStatusDto>": return this.sampleArrayPraksisavtalestedStatusDto();
            case "PraksisgruppeDto": return this.samplePraksisgruppeDto({});
            case "Array<PraksisgruppeDto>": return this.sampleArrayPraksisgruppeDto({});
            case "PraksiskalenderAktivitetDto": return this.samplePraksiskalenderAktivitetDto({});
            case "Array<PraksiskalenderAktivitetDto>": return this.sampleArrayPraksiskalenderAktivitetDto({});
            case "PraksiskalenderDto": return this.samplePraksiskalenderDto({});
            case "Array<PraksiskalenderDto>": return this.sampleArrayPraksiskalenderDto({});
            case "PraksiskalenderInstitusjonerDto": return this.samplePraksiskalenderInstitusjonerDto({});
            case "Array<PraksiskalenderInstitusjonerDto>": return this.sampleArrayPraksiskalenderInstitusjonerDto({});
            case "PraksisklasseDto": return this.samplePraksisklasseDto({});
            case "Array<PraksisklasseDto>": return this.sampleArrayPraksisklasseDto({});
            case "PraksisstedInfoPutDto": return this.samplePraksisstedInfoPutDto({});
            case "Array<PraksisstedInfoPutDto>": return this.sampleArrayPraksisstedInfoPutDto({});
            case "PraksisstedRollerDto": return this.samplePraksisstedRollerDto();
            case "Array<PraksisstedRollerDto>": return this.sampleArrayPraksisstedRollerDto();
            case "PraksisstedTilgangerDto": return this.samplePraksisstedTilgangerDto({});
            case "Array<PraksisstedTilgangerDto>": return this.sampleArrayPraksisstedTilgangerDto({});
            case "PraksisstedUndernodeDto": return this.samplePraksisstedUndernodeDto({});
            case "Array<PraksisstedUndernodeDto>": return this.sampleArrayPraksisstedUndernodeDto({});
            case "PraksisstedavtaleAllOfDto": return this.samplePraksisstedavtaleAllOfDto({});
            case "Array<PraksisstedavtaleAllOfDto>": return this.sampleArrayPraksisstedavtaleAllOfDto({});
            case "PraksisstedavtaleCommonDto": return this.samplePraksisstedavtaleCommonDto({});
            case "Array<PraksisstedavtaleCommonDto>": return this.sampleArrayPraksisstedavtaleCommonDto({});
            case "PraksisstedavtaleDto": return this.samplePraksisstedavtaleDto({});
            case "Array<PraksisstedavtaleDto>": return this.sampleArrayPraksisstedavtaleDto({});
            case "PraksisstedavtaleMedStedForelderHierarkiAllOfDto": return this.samplePraksisstedavtaleMedStedForelderHierarkiAllOfDto({});
            case "Array<PraksisstedavtaleMedStedForelderHierarkiAllOfDto>": return this.sampleArrayPraksisstedavtaleMedStedForelderHierarkiAllOfDto({});
            case "PraksisstedavtaleMedStedForelderHierarkiDto": return this.samplePraksisstedavtaleMedStedForelderHierarkiDto({});
            case "Array<PraksisstedavtaleMedStedForelderHierarkiDto>": return this.sampleArrayPraksisstedavtaleMedStedForelderHierarkiDto({});
            case "PraksisstedavtaleViewDto": return this.samplePraksisstedavtaleViewDto();
            case "Array<PraksisstedavtaleViewDto>": return this.sampleArrayPraksisstedavtaleViewDto();
            case "PraksisstedbrukerDto": return this.samplePraksisstedbrukerDto({});
            case "Array<PraksisstedbrukerDto>": return this.sampleArrayPraksisstedbrukerDto({});
            case "PraksisstedbrukerSignatarDto": return this.samplePraksisstedbrukerSignatarDto({});
            case "Array<PraksisstedbrukerSignatarDto>": return this.sampleArrayPraksisstedbrukerSignatarDto({});
            case "PraksisstedbrukerprofilDto": return this.samplePraksisstedbrukerprofilDto({});
            case "Array<PraksisstedbrukerprofilDto>": return this.sampleArrayPraksisstedbrukerprofilDto({});
            case "PraksisstedbrukerprofilPutDto": return this.samplePraksisstedbrukerprofilPutDto({});
            case "Array<PraksisstedbrukerprofilPutDto>": return this.sampleArrayPraksisstedbrukerprofilPutDto({});
            case "PraksisstedbrukerprofilPutTilgangerInnerDto": return this.samplePraksisstedbrukerprofilPutTilgangerInnerDto({});
            case "Array<PraksisstedbrukerprofilPutTilgangerInnerDto>": return this.sampleArrayPraksisstedbrukerprofilPutTilgangerInnerDto({});
            case "PraksisstedprofilAdresseDto": return this.samplePraksisstedprofilAdresseDto({});
            case "Array<PraksisstedprofilAdresseDto>": return this.sampleArrayPraksisstedprofilAdresseDto({});
            case "PraksisstedprofilDto": return this.samplePraksisstedprofilDto({});
            case "Array<PraksisstedprofilDto>": return this.sampleArrayPraksisstedprofilDto({});
            case "PraksisstedprofilNoderDto": return this.samplePraksisstedprofilNoderDto({});
            case "Array<PraksisstedprofilNoderDto>": return this.sampleArrayPraksisstedprofilNoderDto({});
            case "PraksisstedprofilPutDto": return this.samplePraksisstedprofilPutDto({});
            case "Array<PraksisstedprofilPutDto>": return this.sampleArrayPraksisstedprofilPutDto({});
            case "PraksistypeDto": return this.samplePraksistypeDto({});
            case "Array<PraksistypeDto>": return this.sampleArrayPraksistypeDto({});
            case "RolleDto": return this.sampleRolleDto({});
            case "Array<RolleDto>": return this.sampleArrayRolleDto({});
            case "RolleTypeDto": return this.sampleRolleTypeDto({});
            case "Array<RolleTypeDto>": return this.sampleArrayRolleTypeDto({});
            case "StudentPaaPraksisstedDto": return this.sampleStudentPaaPraksisstedDto({});
            case "Array<StudentPaaPraksisstedDto>": return this.sampleArrayStudentPaaPraksisstedDto({});
            case "StudentVurderingDto": return this.sampleStudentVurderingDto({});
            case "Array<StudentVurderingDto>": return this.sampleArrayStudentVurderingDto({});
            case "StudentbrukerDto": return this.sampleStudentbrukerDto({});
            case "Array<StudentbrukerDto>": return this.sampleArrayStudentbrukerDto({});
            case "StudentbrukerprofilDto": return this.sampleStudentbrukerprofilDto({});
            case "Array<StudentbrukerprofilDto>": return this.sampleArrayStudentbrukerprofilDto({});
            case "StudenterForVurderingDto": return this.sampleStudenterForVurderingDto({});
            case "Array<StudenterForVurderingDto>": return this.sampleArrayStudenterForVurderingDto({});
            case "StudenterPaaPraksisstedDto": return this.sampleStudenterPaaPraksisstedDto({});
            case "Array<StudenterPaaPraksisstedDto>": return this.sampleArrayStudenterPaaPraksisstedDto({});
            case "StudentfordelingDto": return this.sampleStudentfordelingDto({});
            case "Array<StudentfordelingDto>": return this.sampleArrayStudentfordelingDto({});
            case "StudentfordelingMedValgDto": return this.sampleStudentfordelingMedValgDto({});
            case "Array<StudentfordelingMedValgDto>": return this.sampleArrayStudentfordelingMedValgDto({});
            case "StudentfordelingPutDto": return this.sampleStudentfordelingPutDto({});
            case "Array<StudentfordelingPutDto>": return this.sampleArrayStudentfordelingPutDto({});
            case "StudiestedDto": return this.sampleStudiestedDto({});
            case "Array<StudiestedDto>": return this.sampleArrayStudiestedDto({});
            case "StudiestedRollerDto": return this.sampleStudiestedRollerDto();
            case "Array<StudiestedRollerDto>": return this.sampleArrayStudiestedRollerDto();
            case "StudiestedbrukerDto": return this.sampleStudiestedbrukerDto({});
            case "Array<StudiestedbrukerDto>": return this.sampleArrayStudiestedbrukerDto({});
            case "StudiestedbrukerSignatarDto": return this.sampleStudiestedbrukerSignatarDto({});
            case "Array<StudiestedbrukerSignatarDto>": return this.sampleArrayStudiestedbrukerSignatarDto({});
            case "StudiestedbrukerprofilDto": return this.sampleStudiestedbrukerprofilDto({});
            case "Array<StudiestedbrukerprofilDto>": return this.sampleArrayStudiestedbrukerprofilDto({});
            case "VurderingOppsummeringDto": return this.sampleVurderingOppsummeringDto({});
            case "Array<VurderingOppsummeringDto>": return this.sampleArrayVurderingOppsummeringDto({});
            case "VurderingStudentDto": return this.sampleVurderingStudentDto({});
            case "Array<VurderingStudentDto>": return this.sampleArrayVurderingStudentDto({});
            default: throw new Error("Unknown type "+ modelName);
        }
    }
    sampleAbstractSignatarDto(template?: Factory<AbstractSignatarDto>): AbstractSignatarDto {
        if (typeof this.sampleModelProperties["AbstractSignatarDto"] === "function") {
            return this.sampleModelProperties["AbstractSignatarDto"](this);
        }

        return {
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("AbstractSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("AbstractSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("AbstractSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("AbstractSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayAbstractSignatarDto(template?: Factory<AbstractSignatarDto>, length?: number): Array<AbstractSignatarDto> {
        return Array.from({length: length || this.arrayLength("AbstractSignatarDto")}).map(() => this.sampleAbstractSignatarDto(template));
    }
    sampleAvtalestatusDto(template?: EnumFactory<AvtalestatusDto>): AvtalestatusDto {
        if (typeof this.sampleModelProperties["AvtalestatusDto"] === "function") {
            return this.sampleModelProperties["AvtalestatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                AvtalestatusDto.IkkeAktiv,
                AvtalestatusDto.Aktiv,
                AvtalestatusDto.SendtTilSignering,
                AvtalestatusDto.InnhenterOpplysninger,
                AvtalestatusDto.Kansellert,
                AvtalestatusDto.Avsluttet,
                AvtalestatusDto.Utkast,
                AvtalestatusDto.Feil
        ]);
    }
    sampleArrayAvtalestatusDto(template?: EnumFactory<AvtalestatusDto>, length?: number): Array<AvtalestatusDto> {
        return Array.from({length: length || this.arrayLength("AvtalestatusDto")}).map(() => this.sampleAvtalestatusDto());
    }
    sampleAvtalestederMedMuligeOmfattedePraksisstedDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstedDto>): AvtalestederMedMuligeOmfattedePraksisstedDto {
        if (typeof this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstedDto"] === "function") {
            return this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstedDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("AvtalestederMedMuligeOmfattedePraksisstedDto", "avtalestedforelder", "MinimalPraksisstedDto", "null", false),
            omfattetPraksisstedsteder: template && template.omfattetPraksisstedsteder ? (typeof template.omfattetPraksisstedsteder === "function" ? (template.omfattetPraksisstedsteder as Function)(this) : template.omfattetPraksisstedsteder): this.generate("AvtalestederMedMuligeOmfattedePraksisstedDto", "omfattetPraksisstedsteder", "Array<MinimalPraksisstedDto>", "null", false),
        };
    }
    sampleArrayAvtalestederMedMuligeOmfattedePraksisstedDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstedDto>, length?: number): Array<AvtalestederMedMuligeOmfattedePraksisstedDto> {
        return Array.from({length: length || this.arrayLength("AvtalestederMedMuligeOmfattedePraksisstedDto")}).map(() => this.sampleAvtalestederMedMuligeOmfattedePraksisstedDto(template));
    }
    sampleAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto>): AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto {
        if (typeof this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto"] === "function") {
            return this.sampleModelProperties["AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto", "avtalestedforelder", "MinimalPraksisstedMedHierarkiDto", "null", false),
            omfattetPraksisstedsteder: template && template.omfattetPraksisstedsteder ? (typeof template.omfattetPraksisstedsteder === "function" ? (template.omfattetPraksisstedsteder as Function)(this) : template.omfattetPraksisstedsteder): this.generate("AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto", "omfattetPraksisstedsteder", "Array<MinimalPraksisstedDto>", "null", false),
        };
    }
    sampleArrayAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto(template?: Factory<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto>, length?: number): Array<AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto> {
        return Array.from({length: length || this.arrayLength("AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto")}).map(() => this.sampleAvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto(template));
    }
    sampleBrukerinfoDto(template?: Factory<BrukerinfoDto>): BrukerinfoDto {
        if (typeof this.sampleModelProperties["BrukerinfoDto"] === "function") {
            return this.sampleModelProperties["BrukerinfoDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("BrukerinfoDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("BrukerinfoDto", "fornavn", "string", "null", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("BrukerinfoDto", "etternavn", "string", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("BrukerinfoDto", "epost", "string", "null", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("BrukerinfoDto", "telefonnummer", "string", "null", false),
            innstillinger: template && template.innstillinger ? (typeof template.innstillinger === "function" ? (template.innstillinger as Function)(this) : template.innstillinger): this.generate("BrukerinfoDto", "innstillinger", "BrukerinnstillingerDto", "null", false),
            hoeyesteRettighet: template && template.hoeyesteRettighet ? (typeof template.hoeyesteRettighet === "function" ? (template.hoeyesteRettighet as Function)(this) : template.hoeyesteRettighet): this.generate("BrukerinfoDto", "hoeyesteRettighet", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayBrukerinfoDto(template?: Factory<BrukerinfoDto>, length?: number): Array<BrukerinfoDto> {
        return Array.from({length: length || this.arrayLength("BrukerinfoDto")}).map(() => this.sampleBrukerinfoDto(template));
    }
    sampleBrukerinnstillingerDto(template?: Factory<BrukerinnstillingerDto>): BrukerinnstillingerDto {
        if (typeof this.sampleModelProperties["BrukerinnstillingerDto"] === "function") {
            return this.sampleModelProperties["BrukerinnstillingerDto"](this);
        }

        return {
            spraakvalg: template && template.spraakvalg ? (typeof template.spraakvalg === "function" ? (template.spraakvalg as Function)(this) : template.spraakvalg): this.generate("BrukerinnstillingerDto", "spraakvalg", "string", "no", false),
            harGodtattBetingelser: template && template.harGodtattBetingelser ? (typeof template.harGodtattBetingelser === "function" ? (template.harGodtattBetingelser as Function)(this) : template.harGodtattBetingelser): this.generate("BrukerinnstillingerDto", "harGodtattBetingelser", "boolean", "null", false),
        };
    }
    sampleArrayBrukerinnstillingerDto(template?: Factory<BrukerinnstillingerDto>, length?: number): Array<BrukerinnstillingerDto> {
        return Array.from({length: length || this.arrayLength("BrukerinnstillingerDto")}).map(() => this.sampleBrukerinnstillingerDto(template));
    }
    sampleBrukerrollerDto(template?: EnumFactory<BrukerrollerDto>): BrukerrollerDto {
        if (typeof this.sampleModelProperties["BrukerrollerDto"] === "function") {
            return this.sampleModelProperties["BrukerrollerDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                BrukerrollerDto.Administrator,
                BrukerrollerDto.Skriverettighet,
                BrukerrollerDto.Leserettighet
        ]);
    }
    sampleArrayBrukerrollerDto(template?: EnumFactory<BrukerrollerDto>, length?: number): Array<BrukerrollerDto> {
        return Array.from({length: length || this.arrayLength("BrukerrollerDto")}).map(() => this.sampleBrukerrollerDto());
    }
    sampleBrukerstatusDto(template?: EnumFactory<BrukerstatusDto>): BrukerstatusDto {
        if (typeof this.sampleModelProperties["BrukerstatusDto"] === "function") {
            return this.sampleModelProperties["BrukerstatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                BrukerstatusDto.Aktiv,
                BrukerstatusDto.Invitert
        ]);
    }
    sampleArrayBrukerstatusDto(template?: EnumFactory<BrukerstatusDto>, length?: number): Array<BrukerstatusDto> {
        return Array.from({length: length || this.arrayLength("BrukerstatusDto")}).map(() => this.sampleBrukerstatusDto());
    }
    sampleEierAvtalestedMedMuligeOmfattedeStudiestedDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedDto>): EierAvtalestedMedMuligeOmfattedeStudiestedDto {
        if (typeof this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedDto"] === "function") {
            return this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedDto", "avtalestedforelder", "MinimalStudiestedDto", "null", false),
            omfattetStudiesteder: template && template.omfattetStudiesteder ? (typeof template.omfattetStudiesteder === "function" ? (template.omfattetStudiesteder as Function)(this) : template.omfattetStudiesteder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedDto", "omfattetStudiesteder", "Array<MinimalStudiestedDto>", "null", false),
        };
    }
    sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedDto>, length?: number): Array<EierAvtalestedMedMuligeOmfattedeStudiestedDto> {
        return Array.from({length: length || this.arrayLength("EierAvtalestedMedMuligeOmfattedeStudiestedDto")}).map(() => this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedDto(template));
    }
    sampleEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto>): EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto {
        if (typeof this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto"] === "function") {
            return this.sampleModelProperties["EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto"](this);
        }

        return {
            avtalestedforelder: template && template.avtalestedforelder ? (typeof template.avtalestedforelder === "function" ? (template.avtalestedforelder as Function)(this) : template.avtalestedforelder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "avtalestedforelder", "MinimalStudiestedHierarkiDto", "null", false),
            omfattetStudiesteder: template && template.omfattetStudiesteder ? (typeof template.omfattetStudiesteder === "function" ? (template.omfattetStudiesteder as Function)(this) : template.omfattetStudiesteder): this.generate("EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "omfattetStudiesteder", "Array<MinimalStudiestedDto>", "null", false),
        };
    }
    sampleArrayEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto(template?: Factory<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto>, length?: number): Array<EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto> {
        return Array.from({length: length || this.arrayLength("EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto")}).map(() => this.sampleEierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto(template));
    }
    sampleEksternSignatarDto(template?: Factory<EksternSignatarDto>): EksternSignatarDto {
        if (typeof this.sampleModelProperties["EksternSignatarDto"] === "function") {
            return this.sampleModelProperties["EksternSignatarDto"](this);
        }

        return {
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("EksternSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("EksternSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("EksternSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("EksternSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayEksternSignatarDto(template?: Factory<EksternSignatarDto>, length?: number): Array<EksternSignatarDto> {
        return Array.from({length: length || this.arrayLength("EksternSignatarDto")}).map(() => this.sampleEksternSignatarDto(template));
    }
    sampleEmneDto(template?: Factory<EmneDto>): EmneDto {
        if (typeof this.sampleModelProperties["EmneDto"] === "function") {
            return this.sampleModelProperties["EmneDto"](this);
        }

        return {
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("EmneDto", "kode", "string", "SYBAPRA1", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("EmneDto", "navn", "string", "Praksisstudier i sykepleie", false),
        };
    }
    sampleArrayEmneDto(template?: Factory<EmneDto>, length?: number): Array<EmneDto> {
        return Array.from({length: length || this.arrayLength("EmneDto")}).map(() => this.sampleEmneDto(template));
    }
    sampleHalPraksisavtaleVedleggMinimalListDto(template?: Factory<HalPraksisavtaleVedleggMinimalListDto>): HalPraksisavtaleVedleggMinimalListDto {
        if (typeof this.sampleModelProperties["HalPraksisavtaleVedleggMinimalListDto"] === "function") {
            return this.sampleModelProperties["HalPraksisavtaleVedleggMinimalListDto"](this);
        }

        return {
            items: template && template.items ? (typeof template.items === "function" ? (template.items as Function)(this) : template.items): this.generate("HalPraksisavtaleVedleggMinimalListDto", "items", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
        };
    }
    sampleArrayHalPraksisavtaleVedleggMinimalListDto(template?: Factory<HalPraksisavtaleVedleggMinimalListDto>, length?: number): Array<HalPraksisavtaleVedleggMinimalListDto> {
        return Array.from({length: length || this.arrayLength("HalPraksisavtaleVedleggMinimalListDto")}).map(() => this.sampleHalPraksisavtaleVedleggMinimalListDto(template));
    }
    sampleHalPraksisstedavtaleDto(template?: Factory<HalPraksisstedavtaleDto>): HalPraksisstedavtaleDto {
        if (typeof this.sampleModelProperties["HalPraksisstedavtaleDto"] === "function") {
            return this.sampleModelProperties["HalPraksisstedavtaleDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("HalPraksisstedavtaleDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("HalPraksisstedavtaleDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("HalPraksisstedavtaleDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("HalPraksisstedavtaleDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("HalPraksisstedavtaleDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("HalPraksisstedavtaleDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("HalPraksisstedavtaleDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("HalPraksisstedavtaleDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("HalPraksisstedavtaleDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("HalPraksisstedavtaleDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("HalPraksisstedavtaleDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("HalPraksisstedavtaleDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("HalPraksisstedavtaleDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("HalPraksisstedavtaleDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("HalPraksisstedavtaleDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("HalPraksisstedavtaleDto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("HalPraksisstedavtaleDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("HalPraksisstedavtaleDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }", "null", false),
        };
    }
    sampleArrayHalPraksisstedavtaleDto(template?: Factory<HalPraksisstedavtaleDto>, length?: number): Array<HalPraksisstedavtaleDto> {
        return Array.from({length: length || this.arrayLength("HalPraksisstedavtaleDto")}).map(() => this.sampleHalPraksisstedavtaleDto(template));
    }
    sampleHalPraksisstedavtalerDto(template?: Factory<HalPraksisstedavtalerDto>): HalPraksisstedavtalerDto {
        if (typeof this.sampleModelProperties["HalPraksisstedavtalerDto"] === "function") {
            return this.sampleModelProperties["HalPraksisstedavtalerDto"](this);
        }

        return {
            avtaler: template && template.avtaler ? (typeof template.avtaler === "function" ? (template.avtaler as Function)(this) : template.avtaler): this.generate("HalPraksisstedavtalerDto", "avtaler", "Array<PraksisstedavtaleDto>", "null", false),
        };
    }
    sampleArrayHalPraksisstedavtalerDto(template?: Factory<HalPraksisstedavtalerDto>, length?: number): Array<HalPraksisstedavtalerDto> {
        return Array.from({length: length || this.arrayLength("HalPraksisstedavtalerDto")}).map(() => this.sampleHalPraksisstedavtalerDto(template));
    }
    sampleMinimalAktivitetInfoDto(template?: Factory<MinimalAktivitetInfoDto>): MinimalAktivitetInfoDto {
        if (typeof this.sampleModelProperties["MinimalAktivitetInfoDto"] === "function") {
            return this.sampleModelProperties["MinimalAktivitetInfoDto"](this);
        }

        return {
            aktivitetId: template && template.aktivitetId ? (typeof template.aktivitetId === "function" ? (template.aktivitetId as Function)(this) : template.aktivitetId): this.generate("MinimalAktivitetInfoDto", "aktivitetId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("MinimalAktivitetInfoDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("MinimalAktivitetInfoDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            emnekode: template && template.emnekode ? (typeof template.emnekode === "function" ? (template.emnekode as Function)(this) : template.emnekode): this.generate("MinimalAktivitetInfoDto", "emnekode", "string", "ACME", false),
            praksistypenavn: template && template.praksistypenavn ? (typeof template.praksistypenavn === "function" ? (template.praksistypenavn as Function)(this) : template.praksistypenavn): this.generate("MinimalAktivitetInfoDto", "praksistypenavn", "string", "Auditorisk Røyksignalisering", false),
            praksisklassenavn: template && template.praksisklassenavn ? (typeof template.praksisklassenavn === "function" ? (template.praksisklassenavn as Function)(this) : template.praksisklassenavn): this.generate("MinimalAktivitetInfoDto", "praksisklassenavn", "string", "Ω", false),
            studenter: template && template.studenter ? (typeof template.studenter === "function" ? (template.studenter as Function)(this) : template.studenter): this.generate("MinimalAktivitetInfoDto", "studenter", "number", "null", false),
            aktivitetVurderingStatus: template && template.aktivitetVurderingStatus ? (typeof template.aktivitetVurderingStatus === "function" ? (template.aktivitetVurderingStatus as Function)(this) : template.aktivitetVurderingStatus): this.pickOne([MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum.Gjennomfoert,MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum.Aktiv,MinimalAktivitetInfoDtoAktivitetVurderingStatusDtoEnum.Framtidig]),
        };
    }
    sampleArrayMinimalAktivitetInfoDto(template?: Factory<MinimalAktivitetInfoDto>, length?: number): Array<MinimalAktivitetInfoDto> {
        return Array.from({length: length || this.arrayLength("MinimalAktivitetInfoDto")}).map(() => this.sampleMinimalAktivitetInfoDto(template));
    }
    sampleMinimalAktiviteterDto(template?: Factory<MinimalAktiviteterDto>): MinimalAktiviteterDto {
        if (typeof this.sampleModelProperties["MinimalAktiviteterDto"] === "function") {
            return this.sampleModelProperties["MinimalAktiviteterDto"](this);
        }

        return {
            aktiviteter: template && template.aktiviteter ? (typeof template.aktiviteter === "function" ? (template.aktiviteter as Function)(this) : template.aktiviteter): this.generate("MinimalAktiviteterDto", "aktiviteter", "Array<MinimalAktivitetInfoDto>", "null", false),
        };
    }
    sampleArrayMinimalAktiviteterDto(template?: Factory<MinimalAktiviteterDto>, length?: number): Array<MinimalAktiviteterDto> {
        return Array.from({length: length || this.arrayLength("MinimalAktiviteterDto")}).map(() => this.sampleMinimalAktiviteterDto(template));
    }
    sampleMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>): MinimalPraksisstedDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalPraksisstedDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalPraksisstedDto", "navn", "string", "Sykehus", false),
        };
    }
    sampleArrayMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>, length?: number): Array<MinimalPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedDto")}).map(() => this.sampleMinimalPraksisstedDto(template));
    }
    sampleMinimalPraksisstedMedHierarkiDto(template?: Factory<MinimalPraksisstedMedHierarkiDto>): MinimalPraksisstedMedHierarkiDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedMedHierarkiDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedMedHierarkiDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalPraksisstedMedHierarkiDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalPraksisstedMedHierarkiDto", "navn", "string", "Sykehus", false),
            orgnr: template && template.orgnr ? (typeof template.orgnr === "function" ? (template.orgnr as Function)(this) : template.orgnr): this.generate("MinimalPraksisstedMedHierarkiDto", "orgnr", "string", "456789129", false),
            noder: template && template.noder ? (typeof template.noder === "function" ? (template.noder as Function)(this) : template.noder): this.generate("MinimalPraksisstedMedHierarkiDto", "noder", "MinimalPraksisstedMedHierarkiNoderDto", "null", false),
        };
    }
    sampleArrayMinimalPraksisstedMedHierarkiDto(template?: Factory<MinimalPraksisstedMedHierarkiDto>, length?: number): Array<MinimalPraksisstedMedHierarkiDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedMedHierarkiDto")}).map(() => this.sampleMinimalPraksisstedMedHierarkiDto(template));
    }
    sampleMinimalPraksisstedMedHierarkiNoderDto(template?: Factory<MinimalPraksisstedMedHierarkiNoderDto>): MinimalPraksisstedMedHierarkiNoderDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedMedHierarkiNoderDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedMedHierarkiNoderDto"](this);
        }

        return {
            over: template && template.over ? (typeof template.over === "function" ? (template.over as Function)(this) : template.over): this.generate("MinimalPraksisstedMedHierarkiNoderDto", "over", "MinimalPraksisstedMedHierarkiDto", "null", false),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("MinimalPraksisstedMedHierarkiNoderDto", "under", "Array<MinimalPraksisstedMedHierarkiDto>", "null", false),
        };
    }
    sampleArrayMinimalPraksisstedMedHierarkiNoderDto(template?: Factory<MinimalPraksisstedMedHierarkiNoderDto>, length?: number): Array<MinimalPraksisstedMedHierarkiNoderDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedMedHierarkiNoderDto")}).map(() => this.sampleMinimalPraksisstedMedHierarkiNoderDto(template));
    }
    sampleMinimalPraksisstedprofilDto(template?: Factory<MinimalPraksisstedprofilDto>): MinimalPraksisstedprofilDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedprofilDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedprofilDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalPraksisstedprofilDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalPraksisstedprofilDto", "navn", "string", "Lovisenberg Diakonale Sykehus", false),
            bilde: template && template.bilde ? (typeof template.bilde === "function" ? (template.bilde as Function)(this) : template.bilde): this.generate("MinimalPraksisstedprofilDto", "bilde", "string", "null", false),
        };
    }
    sampleArrayMinimalPraksisstedprofilDto(template?: Factory<MinimalPraksisstedprofilDto>, length?: number): Array<MinimalPraksisstedprofilDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedprofilDto")}).map(() => this.sampleMinimalPraksisstedprofilDto(template));
    }
    sampleMinimalStudiestedDto(template?: Factory<MinimalStudiestedDto>): MinimalStudiestedDto {
        if (typeof this.sampleModelProperties["MinimalStudiestedDto"] === "function") {
            return this.sampleModelProperties["MinimalStudiestedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalStudiestedDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalStudiestedDto", "navn", "string", "UIO", false),
        };
    }
    sampleArrayMinimalStudiestedDto(template?: Factory<MinimalStudiestedDto>, length?: number): Array<MinimalStudiestedDto> {
        return Array.from({length: length || this.arrayLength("MinimalStudiestedDto")}).map(() => this.sampleMinimalStudiestedDto(template));
    }
    sampleMinimalStudiestedHierarkiDto(template?: Factory<MinimalStudiestedHierarkiDto>): MinimalStudiestedHierarkiDto {
        if (typeof this.sampleModelProperties["MinimalStudiestedHierarkiDto"] === "function") {
            return this.sampleModelProperties["MinimalStudiestedHierarkiDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalStudiestedHierarkiDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalStudiestedHierarkiDto", "navn", "string", "UIO", false),
            noder: template && template.noder ? (typeof template.noder === "function" ? (template.noder as Function)(this) : template.noder): this.generate("MinimalStudiestedHierarkiDto", "noder", "MinimalStudiestedHierarkiNoderDto", "null", false),
        };
    }
    sampleArrayMinimalStudiestedHierarkiDto(template?: Factory<MinimalStudiestedHierarkiDto>, length?: number): Array<MinimalStudiestedHierarkiDto> {
        return Array.from({length: length || this.arrayLength("MinimalStudiestedHierarkiDto")}).map(() => this.sampleMinimalStudiestedHierarkiDto(template));
    }
    sampleMinimalStudiestedHierarkiNoderDto(template?: Factory<MinimalStudiestedHierarkiNoderDto>): MinimalStudiestedHierarkiNoderDto {
        if (typeof this.sampleModelProperties["MinimalStudiestedHierarkiNoderDto"] === "function") {
            return this.sampleModelProperties["MinimalStudiestedHierarkiNoderDto"](this);
        }

        return {
            over: template && template.over ? (typeof template.over === "function" ? (template.over as Function)(this) : template.over): this.generate("MinimalStudiestedHierarkiNoderDto", "over", "Array<MinimalStudiestedHierarkiDto>", "null", false),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("MinimalStudiestedHierarkiNoderDto", "under", "Array<MinimalStudiestedHierarkiDto>", "null", false),
        };
    }
    sampleArrayMinimalStudiestedHierarkiNoderDto(template?: Factory<MinimalStudiestedHierarkiNoderDto>, length?: number): Array<MinimalStudiestedHierarkiNoderDto> {
        return Array.from({length: length || this.arrayLength("MinimalStudiestedHierarkiNoderDto")}).map(() => this.sampleMinimalStudiestedHierarkiNoderDto(template));
    }
    sampleMuligPraksisstedDto(template?: Factory<MuligPraksisstedDto>): MuligPraksisstedDto {
        if (typeof this.sampleModelProperties["MuligPraksisstedDto"] === "function") {
            return this.sampleModelProperties["MuligPraksisstedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MuligPraksisstedDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MuligPraksisstedDto", "navn", "string", "Sykehus", false),
            dybde: template && template.dybde ? (typeof template.dybde === "function" ? (template.dybde as Function)(this) : template.dybde): this.generate("MuligPraksisstedDto", "dybde", "number", "1", false),
            endenode: template && template.endenode ? (typeof template.endenode === "function" ? (template.endenode as Function)(this) : template.endenode): this.generate("MuligPraksisstedDto", "endenode", "boolean", "false", false),
            deaktivert: template && template.deaktivert ? (typeof template.deaktivert === "function" ? (template.deaktivert as Function)(this) : template.deaktivert): this.generate("MuligPraksisstedDto", "deaktivert", "boolean", "false", false),
        };
    }
    sampleArrayMuligPraksisstedDto(template?: Factory<MuligPraksisstedDto>, length?: number): Array<MuligPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("MuligPraksisstedDto")}).map(() => this.sampleMuligPraksisstedDto(template));
    }
    sampleMultiSignatarerDto(template?: Factory<MultiSignatarerDto>): MultiSignatarerDto {
        if (typeof this.sampleModelProperties["MultiSignatarerDto"] === "function") {
            return this.sampleModelProperties["MultiSignatarerDto"](this);
        }

        return {
            eksternbrukere: template && template.eksternbrukere ? (typeof template.eksternbrukere === "function" ? (template.eksternbrukere as Function)(this) : template.eksternbrukere): this.generate("MultiSignatarerDto", "eksternbrukere", "Array<EksternSignatarDto>", "null", false),
            studiestedbrukere: template && template.studiestedbrukere ? (typeof template.studiestedbrukere === "function" ? (template.studiestedbrukere as Function)(this) : template.studiestedbrukere): this.generate("MultiSignatarerDto", "studiestedbrukere", "Array<StudiestedbrukerSignatarDto>", "null", false),
            praksisstedbrukere: template && template.praksisstedbrukere ? (typeof template.praksisstedbrukere === "function" ? (template.praksisstedbrukere as Function)(this) : template.praksisstedbrukere): this.generate("MultiSignatarerDto", "praksisstedbrukere", "Array<PraksisstedbrukerSignatarDto>", "null", false),
        };
    }
    sampleArrayMultiSignatarerDto(template?: Factory<MultiSignatarerDto>, length?: number): Array<MultiSignatarerDto> {
        return Array.from({length: length || this.arrayLength("MultiSignatarerDto")}).map(() => this.sampleMultiSignatarerDto(template));
    }
    sampleNyPraksisstedbrukerInvitasjonDto(template?: Factory<NyPraksisstedbrukerInvitasjonDto>): NyPraksisstedbrukerInvitasjonDto {
        if (typeof this.sampleModelProperties["NyPraksisstedbrukerInvitasjonDto"] === "function") {
            return this.sampleModelProperties["NyPraksisstedbrukerInvitasjonDto"](this);
        }

        return {
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("NyPraksisstedbrukerInvitasjonDto", "epost", "string", "user@example.com", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("NyPraksisstedbrukerInvitasjonDto", "fornavn", "string", "Ola Nordmann", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("NyPraksisstedbrukerInvitasjonDto", "etternavn", "string", "Nordmann", false),
            fnr: template && template.fnr ? (typeof template.fnr === "function" ? (template.fnr as Function)(this) : template.fnr): this.generate("NyPraksisstedbrukerInvitasjonDto", "fnr", "string", "1234567800000", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("NyPraksisstedbrukerInvitasjonDto", "praksisstedId", "string", "null", false),
            tilgangsrolle: template && template.tilgangsrolle ? (typeof template.tilgangsrolle === "function" ? (template.tilgangsrolle as Function)(this) : template.tilgangsrolle): this.generate("NyPraksisstedbrukerInvitasjonDto", "tilgangsrolle", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayNyPraksisstedbrukerInvitasjonDto(template?: Factory<NyPraksisstedbrukerInvitasjonDto>, length?: number): Array<NyPraksisstedbrukerInvitasjonDto> {
        return Array.from({length: length || this.arrayLength("NyPraksisstedbrukerInvitasjonDto")}).map(() => this.sampleNyPraksisstedbrukerInvitasjonDto(template));
    }
    sampleNyRolleDto(template?: Factory<NyRolleDto>): NyRolleDto {
        if (typeof this.sampleModelProperties["NyRolleDto"] === "function") {
            return this.sampleModelProperties["NyRolleDto"](this);
        }

        return {
            praksisstedbrukerId: template && template.praksisstedbrukerId ? (typeof template.praksisstedbrukerId === "function" ? (template.praksisstedbrukerId as Function)(this) : template.praksisstedbrukerId): this.generate("NyRolleDto", "praksisstedbrukerId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("NyRolleDto", "type", "PraksisstedRollerDto", "null", false),
        };
    }
    sampleArrayNyRolleDto(template?: Factory<NyRolleDto>, length?: number): Array<NyRolleDto> {
        return Array.from({length: length || this.arrayLength("NyRolleDto")}).map(() => this.sampleNyRolleDto(template));
    }
    samplePersonDto(template?: Factory<PersonDto>): PersonDto {
        if (typeof this.sampleModelProperties["PersonDto"] === "function") {
            return this.sampleModelProperties["PersonDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PersonDto", "id", "string", "null", false),
            fsId: template && template.fsId ? (typeof template.fsId === "function" ? (template.fsId as Function)(this) : template.fsId): this.generate("PersonDto", "fsId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("PersonDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("PersonDto", "etternavn", "string", "Nordmann", false),
        };
    }
    sampleArrayPersonDto(template?: Factory<PersonDto>, length?: number): Array<PersonDto> {
        return Array.from({length: length || this.arrayLength("PersonDto")}).map(() => this.samplePersonDto(template));
    }
    samplePraksisDto(template?: Factory<PraksisDto>): PraksisDto {
        if (typeof this.sampleModelProperties["PraksisDto"] === "function") {
            return this.sampleModelProperties["PraksisDto"](this);
        }

        return {
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("PraksisDto", "kode", "string", "SPLGRU", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisDto", "navn", "string", "Grunnleggende sykepleie", false),
        };
    }
    sampleArrayPraksisDto(template?: Factory<PraksisDto>, length?: number): Array<PraksisDto> {
        return Array.from({length: length || this.arrayLength("PraksisDto")}).map(() => this.samplePraksisDto(template));
    }
    samplePraksisaktivitetDto(template?: Factory<PraksisaktivitetDto>): PraksisaktivitetDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetDto", "sted", "StudiestedDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetDto", "praksis", "PraksisDto", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            totalBestilling: template && template.totalBestilling ? (typeof template.totalBestilling === "function" ? (template.totalBestilling as Function)(this) : template.totalBestilling): this.generate("PraksisaktivitetDto", "totalBestilling", "number", "20", false),
            totalKapasitet: template && template.totalKapasitet ? (typeof template.totalKapasitet === "function" ? (template.totalKapasitet as Function)(this) : template.totalKapasitet): this.generate("PraksisaktivitetDto", "totalKapasitet", "number", "20", false),
            praksissteder: template && template.praksissteder ? (typeof template.praksissteder === "function" ? (template.praksissteder as Function)(this) : template.praksissteder): this.generate("PraksisaktivitetDto", "praksissteder", "Array<PraksisavtaleStedDto>", "null", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisaktivitetDto", "krav", "string", "Kirurgisk praksis", false),
            organisasjonsNavn: template && template.organisasjonsNavn ? (typeof template.organisasjonsNavn === "function" ? (template.organisasjonsNavn as Function)(this) : template.organisasjonsNavn): this.generate("PraksisaktivitetDto", "organisasjonsNavn", "string", "Oslo kommune", false),
            publisertTilFs: template && template.publisertTilFs ? (typeof template.publisertTilFs === "function" ? (template.publisertTilFs as Function)(this) : template.publisertTilFs): this.generate("PraksisaktivitetDto", "publisertTilFs", "boolean", "false", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisaktivitetDto", "status", "PraksisaktivitetStatusDto", "null", false),
            fritekst: template && template.fritekst ? (typeof template.fritekst === "function" ? (template.fritekst as Function)(this) : template.fritekst): this.generate("PraksisaktivitetDto", "fritekst", "string", "Hei på deg, din gamle blei!", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisaktivitetDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisaktivitetDto", "delIdentitetsnummer", "boolean", "false", false),
        };
    }
    sampleArrayPraksisaktivitetDto(template?: Factory<PraksisaktivitetDto>, length?: number): Array<PraksisaktivitetDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetDto")}).map(() => this.samplePraksisaktivitetDto(template));
    }
    samplePraksisaktivitetInfoDetaljertPsDto(template?: Factory<PraksisaktivitetInfoDetaljertPsDto>): PraksisaktivitetInfoDetaljertPsDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetInfoDetaljertPsDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetInfoDetaljertPsDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetInfoDetaljertPsDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetInfoDetaljertPsDto", "sted", "StudiestedDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetInfoDetaljertPsDto", "praksis", "PraksisDto", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetInfoDetaljertPsDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetInfoDetaljertPsDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetInfoDetaljertPsDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("PraksisaktivitetInfoDetaljertPsDto", "bestilling", "number", "20", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisaktivitetInfoDetaljertPsDto", "krav", "string", "Kirurgisk praksis", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisaktivitetInfoDetaljertPsDto", "status", "PraksisaktivitetStatusDto", "null", false),
            rolle: template && template.rolle ? (typeof template.rolle === "function" ? (template.rolle as Function)(this) : template.rolle): this.generate("PraksisaktivitetInfoDetaljertPsDto", "rolle", "Array<PraksisstedRollerDto>", "null", false),
        };
    }
    sampleArrayPraksisaktivitetInfoDetaljertPsDto(template?: Factory<PraksisaktivitetInfoDetaljertPsDto>, length?: number): Array<PraksisaktivitetInfoDetaljertPsDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetInfoDetaljertPsDto")}).map(() => this.samplePraksisaktivitetInfoDetaljertPsDto(template));
    }
    samplePraksisaktivitetInfoDetaljertUhDto(template?: Factory<PraksisaktivitetInfoDetaljertUhDto>): PraksisaktivitetInfoDetaljertUhDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetInfoDetaljertUhDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetInfoDetaljertUhDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetInfoDetaljertUhDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetInfoDetaljertUhDto", "sted", "StudiestedDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetInfoDetaljertUhDto", "praksis", "PraksisDto", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetInfoDetaljertUhDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetInfoDetaljertUhDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetInfoDetaljertUhDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("PraksisaktivitetInfoDetaljertUhDto", "bestilling", "number", "20", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisaktivitetInfoDetaljertUhDto", "krav", "string", "Kirurgisk praksis", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisaktivitetInfoDetaljertUhDto", "status", "PraksisaktivitetStatusDto", "null", false),
            rolle: template && template.rolle ? (typeof template.rolle === "function" ? (template.rolle as Function)(this) : template.rolle): this.generate("PraksisaktivitetInfoDetaljertUhDto", "rolle", "Array<StudiestedRollerDto>", "null", false),
        };
    }
    sampleArrayPraksisaktivitetInfoDetaljertUhDto(template?: Factory<PraksisaktivitetInfoDetaljertUhDto>, length?: number): Array<PraksisaktivitetInfoDetaljertUhDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetInfoDetaljertUhDto")}).map(() => this.samplePraksisaktivitetInfoDetaljertUhDto(template));
    }
    samplePraksisaktivitetInfoDto(template?: Factory<PraksisaktivitetInfoDto>): PraksisaktivitetInfoDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetInfoDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetInfoDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetInfoDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            sted: template && template.sted ? (typeof template.sted === "function" ? (template.sted as Function)(this) : template.sted): this.generate("PraksisaktivitetInfoDto", "sted", "StudiestedDto", "null", false),
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisaktivitetInfoDto", "praksis", "PraksisDto", "null", false),
            klasse: template && template.klasse ? (typeof template.klasse === "function" ? (template.klasse as Function)(this) : template.klasse): this.generate("PraksisaktivitetInfoDto", "klasse", "PraksisklasseDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetInfoDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetInfoDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("PraksisaktivitetInfoDto", "bestilling", "number", "20", false),
        };
    }
    sampleArrayPraksisaktivitetInfoDto(template?: Factory<PraksisaktivitetInfoDto>, length?: number): Array<PraksisaktivitetInfoDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetInfoDto")}).map(() => this.samplePraksisaktivitetInfoDto(template));
    }
    samplePraksisaktivitetPutBesvarelseDto(template?: Factory<PraksisaktivitetPutBesvarelseDto>): PraksisaktivitetPutBesvarelseDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetPutBesvarelseDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetPutBesvarelseDto"](this);
        }

        return {
            bestillingId: template && template.bestillingId ? (typeof template.bestillingId === "function" ? (template.bestillingId as Function)(this) : template.bestillingId): this.generate("PraksisaktivitetPutBesvarelseDto", "bestillingId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("PraksisaktivitetPutBesvarelseDto", "praksisstedId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksisaktivitetPutBesvarelseDto", "kapasitet", "number", "10", false),
        };
    }
    sampleArrayPraksisaktivitetPutBesvarelseDto(template?: Factory<PraksisaktivitetPutBesvarelseDto>, length?: number): Array<PraksisaktivitetPutBesvarelseDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetPutBesvarelseDto")}).map(() => this.samplePraksisaktivitetPutBesvarelseDto(template));
    }
    samplePraksisaktivitetPutDto(template?: Factory<PraksisaktivitetPutDto>): PraksisaktivitetPutDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetPutDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetPutDto"](this);
        }

        return {
            bekreftet: template && template.bekreftet ? (typeof template.bekreftet === "function" ? (template.bekreftet as Function)(this) : template.bekreftet): this.generate("PraksisaktivitetPutDto", "bekreftet", "boolean", "true", false),
            besvarelser: template && template.besvarelser ? (typeof template.besvarelser === "function" ? (template.besvarelser as Function)(this) : template.besvarelser): this.generate("PraksisaktivitetPutDto", "besvarelser", "Array<PraksisaktivitetPutBesvarelseDto>", "null", false),
        };
    }
    sampleArrayPraksisaktivitetPutDto(template?: Factory<PraksisaktivitetPutDto>, length?: number): Array<PraksisaktivitetPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetPutDto")}).map(() => this.samplePraksisaktivitetPutDto(template));
    }
    samplePraksisaktivitetStatusDto(template?: EnumFactory<PraksisaktivitetStatusDto>): PraksisaktivitetStatusDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetStatusDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetStatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisaktivitetStatusDto.KanBekreftes,
                PraksisaktivitetStatusDto.BekreftetMenManglerKapasitet,
                PraksisaktivitetStatusDto.BekreftetOgHarKapasitet,
                PraksisaktivitetStatusDto.BekreftetOverstyrtKapasitet,
                PraksisaktivitetStatusDto.BekreftetMenManglerFordeling,
                PraksisaktivitetStatusDto.KlarForGjennomfoering,
                PraksisaktivitetStatusDto.Gjennomfoert,
                PraksisaktivitetStatusDto.Avtalefeil
        ]);
    }
    sampleArrayPraksisaktivitetStatusDto(template?: EnumFactory<PraksisaktivitetStatusDto>, length?: number): Array<PraksisaktivitetStatusDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetStatusDto")}).map(() => this.samplePraksisaktivitetStatusDto());
    }
    samplePraksisaktiviteterDto(template?: Factory<PraksisaktiviteterDto>): PraksisaktiviteterDto {
        if (typeof this.sampleModelProperties["PraksisaktiviteterDto"] === "function") {
            return this.sampleModelProperties["PraksisaktiviteterDto"](this);
        }

        return {
            gamle: template && template.gamle ? (typeof template.gamle === "function" ? (template.gamle as Function)(this) : template.gamle): this.generate("PraksisaktiviteterDto", "gamle", "Array<PraksisaktivitetInfoDto>", "null", false),
            aktive: template && template.aktive ? (typeof template.aktive === "function" ? (template.aktive as Function)(this) : template.aktive): this.generate("PraksisaktiviteterDto", "aktive", "Array<PraksisaktivitetInfoDto>", "null", false),
            fremtidige: template && template.fremtidige ? (typeof template.fremtidige === "function" ? (template.fremtidige as Function)(this) : template.fremtidige): this.generate("PraksisaktiviteterDto", "fremtidige", "Array<PraksisaktivitetInfoDto>", "null", false),
        };
    }
    sampleArrayPraksisaktiviteterDto(template?: Factory<PraksisaktiviteterDto>, length?: number): Array<PraksisaktiviteterDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktiviteterDto")}).map(() => this.samplePraksisaktiviteterDto(template));
    }
    samplePraksisaktiviteterInfoDto(template?: Factory<PraksisaktiviteterInfoDto>): PraksisaktiviteterInfoDto {
        if (typeof this.sampleModelProperties["PraksisaktiviteterInfoDto"] === "function") {
            return this.sampleModelProperties["PraksisaktiviteterInfoDto"](this);
        }

        return {
            aktiviteter: template && template.aktiviteter ? (typeof template.aktiviteter === "function" ? (template.aktiviteter as Function)(this) : template.aktiviteter): this.generate("PraksisaktiviteterInfoDto", "aktiviteter", "Array<PraksisaktivitetInfoDto>", "null", false),
        };
    }
    sampleArrayPraksisaktiviteterInfoDto(template?: Factory<PraksisaktiviteterInfoDto>, length?: number): Array<PraksisaktiviteterInfoDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktiviteterInfoDto")}).map(() => this.samplePraksisaktiviteterInfoDto(template));
    }
    samplePraksisavtaleStedDto(template?: Factory<PraksisavtaleStedDto>): PraksisavtaleStedDto {
        if (typeof this.sampleModelProperties["PraksisavtaleStedDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleStedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisavtaleStedDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisavtaleStedDto", "navn", "string", "Skole A", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisavtaleStedDto", "kanEndre", "boolean", "true", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisavtaleStedDto", "avtaleId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisavtaleStedDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("PraksisavtaleStedDto", "bestilling", "number", "20", false),
            bestillingId: template && template.bestillingId ? (typeof template.bestillingId === "function" ? (template.bestillingId as Function)(this) : template.bestillingId): this.generate("PraksisavtaleStedDto", "bestillingId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksisavtaleStedDto", "kapasitet", "number", "10", false),
            kapasitetstype: template && template.kapasitetstype ? (typeof template.kapasitetstype === "function" ? (template.kapasitetstype as Function)(this) : template.kapasitetstype): this.pickOne([PraksisavtaleStedDtoKapasitetstypeDtoEnum.Praksissted,PraksisavtaleStedDtoKapasitetstypeDtoEnum.Studiested]),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisavtaleStedDto", "status", "PraksisavtalestedStatusDto", "null", false),
            undernoder: template && template.undernoder ? (typeof template.undernoder === "function" ? (template.undernoder as Function)(this) : template.undernoder): this.generate("PraksisavtaleStedDto", "undernoder", "Array<PraksisavtaleStedDto>", "null", false),
        };
    }
    sampleArrayPraksisavtaleStedDto(template?: Factory<PraksisavtaleStedDto>, length?: number): Array<PraksisavtaleStedDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleStedDto")}).map(() => this.samplePraksisavtaleStedDto(template));
    }
    samplePraksisavtaleValideringfeiltypeDto(template?: EnumFactory<PraksisavtaleValideringfeiltypeDto>): PraksisavtaleValideringfeiltypeDto {
        if (typeof this.sampleModelProperties["PraksisavtaleValideringfeiltypeDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleValideringfeiltypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtaleValideringfeiltypeDto.Avtalenavn,
                PraksisavtaleValideringfeiltypeDto.Avtalested,
                PraksisavtaleValideringfeiltypeDto.AvtaleVersjon,
                PraksisavtaleValideringfeiltypeDto.AvtalePraksistyper,
                PraksisavtaleValideringfeiltypeDto.Avtaleeier,
                PraksisavtaleValideringfeiltypeDto.AvtaleDato,
                PraksisavtaleValideringfeiltypeDto.AvtaleData
        ]);
    }
    sampleArrayPraksisavtaleValideringfeiltypeDto(template?: EnumFactory<PraksisavtaleValideringfeiltypeDto>, length?: number): Array<PraksisavtaleValideringfeiltypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleValideringfeiltypeDto")}).map(() => this.samplePraksisavtaleValideringfeiltypeDto());
    }
    samplePraksisavtaleValideringsfeilDto(template?: Factory<PraksisavtaleValideringsfeilDto>): PraksisavtaleValideringsfeilDto {
        if (typeof this.sampleModelProperties["PraksisavtaleValideringsfeilDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleValideringsfeilDto"](this);
        }

        return {
            message: template && template.message ? (typeof template.message === "function" ? (template.message as Function)(this) : template.message): this.generate("PraksisavtaleValideringsfeilDto", "message", "string", "Avtalenavn kan ikke være tom", false),
            errorType: template && template.errorType ? (typeof template.errorType === "function" ? (template.errorType as Function)(this) : template.errorType): this.generate("PraksisavtaleValideringsfeilDto", "errorType", "PraksisavtaleValideringfeiltypeDto", "null", false),
        };
    }
    sampleArrayPraksisavtaleValideringsfeilDto(template?: Factory<PraksisavtaleValideringsfeilDto>, length?: number): Array<PraksisavtaleValideringsfeilDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleValideringsfeilDto")}).map(() => this.samplePraksisavtaleValideringsfeilDto(template));
    }
    samplePraksisavtaleVedleggDto(template?: Factory<PraksisavtaleVedleggDto>): PraksisavtaleVedleggDto {
        if (typeof this.sampleModelProperties["PraksisavtaleVedleggDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleVedleggDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisavtaleVedleggDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisavtaleVedleggDto", "navn", "string", "Sommeravtalen for skøy på landet", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("PraksisavtaleVedleggDto", "type", "PraksisavtaleVedleggTypeDto", "null", false),
            filStorrelse: template && template.filStorrelse ? (typeof template.filStorrelse === "function" ? (template.filStorrelse as Function)(this) : template.filStorrelse): this.generate("PraksisavtaleVedleggDto", "filStorrelse", "number", "3500000", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisavtaleVedleggDto", "vedlegg", "string", "null", false),
        };
    }
    sampleArrayPraksisavtaleVedleggDto(template?: Factory<PraksisavtaleVedleggDto>, length?: number): Array<PraksisavtaleVedleggDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleVedleggDto")}).map(() => this.samplePraksisavtaleVedleggDto(template));
    }
    samplePraksisavtaleVedleggMinimalDto(template?: Factory<PraksisavtaleVedleggMinimalDto>): PraksisavtaleVedleggMinimalDto {
        if (typeof this.sampleModelProperties["PraksisavtaleVedleggMinimalDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleVedleggMinimalDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisavtaleVedleggMinimalDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisavtaleVedleggMinimalDto", "navn", "string", "Sommeravtalen for skøy på landet", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("PraksisavtaleVedleggMinimalDto", "type", "PraksisavtaleVedleggTypeDto", "null", false),
            resourceLink: template && template.resourceLink ? (typeof template.resourceLink === "function" ? (template.resourceLink as Function)(this) : template.resourceLink): this.generate("PraksisavtaleVedleggMinimalDto", "resourceLink", "string", "http://localhost/praksisavtale/1234/vedlegg/12124", false),
        };
    }
    sampleArrayPraksisavtaleVedleggMinimalDto(template?: Factory<PraksisavtaleVedleggMinimalDto>, length?: number): Array<PraksisavtaleVedleggMinimalDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleVedleggMinimalDto")}).map(() => this.samplePraksisavtaleVedleggMinimalDto(template));
    }
    samplePraksisavtaleVedleggTypeDto(template?: EnumFactory<PraksisavtaleVedleggTypeDto>): PraksisavtaleVedleggTypeDto {
        if (typeof this.sampleModelProperties["PraksisavtaleVedleggTypeDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleVedleggTypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtaleVedleggTypeDto.Samarbeidsavtale,
                PraksisavtaleVedleggTypeDto.Databehandleravtale,
                PraksisavtaleVedleggTypeDto.Annet
        ]);
    }
    sampleArrayPraksisavtaleVedleggTypeDto(template?: EnumFactory<PraksisavtaleVedleggTypeDto>, length?: number): Array<PraksisavtaleVedleggTypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleVedleggTypeDto")}).map(() => this.samplePraksisavtaleVedleggTypeDto());
    }
    samplePraksisavtalerDto(template?: Factory<PraksisavtalerDto>): PraksisavtalerDto {
        if (typeof this.sampleModelProperties["PraksisavtalerDto"] === "function") {
            return this.sampleModelProperties["PraksisavtalerDto"](this);
        }

        return {
            avtaler: template && template.avtaler ? (typeof template.avtaler === "function" ? (template.avtaler as Function)(this) : template.avtaler): this.generate("PraksisavtalerDto", "avtaler", "Array<PraksisstedavtaleDto>", "null", false),
        };
    }
    sampleArrayPraksisavtalerDto(template?: Factory<PraksisavtalerDto>, length?: number): Array<PraksisavtalerDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtalerDto")}).map(() => this.samplePraksisavtalerDto(template));
    }
    samplePraksisavtalestedStatusDto(template?: EnumFactory<PraksisavtalestedStatusDto>): PraksisavtalestedStatusDto {
        if (typeof this.sampleModelProperties["PraksisavtalestedStatusDto"] === "function") {
            return this.sampleModelProperties["PraksisavtalestedStatusDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtalestedStatusDto.Ubekreftet,
                PraksisavtalestedStatusDto.Bekreftet,
                PraksisavtalestedStatusDto.Avtalefeil,
                PraksisavtalestedStatusDto.UtenBesvarelse
        ]);
    }
    sampleArrayPraksisavtalestedStatusDto(template?: EnumFactory<PraksisavtalestedStatusDto>, length?: number): Array<PraksisavtalestedStatusDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtalestedStatusDto")}).map(() => this.samplePraksisavtalestedStatusDto());
    }
    samplePraksisgruppeDto(template?: Factory<PraksisgruppeDto>): PraksisgruppeDto {
        if (typeof this.sampleModelProperties["PraksisgruppeDto"] === "function") {
            return this.sampleModelProperties["PraksisgruppeDto"](this);
        }

        return {
            praksis: template && template.praksis ? (typeof template.praksis === "function" ? (template.praksis as Function)(this) : template.praksis): this.generate("PraksisgruppeDto", "praksis", "PraksisDto", "null", false),
            institusjoner: template && template.institusjoner ? (typeof template.institusjoner === "function" ? (template.institusjoner as Function)(this) : template.institusjoner): this.generate("PraksisgruppeDto", "institusjoner", "Array<PraksiskalenderInstitusjonerDto>", "null", false),
        };
    }
    sampleArrayPraksisgruppeDto(template?: Factory<PraksisgruppeDto>, length?: number): Array<PraksisgruppeDto> {
        return Array.from({length: length || this.arrayLength("PraksisgruppeDto")}).map(() => this.samplePraksisgruppeDto(template));
    }
    samplePraksiskalenderAktivitetDto(template?: Factory<PraksiskalenderAktivitetDto>): PraksiskalenderAktivitetDto {
        if (typeof this.sampleModelProperties["PraksiskalenderAktivitetDto"] === "function") {
            return this.sampleModelProperties["PraksiskalenderAktivitetDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksiskalenderAktivitetDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            klasseId: template && template.klasseId ? (typeof template.klasseId === "function" ? (template.klasseId as Function)(this) : template.klasseId): this.generate("PraksiskalenderAktivitetDto", "klasseId", "string", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksiskalenderAktivitetDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksiskalenderAktivitetDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            bekreftet: template && template.bekreftet ? (typeof template.bekreftet === "function" ? (template.bekreftet as Function)(this) : template.bekreftet): this.generate("PraksiskalenderAktivitetDto", "bekreftet", "boolean", "false", false),
            behov: template && template.behov ? (typeof template.behov === "function" ? (template.behov as Function)(this) : template.behov): this.generate("PraksiskalenderAktivitetDto", "behov", "number", "20", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("PraksiskalenderAktivitetDto", "kapasitet", "number", "10", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksiskalenderAktivitetDto", "status", "PraksisaktivitetStatusDto", "null", false),
        };
    }
    sampleArrayPraksiskalenderAktivitetDto(template?: Factory<PraksiskalenderAktivitetDto>, length?: number): Array<PraksiskalenderAktivitetDto> {
        return Array.from({length: length || this.arrayLength("PraksiskalenderAktivitetDto")}).map(() => this.samplePraksiskalenderAktivitetDto(template));
    }
    samplePraksiskalenderDto(template?: Factory<PraksiskalenderDto>): PraksiskalenderDto {
        if (typeof this.sampleModelProperties["PraksiskalenderDto"] === "function") {
            return this.sampleModelProperties["PraksiskalenderDto"](this);
        }

        return {
            praksisstednavn: template && template.praksisstednavn ? (typeof template.praksisstednavn === "function" ? (template.praksisstednavn as Function)(this) : template.praksisstednavn): this.generate("PraksiskalenderDto", "praksisstednavn", "string", "Sykehus", false),
            praksisgrupper: template && template.praksisgrupper ? (typeof template.praksisgrupper === "function" ? (template.praksisgrupper as Function)(this) : template.praksisgrupper): this.generate("PraksiskalenderDto", "praksisgrupper", "Array<PraksisgruppeDto>", "null", false),
            aktiviteter: template && template.aktiviteter ? (typeof template.aktiviteter === "function" ? (template.aktiviteter as Function)(this) : template.aktiviteter): this.generate("PraksiskalenderDto", "aktiviteter", "Array<PraksiskalenderAktivitetDto>", "null", false),
        };
    }
    sampleArrayPraksiskalenderDto(template?: Factory<PraksiskalenderDto>, length?: number): Array<PraksiskalenderDto> {
        return Array.from({length: length || this.arrayLength("PraksiskalenderDto")}).map(() => this.samplePraksiskalenderDto(template));
    }
    samplePraksiskalenderInstitusjonerDto(template?: Factory<PraksiskalenderInstitusjonerDto>): PraksiskalenderInstitusjonerDto {
        if (typeof this.sampleModelProperties["PraksiskalenderInstitusjonerDto"] === "function") {
            return this.sampleModelProperties["PraksiskalenderInstitusjonerDto"](this);
        }

        return {
            institusjonsnavn: template && template.institusjonsnavn ? (typeof template.institusjonsnavn === "function" ? (template.institusjonsnavn as Function)(this) : template.institusjonsnavn): this.generate("PraksiskalenderInstitusjonerDto", "institusjonsnavn", "string", "OsloMet", false),
            klasser: template && template.klasser ? (typeof template.klasser === "function" ? (template.klasser as Function)(this) : template.klasser): this.generate("PraksiskalenderInstitusjonerDto", "klasser", "Array<PraksisklasseDto>", "null", false),
        };
    }
    sampleArrayPraksiskalenderInstitusjonerDto(template?: Factory<PraksiskalenderInstitusjonerDto>, length?: number): Array<PraksiskalenderInstitusjonerDto> {
        return Array.from({length: length || this.arrayLength("PraksiskalenderInstitusjonerDto")}).map(() => this.samplePraksiskalenderInstitusjonerDto(template));
    }
    samplePraksisklasseDto(template?: Factory<PraksisklasseDto>): PraksisklasseDto {
        if (typeof this.sampleModelProperties["PraksisklasseDto"] === "function") {
            return this.sampleModelProperties["PraksisklasseDto"](this);
        }

        return {
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisklasseDto", "emne", "EmneDto", "null", false),
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisklasseDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            bokstav: template && template.bokstav ? (typeof template.bokstav === "function" ? (template.bokstav as Function)(this) : template.bokstav): this.generate("PraksisklasseDto", "bokstav", "string", "A", false),
            presentertNavn: template && template.presentertNavn ? (typeof template.presentertNavn === "function" ? (template.presentertNavn as Function)(this) : template.presentertNavn): this.generate("PraksisklasseDto", "presentertNavn", "string", "Min klasse", false),
        };
    }
    sampleArrayPraksisklasseDto(template?: Factory<PraksisklasseDto>, length?: number): Array<PraksisklasseDto> {
        return Array.from({length: length || this.arrayLength("PraksisklasseDto")}).map(() => this.samplePraksisklasseDto(template));
    }
    samplePraksisstedInfoPutDto(template?: Factory<PraksisstedInfoPutDto>): PraksisstedInfoPutDto {
        if (typeof this.sampleModelProperties["PraksisstedInfoPutDto"] === "function") {
            return this.sampleModelProperties["PraksisstedInfoPutDto"](this);
        }

        return {
            adresselinje1: template && template.adresselinje1 ? (typeof template.adresselinje1 === "function" ? (template.adresselinje1 as Function)(this) : template.adresselinje1): this.generate("PraksisstedInfoPutDto", "adresselinje1", "string", "Lorem Ipsum gate 12", false),
            adresselinje2: template && template.adresselinje2 ? (typeof template.adresselinje2 === "function" ? (template.adresselinje2 as Function)(this) : template.adresselinje2): this.generate("PraksisstedInfoPutDto", "adresselinje2", "string", "Lorem Ipsum gate 12", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("PraksisstedInfoPutDto", "postnr", "string", "0440", false),
            poststed: template && template.poststed ? (typeof template.poststed === "function" ? (template.poststed as Function)(this) : template.poststed): this.generate("PraksisstedInfoPutDto", "poststed", "string", "Oslo", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedInfoPutDto", "epost", "string", "resepsjon@lovisenbergdiakonale.no", false),
            telefonlandnr: template && template.telefonlandnr ? (typeof template.telefonlandnr === "function" ? (template.telefonlandnr as Function)(this) : template.telefonlandnr): this.generate("PraksisstedInfoPutDto", "telefonlandnr", "string", "47", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedInfoPutDto", "telefonnummer", "string", "12345678", false),
        };
    }
    sampleArrayPraksisstedInfoPutDto(template?: Factory<PraksisstedInfoPutDto>, length?: number): Array<PraksisstedInfoPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedInfoPutDto")}).map(() => this.samplePraksisstedInfoPutDto(template));
    }
    samplePraksisstedRollerDto(template?: EnumFactory<PraksisstedRollerDto>): PraksisstedRollerDto {
        if (typeof this.sampleModelProperties["PraksisstedRollerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedRollerDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisstedRollerDto.Koordinator,
                PraksisstedRollerDto.Veileder
        ]);
    }
    sampleArrayPraksisstedRollerDto(template?: EnumFactory<PraksisstedRollerDto>, length?: number): Array<PraksisstedRollerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedRollerDto")}).map(() => this.samplePraksisstedRollerDto());
    }
    samplePraksisstedTilgangerDto(template?: Factory<PraksisstedTilgangerDto>): PraksisstedTilgangerDto {
        if (typeof this.sampleModelProperties["PraksisstedTilgangerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedTilgangerDto"](this);
        }

        return {
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("PraksisstedTilgangerDto", "kanRedigere", "boolean", "null", false),
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisstedTilgangerDto", "praksissted", "MuligPraksisstedDto", "null", false),
            brukerrolle: template && template.brukerrolle ? (typeof template.brukerrolle === "function" ? (template.brukerrolle as Function)(this) : template.brukerrolle): this.generate("PraksisstedTilgangerDto", "brukerrolle", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayPraksisstedTilgangerDto(template?: Factory<PraksisstedTilgangerDto>, length?: number): Array<PraksisstedTilgangerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedTilgangerDto")}).map(() => this.samplePraksisstedTilgangerDto(template));
    }
    samplePraksisstedUndernodeDto(template?: Factory<PraksisstedUndernodeDto>): PraksisstedUndernodeDto {
        if (typeof this.sampleModelProperties["PraksisstedUndernodeDto"] === "function") {
            return this.sampleModelProperties["PraksisstedUndernodeDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedUndernodeDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedUndernodeDto", "navn", "string", "DPS, Seksjon Døgn", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.pickOne([PraksisstedUndernodeDtoStatusDtoEnum.Active,PraksisstedUndernodeDtoStatusDtoEnum.Deleted]),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("PraksisstedUndernodeDto", "under", "Array<PraksisstedUndernodeDto>", "null", false),
        };
    }
    sampleArrayPraksisstedUndernodeDto(template?: Factory<PraksisstedUndernodeDto>, length?: number): Array<PraksisstedUndernodeDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedUndernodeDto")}).map(() => this.samplePraksisstedUndernodeDto(template));
    }
    samplePraksisstedavtaleAllOfDto(template?: Factory<PraksisstedavtaleAllOfDto>): PraksisstedavtaleAllOfDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleAllOfDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleAllOfDto"](this);
        }

        return {
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleAllOfDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleAllOfDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleAllOfDto(template?: Factory<PraksisstedavtaleAllOfDto>, length?: number): Array<PraksisstedavtaleAllOfDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleAllOfDto")}).map(() => this.samplePraksisstedavtaleAllOfDto(template));
    }
    samplePraksisstedavtaleCommonDto(template?: Factory<PraksisstedavtaleCommonDto>): PraksisstedavtaleCommonDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleCommonDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleCommonDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("PraksisstedavtaleCommonDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedavtaleCommonDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("PraksisstedavtaleCommonDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisstedavtaleCommonDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("PraksisstedavtaleCommonDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("PraksisstedavtaleCommonDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("PraksisstedavtaleCommonDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("PraksisstedavtaleCommonDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("PraksisstedavtaleCommonDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("PraksisstedavtaleCommonDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("PraksisstedavtaleCommonDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisstedavtaleCommonDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisstedavtaleCommonDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisstedavtaleCommonDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisstedavtaleCommonDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisstedavtaleCommonDto", "kanEndre", "boolean", "false", false),
        };
    }
    sampleArrayPraksisstedavtaleCommonDto(template?: Factory<PraksisstedavtaleCommonDto>, length?: number): Array<PraksisstedavtaleCommonDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleCommonDto")}).map(() => this.samplePraksisstedavtaleCommonDto(template));
    }
    samplePraksisstedavtaleDto(template?: Factory<PraksisstedavtaleDto>): PraksisstedavtaleDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("PraksisstedavtaleDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedavtaleDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("PraksisstedavtaleDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisstedavtaleDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("PraksisstedavtaleDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("PraksisstedavtaleDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("PraksisstedavtaleDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("PraksisstedavtaleDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("PraksisstedavtaleDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("PraksisstedavtaleDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("PraksisstedavtaleDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisstedavtaleDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisstedavtaleDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisstedavtaleDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisstedavtaleDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisstedavtaleDto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstedDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleDto(template?: Factory<PraksisstedavtaleDto>, length?: number): Array<PraksisstedavtaleDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleDto")}).map(() => this.samplePraksisstedavtaleDto(template));
    }
    samplePraksisstedavtaleMedStedForelderHierarkiAllOfDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiAllOfDto>): PraksisstedavtaleMedStedForelderHierarkiAllOfDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiAllOfDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiAllOfDto"](this);
        }

        return {
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleMedStedForelderHierarkiAllOfDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleMedStedForelderHierarkiAllOfDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleMedStedForelderHierarkiAllOfDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiAllOfDto>, length?: number): Array<PraksisstedavtaleMedStedForelderHierarkiAllOfDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleMedStedForelderHierarkiAllOfDto")}).map(() => this.samplePraksisstedavtaleMedStedForelderHierarkiAllOfDto(template));
    }
    samplePraksisstedavtaleMedStedForelderHierarkiDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiDto>): PraksisstedavtaleMedStedForelderHierarkiDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleMedStedForelderHierarkiDto"](this);
        }

        return {
            view: template && template.view ? (typeof template.view === "function" ? (template.view as Function)(this) : template.view): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "view", "PraksisstedavtaleViewDto", "null", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleId", "string", "83c38dde-6225-11eb-94fc-1f59c470cdcc", false),
            avtaleversjon: template && template.avtaleversjon ? (typeof template.avtaleversjon === "function" ? (template.avtaleversjon as Function)(this) : template.avtaleversjon): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleversjon", "number", "1", false),
            avtalenavn: template && template.avtalenavn ? (typeof template.avtalenavn === "function" ? (template.avtalenavn as Function)(this) : template.avtalenavn): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalenavn", "string", "Grunnskolepraksis i ALP", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            signatarer: template && template.signatarer ? (typeof template.signatarer === "function" ? (template.signatarer as Function)(this) : template.signatarer): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "signatarer", "MultiSignatarerDto", "null", false),
            saksansvarlig: template && template.saksansvarlig ? (typeof template.saksansvarlig === "function" ? (template.saksansvarlig as Function)(this) : template.saksansvarlig): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "saksansvarlig", "string", "null", false),
            avtaleparter: template && template.avtaleparter ? (typeof template.avtaleparter === "function" ? (template.avtaleparter as Function)(this) : template.avtaleparter): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleparter", "number", "5", false),
            praksistyper: template && template.praksistyper ? (typeof template.praksistyper === "function" ? (template.praksistyper as Function)(this) : template.praksistyper): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "praksistyper", "Array<PraksistypeDto>", "null", false),
            avtalestatus: template && template.avtalestatus ? (typeof template.avtalestatus === "function" ? (template.avtalestatus as Function)(this) : template.avtalestatus): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalestatus", "AvtalestatusDto", "null", false),
            valideringsfeil: template && template.valideringsfeil ? (typeof template.valideringsfeil === "function" ? (template.valideringsfeil as Function)(this) : template.valideringsfeil): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "valideringsfeil", "Array<PraksisavtaleValideringsfeilDto>", "null", false),
            avtaleErSignertAvAlle: template && template.avtaleErSignertAvAlle ? (typeof template.avtaleErSignertAvAlle === "function" ? (template.avtaleErSignertAvAlle as Function)(this) : template.avtaleErSignertAvAlle): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleErSignertAvAlle", "boolean", "false", false),
            delIdentitetsnummer: template && template.delIdentitetsnummer ? (typeof template.delIdentitetsnummer === "function" ? (template.delIdentitetsnummer as Function)(this) : template.delIdentitetsnummer): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "delIdentitetsnummer", "boolean", "false", false),
            vedlegg: template && template.vedlegg ? (typeof template.vedlegg === "function" ? (template.vedlegg as Function)(this) : template.vedlegg): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "vedlegg", "Array<PraksisavtaleVedleggMinimalDto>", "null", false),
            kanEndre: template && template.kanEndre ? (typeof template.kanEndre === "function" ? (template.kanEndre as Function)(this) : template.kanEndre): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "kanEndre", "boolean", "false", false),
            avtaleeier: template && template.avtaleeier ? (typeof template.avtaleeier === "function" ? (template.avtaleeier as Function)(this) : template.avtaleeier): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtaleeier", "EierAvtalestedMedMuligeOmfattedeStudiestedMedForelderHierarkiDto", "null", false),
            avtalesteder: template && template.avtalesteder ? (typeof template.avtalesteder === "function" ? (template.avtalesteder as Function)(this) : template.avtalesteder): this.generate("PraksisstedavtaleMedStedForelderHierarkiDto", "avtalesteder", "{ [key: string]: AvtalestederMedMuligeOmfattedePraksisstederMedForelderHierarkiDto; }", "null", false),
        };
    }
    sampleArrayPraksisstedavtaleMedStedForelderHierarkiDto(template?: Factory<PraksisstedavtaleMedStedForelderHierarkiDto>, length?: number): Array<PraksisstedavtaleMedStedForelderHierarkiDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleMedStedForelderHierarkiDto")}).map(() => this.samplePraksisstedavtaleMedStedForelderHierarkiDto(template));
    }
    samplePraksisstedavtaleViewDto(template?: EnumFactory<PraksisstedavtaleViewDto>): PraksisstedavtaleViewDto {
        if (typeof this.sampleModelProperties["PraksisstedavtaleViewDto"] === "function") {
            return this.sampleModelProperties["PraksisstedavtaleViewDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisstedavtaleViewDto.Praksisstedavtale,
                PraksisstedavtaleViewDto.PraksisstedavtaleMedStedForelderHierarki
        ]);
    }
    sampleArrayPraksisstedavtaleViewDto(template?: EnumFactory<PraksisstedavtaleViewDto>, length?: number): Array<PraksisstedavtaleViewDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedavtaleViewDto")}).map(() => this.samplePraksisstedavtaleViewDto());
    }
    samplePraksisstedbrukerDto(template?: Factory<PraksisstedbrukerDto>): PraksisstedbrukerDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedbrukerDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("PraksisstedbrukerDto", "fornavn", "string", "Ola Nordmann", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("PraksisstedbrukerDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedbrukerDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedbrukerDto", "telefonnummer", "string", "12345678", false),
            tilgangsrolle: template && template.tilgangsrolle ? (typeof template.tilgangsrolle === "function" ? (template.tilgangsrolle as Function)(this) : template.tilgangsrolle): this.generate("PraksisstedbrukerDto", "tilgangsrolle", "BrukerrollerDto", "null", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisstedbrukerDto", "status", "BrukerstatusDto", "null", false),
            kanSlette: template && template.kanSlette ? (typeof template.kanSlette === "function" ? (template.kanSlette as Function)(this) : template.kanSlette): this.generate("PraksisstedbrukerDto", "kanSlette", "boolean", "null", false),
            tilhorighet: template && template.tilhorighet ? (typeof template.tilhorighet === "function" ? (template.tilhorighet as Function)(this) : template.tilhorighet): this.generate("PraksisstedbrukerDto", "tilhorighet", "PraksisstedTilgangerDto", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerDto(template?: Factory<PraksisstedbrukerDto>, length?: number): Array<PraksisstedbrukerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerDto")}).map(() => this.samplePraksisstedbrukerDto(template));
    }
    samplePraksisstedbrukerSignatarDto(template?: Factory<PraksisstedbrukerSignatarDto>): PraksisstedbrukerSignatarDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerSignatarDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerSignatarDto"](this);
        }

        return {
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("PraksisstedbrukerSignatarDto", "praksisstedId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("PraksisstedbrukerSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("PraksisstedbrukerSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedbrukerSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedbrukerSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerSignatarDto(template?: Factory<PraksisstedbrukerSignatarDto>, length?: number): Array<PraksisstedbrukerSignatarDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerSignatarDto")}).map(() => this.samplePraksisstedbrukerSignatarDto(template));
    }
    samplePraksisstedbrukerprofilDto(template?: Factory<PraksisstedbrukerprofilDto>): PraksisstedbrukerprofilDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerprofilDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerprofilDto"](this);
        }

        return {
            bruker: template && template.bruker ? (typeof template.bruker === "function" ? (template.bruker as Function)(this) : template.bruker): this.generate("PraksisstedbrukerprofilDto", "bruker", "PraksisstedbrukerDto", "null", false),
            omMeg: template && template.omMeg ? (typeof template.omMeg === "function" ? (template.omMeg as Function)(this) : template.omMeg): this.generate("PraksisstedbrukerprofilDto", "omMeg", "string", "Jeg er veldig glad i øl", false),
            bildeUrl: template && template.bildeUrl ? (typeof template.bildeUrl === "function" ? (template.bildeUrl as Function)(this) : template.bildeUrl): this.generate("PraksisstedbrukerprofilDto", "bildeUrl", "string", "bilde.png", false),
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("PraksisstedbrukerprofilDto", "kanRedigere", "boolean", "null", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("PraksisstedbrukerprofilDto", "tilganger", "Array<PraksisstedTilgangerDto>", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerprofilDto(template?: Factory<PraksisstedbrukerprofilDto>, length?: number): Array<PraksisstedbrukerprofilDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerprofilDto")}).map(() => this.samplePraksisstedbrukerprofilDto(template));
    }
    samplePraksisstedbrukerprofilPutDto(template?: Factory<PraksisstedbrukerprofilPutDto>): PraksisstedbrukerprofilPutDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerprofilPutDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerprofilPutDto"](this);
        }

        return {
            omMeg: template && template.omMeg ? (typeof template.omMeg === "function" ? (template.omMeg as Function)(this) : template.omMeg): this.generate("PraksisstedbrukerprofilPutDto", "omMeg", "string", "Jeg liker vin også", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("PraksisstedbrukerprofilPutDto", "fornavn", "string", "null", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("PraksisstedbrukerprofilPutDto", "etternavn", "string", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedbrukerprofilPutDto", "epost", "string", "null", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedbrukerprofilPutDto", "telefonnummer", "string", "null", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("PraksisstedbrukerprofilPutDto", "tilganger", "Array<PraksisstedbrukerprofilPutTilgangerInnerDto>", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerprofilPutDto(template?: Factory<PraksisstedbrukerprofilPutDto>, length?: number): Array<PraksisstedbrukerprofilPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerprofilPutDto")}).map(() => this.samplePraksisstedbrukerprofilPutDto(template));
    }
    samplePraksisstedbrukerprofilPutTilgangerInnerDto(template?: Factory<PraksisstedbrukerprofilPutTilgangerInnerDto>): PraksisstedbrukerprofilPutTilgangerInnerDto {
        if (typeof this.sampleModelProperties["PraksisstedbrukerprofilPutTilgangerInnerDto"] === "function") {
            return this.sampleModelProperties["PraksisstedbrukerprofilPutTilgangerInnerDto"](this);
        }

        return {
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("PraksisstedbrukerprofilPutTilgangerInnerDto", "praksisstedId", "string", "null", false),
            tilgangsrolle: template && template.tilgangsrolle ? (typeof template.tilgangsrolle === "function" ? (template.tilgangsrolle as Function)(this) : template.tilgangsrolle): this.generate("PraksisstedbrukerprofilPutTilgangerInnerDto", "tilgangsrolle", "BrukerrollerDto", "null", false),
        };
    }
    sampleArrayPraksisstedbrukerprofilPutTilgangerInnerDto(template?: Factory<PraksisstedbrukerprofilPutTilgangerInnerDto>, length?: number): Array<PraksisstedbrukerprofilPutTilgangerInnerDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedbrukerprofilPutTilgangerInnerDto")}).map(() => this.samplePraksisstedbrukerprofilPutTilgangerInnerDto(template));
    }
    samplePraksisstedprofilAdresseDto(template?: Factory<PraksisstedprofilAdresseDto>): PraksisstedprofilAdresseDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilAdresseDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilAdresseDto"](this);
        }

        return {
            adresselinje1: template && template.adresselinje1 ? (typeof template.adresselinje1 === "function" ? (template.adresselinje1 as Function)(this) : template.adresselinje1): this.generate("PraksisstedprofilAdresseDto", "adresselinje1", "string", "Lorem Ipsum gate 12", false),
            adresselinje2: template && template.adresselinje2 ? (typeof template.adresselinje2 === "function" ? (template.adresselinje2 as Function)(this) : template.adresselinje2): this.generate("PraksisstedprofilAdresseDto", "adresselinje2", "string", "1. etasje", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("PraksisstedprofilAdresseDto", "postnr", "string", "0440", false),
            poststed: template && template.poststed ? (typeof template.poststed === "function" ? (template.poststed as Function)(this) : template.poststed): this.generate("PraksisstedprofilAdresseDto", "poststed", "string", "Oslo", false),
        };
    }
    sampleArrayPraksisstedprofilAdresseDto(template?: Factory<PraksisstedprofilAdresseDto>, length?: number): Array<PraksisstedprofilAdresseDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilAdresseDto")}).map(() => this.samplePraksisstedprofilAdresseDto(template));
    }
    samplePraksisstedprofilDto(template?: Factory<PraksisstedprofilDto>): PraksisstedprofilDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedprofilDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedprofilDto", "navn", "string", "Lovisenberg Diakonale Sykehus", false),
            orgnr: template && template.orgnr ? (typeof template.orgnr === "function" ? (template.orgnr as Function)(this) : template.orgnr): this.generate("PraksisstedprofilDto", "orgnr", "string", "123423413412", false),
            avdeling: template && template.avdeling ? (typeof template.avdeling === "function" ? (template.avdeling as Function)(this) : template.avdeling): this.generate("PraksisstedprofilDto", "avdeling", "MinimalPraksisstedDto", "null", false),
            adresse: template && template.adresse ? (typeof template.adresse === "function" ? (template.adresse as Function)(this) : template.adresse): this.generate("PraksisstedprofilDto", "adresse", "PraksisstedprofilAdresseDto", "null", false),
            nettsideUrl: template && template.nettsideUrl ? (typeof template.nettsideUrl === "function" ? (template.nettsideUrl as Function)(this) : template.nettsideUrl): this.generate("PraksisstedprofilDto", "nettsideUrl", "string", "https://lovisenbergdiakonale.no", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedprofilDto", "epost", "string", "resepsjon@lovisenbergdiakonale.no", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedprofilDto", "telefonnummer", "string", "12345678", false),
            telefonlandnr: template && template.telefonlandnr ? (typeof template.telefonlandnr === "function" ? (template.telefonlandnr as Function)(this) : template.telefonlandnr): this.generate("PraksisstedprofilDto", "telefonlandnr", "string", "+47", false),
            bildeId: template && template.bildeId ? (typeof template.bildeId === "function" ? (template.bildeId as Function)(this) : template.bildeId): this.generate("PraksisstedprofilDto", "bildeId", "string", "null", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("PraksisstedprofilDto", "beskrivelse", "string", "Lorem Ipsum", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisstedprofilDto", "krav", "string", "Personlig egnethet", false),
            noder: template && template.noder ? (typeof template.noder === "function" ? (template.noder as Function)(this) : template.noder): this.generate("PraksisstedprofilDto", "noder", "PraksisstedprofilNoderDto", "null", false),
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("PraksisstedprofilDto", "kanRedigere", "boolean", "null", false),
            erAdmin: template && template.erAdmin ? (typeof template.erAdmin === "function" ? (template.erAdmin as Function)(this) : template.erAdmin): this.generate("PraksisstedprofilDto", "erAdmin", "boolean", "null", false),
            sistEndret: template && template.sistEndret ? (typeof template.sistEndret === "function" ? (template.sistEndret as Function)(this) : template.sistEndret): this.generate("PraksisstedprofilDto", "sistEndret", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            sistEndretAvStudiestedbruker: template && template.sistEndretAvStudiestedbruker ? (typeof template.sistEndretAvStudiestedbruker === "function" ? (template.sistEndretAvStudiestedbruker as Function)(this) : template.sistEndretAvStudiestedbruker): this.generate("PraksisstedprofilDto", "sistEndretAvStudiestedbruker", "PersonDto", "null", false),
            sistEndretAvPraksisstedbruker: template && template.sistEndretAvPraksisstedbruker ? (typeof template.sistEndretAvPraksisstedbruker === "function" ? (template.sistEndretAvPraksisstedbruker as Function)(this) : template.sistEndretAvPraksisstedbruker): this.generate("PraksisstedprofilDto", "sistEndretAvPraksisstedbruker", "PersonDto", "null", false),
        };
    }
    sampleArrayPraksisstedprofilDto(template?: Factory<PraksisstedprofilDto>, length?: number): Array<PraksisstedprofilDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilDto")}).map(() => this.samplePraksisstedprofilDto(template));
    }
    samplePraksisstedprofilNoderDto(template?: Factory<PraksisstedprofilNoderDto>): PraksisstedprofilNoderDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilNoderDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilNoderDto"](this);
        }

        return {
            over: template && template.over ? (typeof template.over === "function" ? (template.over as Function)(this) : template.over): this.generate("PraksisstedprofilNoderDto", "over", "Array<MinimalPraksisstedDto>", "null", false),
            under: template && template.under ? (typeof template.under === "function" ? (template.under as Function)(this) : template.under): this.generate("PraksisstedprofilNoderDto", "under", "Array<MinimalPraksisstedprofilDto>", "null", false),
        };
    }
    sampleArrayPraksisstedprofilNoderDto(template?: Factory<PraksisstedprofilNoderDto>, length?: number): Array<PraksisstedprofilNoderDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilNoderDto")}).map(() => this.samplePraksisstedprofilNoderDto(template));
    }
    samplePraksisstedprofilPutDto(template?: Factory<PraksisstedprofilPutDto>): PraksisstedprofilPutDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilPutDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilPutDto"](this);
        }

        return {
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("PraksisstedprofilPutDto", "beskrivelse", "string", "Lorem Ipsum", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisstedprofilPutDto", "krav", "string", "Personlig egnethet", false),
        };
    }
    sampleArrayPraksisstedprofilPutDto(template?: Factory<PraksisstedprofilPutDto>, length?: number): Array<PraksisstedprofilPutDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilPutDto")}).map(() => this.samplePraksisstedprofilPutDto(template));
    }
    samplePraksistypeDto(template?: Factory<PraksistypeDto>): PraksistypeDto {
        if (typeof this.sampleModelProperties["PraksistypeDto"] === "function") {
            return this.sampleModelProperties["PraksistypeDto"](this);
        }

        return {
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("PraksistypeDto", "kode", "string", "ABC123", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksistypeDto", "navn", "string", "Grunnleggende sykepleie", false),
        };
    }
    sampleArrayPraksistypeDto(template?: Factory<PraksistypeDto>, length?: number): Array<PraksistypeDto> {
        return Array.from({length: length || this.arrayLength("PraksistypeDto")}).map(() => this.samplePraksistypeDto(template));
    }
    sampleRolleDto(template?: Factory<RolleDto>): RolleDto {
        if (typeof this.sampleModelProperties["RolleDto"] === "function") {
            return this.sampleModelProperties["RolleDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("RolleDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("RolleDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("RolleDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("RolleDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("RolleDto", "telefonnummer", "string", "12345678", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("RolleDto", "type", "RolleTypeDto", "null", false),
            slettet: template && template.slettet ? (typeof template.slettet === "function" ? (template.slettet as Function)(this) : template.slettet): this.generate("RolleDto", "slettet", "boolean", "false", false),
        };
    }
    sampleArrayRolleDto(template?: Factory<RolleDto>, length?: number): Array<RolleDto> {
        return Array.from({length: length || this.arrayLength("RolleDto")}).map(() => this.sampleRolleDto(template));
    }
    sampleRolleTypeDto(template?: Factory<RolleTypeDto>): RolleTypeDto {
        if (typeof this.sampleModelProperties["RolleTypeDto"] === "function") {
            return this.sampleModelProperties["RolleTypeDto"](this);
        }

        return {
            studiestedrolle: template && template.studiestedrolle ? (typeof template.studiestedrolle === "function" ? (template.studiestedrolle as Function)(this) : template.studiestedrolle): this.generate("RolleTypeDto", "studiestedrolle", "StudiestedRollerDto", "null", false),
            praksisstedrolle: template && template.praksisstedrolle ? (typeof template.praksisstedrolle === "function" ? (template.praksisstedrolle as Function)(this) : template.praksisstedrolle): this.generate("RolleTypeDto", "praksisstedrolle", "PraksisstedRollerDto", "null", false),
        };
    }
    sampleArrayRolleTypeDto(template?: Factory<RolleTypeDto>, length?: number): Array<RolleTypeDto> {
        return Array.from({length: length || this.arrayLength("RolleTypeDto")}).map(() => this.sampleRolleTypeDto(template));
    }
    sampleStudentPaaPraksisstedDto(template?: Factory<StudentPaaPraksisstedDto>): StudentPaaPraksisstedDto {
        if (typeof this.sampleModelProperties["StudentPaaPraksisstedDto"] === "function") {
            return this.sampleModelProperties["StudentPaaPraksisstedDto"](this);
        }

        return {
            student: template && template.student ? (typeof template.student === "function" ? (template.student as Function)(this) : template.student): this.generate("StudentPaaPraksisstedDto", "student", "StudentbrukerDto", "null", false),
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("StudentPaaPraksisstedDto", "praksissted", "MinimalPraksisstedDto", "null", false),
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("StudentPaaPraksisstedDto", "emne", "EmneDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("StudentPaaPraksisstedDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("StudentPaaPraksisstedDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
        };
    }
    sampleArrayStudentPaaPraksisstedDto(template?: Factory<StudentPaaPraksisstedDto>, length?: number): Array<StudentPaaPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("StudentPaaPraksisstedDto")}).map(() => this.sampleStudentPaaPraksisstedDto(template));
    }
    sampleStudentVurderingDto(template?: Factory<StudentVurderingDto>): StudentVurderingDto {
        if (typeof this.sampleModelProperties["StudentVurderingDto"] === "function") {
            return this.sampleModelProperties["StudentVurderingDto"](this);
        }

        return {
            studentVurderingId: template && template.studentVurderingId ? (typeof template.studentVurderingId === "function" ? (template.studentVurderingId as Function)(this) : template.studentVurderingId): this.generate("StudentVurderingDto", "studentVurderingId", "string", "9251b7fc-011d-11ed-a72e-03e4c1502862", false),
            student: template && template.student ? (typeof template.student === "function" ? (template.student as Function)(this) : template.student): this.generate("StudentVurderingDto", "student", "VurderingStudentDto", "null", false),
            vurderingsstatus: template && template.vurderingsstatus ? (typeof template.vurderingsstatus === "function" ? (template.vurderingsstatus as Function)(this) : template.vurderingsstatus): this.pickOne([StudentVurderingDtoVurderingsstatusDtoEnum.Aktiv,StudentVurderingDtoVurderingsstatusDtoEnum.AvbruttPraksis,StudentVurderingDtoVurderingsstatusDtoEnum.PraksisFullfrt]),
            studiestedNavn: template && template.studiestedNavn ? (typeof template.studiestedNavn === "function" ? (template.studiestedNavn as Function)(this) : template.studiestedNavn): this.generate("StudentVurderingDto", "studiestedNavn", "string", "null", false),
        };
    }
    sampleArrayStudentVurderingDto(template?: Factory<StudentVurderingDto>, length?: number): Array<StudentVurderingDto> {
        return Array.from({length: length || this.arrayLength("StudentVurderingDto")}).map(() => this.sampleStudentVurderingDto(template));
    }
    sampleStudentbrukerDto(template?: Factory<StudentbrukerDto>): StudentbrukerDto {
        if (typeof this.sampleModelProperties["StudentbrukerDto"] === "function") {
            return this.sampleModelProperties["StudentbrukerDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudentbrukerDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudentbrukerDto", "fornavn", "string", "Ola Nordmann", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudentbrukerDto", "etternavn", "string", "Nordmann", false),
            studiestednavn: template && template.studiestednavn ? (typeof template.studiestednavn === "function" ? (template.studiestednavn as Function)(this) : template.studiestednavn): this.generate("StudentbrukerDto", "studiestednavn", "string", "Universistetet i Oslo", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudentbrukerDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("StudentbrukerDto", "telefonnummer", "string", "12345678", false),
        };
    }
    sampleArrayStudentbrukerDto(template?: Factory<StudentbrukerDto>, length?: number): Array<StudentbrukerDto> {
        return Array.from({length: length || this.arrayLength("StudentbrukerDto")}).map(() => this.sampleStudentbrukerDto(template));
    }
    sampleStudentbrukerprofilDto(template?: Factory<StudentbrukerprofilDto>): StudentbrukerprofilDto {
        if (typeof this.sampleModelProperties["StudentbrukerprofilDto"] === "function") {
            return this.sampleModelProperties["StudentbrukerprofilDto"](this);
        }

        return {
            bruker: template && template.bruker ? (typeof template.bruker === "function" ? (template.bruker as Function)(this) : template.bruker): this.generate("StudentbrukerprofilDto", "bruker", "StudentbrukerDto", "null", false),
        };
    }
    sampleArrayStudentbrukerprofilDto(template?: Factory<StudentbrukerprofilDto>, length?: number): Array<StudentbrukerprofilDto> {
        return Array.from({length: length || this.arrayLength("StudentbrukerprofilDto")}).map(() => this.sampleStudentbrukerprofilDto(template));
    }
    sampleStudenterForVurderingDto(template?: Factory<StudenterForVurderingDto>): StudenterForVurderingDto {
        if (typeof this.sampleModelProperties["StudenterForVurderingDto"] === "function") {
            return this.sampleModelProperties["StudenterForVurderingDto"](this);
        }

        return {
            studenter: template && template.studenter ? (typeof template.studenter === "function" ? (template.studenter as Function)(this) : template.studenter): this.generate("StudenterForVurderingDto", "studenter", "Array<StudentVurderingDto>", "null", false),
        };
    }
    sampleArrayStudenterForVurderingDto(template?: Factory<StudenterForVurderingDto>, length?: number): Array<StudenterForVurderingDto> {
        return Array.from({length: length || this.arrayLength("StudenterForVurderingDto")}).map(() => this.sampleStudenterForVurderingDto(template));
    }
    sampleStudenterPaaPraksisstedDto(template?: Factory<StudenterPaaPraksisstedDto>): StudenterPaaPraksisstedDto {
        if (typeof this.sampleModelProperties["StudenterPaaPraksisstedDto"] === "function") {
            return this.sampleModelProperties["StudenterPaaPraksisstedDto"](this);
        }

        return {
            gamle: template && template.gamle ? (typeof template.gamle === "function" ? (template.gamle as Function)(this) : template.gamle): this.generate("StudenterPaaPraksisstedDto", "gamle", "Array<StudentPaaPraksisstedDto>", "null", false),
            aktive: template && template.aktive ? (typeof template.aktive === "function" ? (template.aktive as Function)(this) : template.aktive): this.generate("StudenterPaaPraksisstedDto", "aktive", "Array<StudentPaaPraksisstedDto>", "null", false),
            fremtidige: template && template.fremtidige ? (typeof template.fremtidige === "function" ? (template.fremtidige as Function)(this) : template.fremtidige): this.generate("StudenterPaaPraksisstedDto", "fremtidige", "Array<StudentPaaPraksisstedDto>", "null", false),
        };
    }
    sampleArrayStudenterPaaPraksisstedDto(template?: Factory<StudenterPaaPraksisstedDto>, length?: number): Array<StudenterPaaPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("StudenterPaaPraksisstedDto")}).map(() => this.sampleStudenterPaaPraksisstedDto(template));
    }
    sampleStudentfordelingDto(template?: Factory<StudentfordelingDto>): StudentfordelingDto {
        if (typeof this.sampleModelProperties["StudentfordelingDto"] === "function") {
            return this.sampleModelProperties["StudentfordelingDto"](this);
        }

        return {
            student: template && template.student ? (typeof template.student === "function" ? (template.student as Function)(this) : template.student): this.generate("StudentfordelingDto", "student", "PersonDto", "null", false),
            undervisere: template && template.undervisere ? (typeof template.undervisere === "function" ? (template.undervisere as Function)(this) : template.undervisere): this.generate("StudentfordelingDto", "undervisere", "Array<PersonDto>", "null", false),
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("StudentfordelingDto", "praksissted", "MinimalPraksisstedDto", "null", false),
            veiledere: template && template.veiledere ? (typeof template.veiledere === "function" ? (template.veiledere as Function)(this) : template.veiledere): this.generate("StudentfordelingDto", "veiledere", "Array<PersonDto>", "null", false),
            muligeVeiledere: template && template.muligeVeiledere ? (typeof template.muligeVeiledere === "function" ? (template.muligeVeiledere as Function)(this) : template.muligeVeiledere): this.generate("StudentfordelingDto", "muligeVeiledere", "Array<PersonDto>", "null", false),
            avtalefeil: template && template.avtalefeil ? (typeof template.avtalefeil === "function" ? (template.avtalefeil as Function)(this) : template.avtalefeil): this.generate("StudentfordelingDto", "avtalefeil", "boolean", "null", false),
        };
    }
    sampleArrayStudentfordelingDto(template?: Factory<StudentfordelingDto>, length?: number): Array<StudentfordelingDto> {
        return Array.from({length: length || this.arrayLength("StudentfordelingDto")}).map(() => this.sampleStudentfordelingDto(template));
    }
    sampleStudentfordelingMedValgDto(template?: Factory<StudentfordelingMedValgDto>): StudentfordelingMedValgDto {
        if (typeof this.sampleModelProperties["StudentfordelingMedValgDto"] === "function") {
            return this.sampleModelProperties["StudentfordelingMedValgDto"](this);
        }

        return {
            studentfordeling: template && template.studentfordeling ? (typeof template.studentfordeling === "function" ? (template.studentfordeling as Function)(this) : template.studentfordeling): this.generate("StudentfordelingMedValgDto", "studentfordeling", "Array<StudentfordelingDto>", "null", false),
        };
    }
    sampleArrayStudentfordelingMedValgDto(template?: Factory<StudentfordelingMedValgDto>, length?: number): Array<StudentfordelingMedValgDto> {
        return Array.from({length: length || this.arrayLength("StudentfordelingMedValgDto")}).map(() => this.sampleStudentfordelingMedValgDto(template));
    }
    sampleStudentfordelingPutDto(template?: Factory<StudentfordelingPutDto>): StudentfordelingPutDto {
        if (typeof this.sampleModelProperties["StudentfordelingPutDto"] === "function") {
            return this.sampleModelProperties["StudentfordelingPutDto"](this);
        }

        return {
            studentId: template && template.studentId ? (typeof template.studentId === "function" ? (template.studentId as Function)(this) : template.studentId): this.generate("StudentfordelingPutDto", "studentId", "string", "null", false),
            veilederIder: template && template.veilederIder ? (typeof template.veilederIder === "function" ? (template.veilederIder as Function)(this) : template.veilederIder): this.generate("StudentfordelingPutDto", "veilederIder", "Array<string>", "null", false),
        };
    }
    sampleArrayStudentfordelingPutDto(template?: Factory<StudentfordelingPutDto>, length?: number): Array<StudentfordelingPutDto> {
        return Array.from({length: length || this.arrayLength("StudentfordelingPutDto")}).map(() => this.sampleStudentfordelingPutDto(template));
    }
    sampleStudiestedDto(template?: Factory<StudiestedDto>): StudiestedDto {
        if (typeof this.sampleModelProperties["StudiestedDto"] === "function") {
            return this.sampleModelProperties["StudiestedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudiestedDto", "id", "string", "0aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("StudiestedDto", "navn", "Array<string>", "[Avdeling, Sengepost]", false),
        };
    }
    sampleArrayStudiestedDto(template?: Factory<StudiestedDto>, length?: number): Array<StudiestedDto> {
        return Array.from({length: length || this.arrayLength("StudiestedDto")}).map(() => this.sampleStudiestedDto(template));
    }
    sampleStudiestedRollerDto(template?: EnumFactory<StudiestedRollerDto>): StudiestedRollerDto {
        if (typeof this.sampleModelProperties["StudiestedRollerDto"] === "function") {
            return this.sampleModelProperties["StudiestedRollerDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                StudiestedRollerDto.Koordinator,
                StudiestedRollerDto.Underviser
        ]);
    }
    sampleArrayStudiestedRollerDto(template?: EnumFactory<StudiestedRollerDto>, length?: number): Array<StudiestedRollerDto> {
        return Array.from({length: length || this.arrayLength("StudiestedRollerDto")}).map(() => this.sampleStudiestedRollerDto());
    }
    sampleStudiestedbrukerDto(template?: Factory<StudiestedbrukerDto>): StudiestedbrukerDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudiestedbrukerDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudiestedbrukerDto", "fornavn", "string", "Ola Nordmann", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudiestedbrukerDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudiestedbrukerDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("StudiestedbrukerDto", "telefonnummer", "string", "12345678", false),
        };
    }
    sampleArrayStudiestedbrukerDto(template?: Factory<StudiestedbrukerDto>, length?: number): Array<StudiestedbrukerDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerDto")}).map(() => this.sampleStudiestedbrukerDto(template));
    }
    sampleStudiestedbrukerSignatarDto(template?: Factory<StudiestedbrukerSignatarDto>): StudiestedbrukerSignatarDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerSignatarDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerSignatarDto"](this);
        }

        return {
            studiestedId: template && template.studiestedId ? (typeof template.studiestedId === "function" ? (template.studiestedId as Function)(this) : template.studiestedId): this.generate("StudiestedbrukerSignatarDto", "studiestedId", "string", "null", false),
            studiestedbrukerId: template && template.studiestedbrukerId ? (typeof template.studiestedbrukerId === "function" ? (template.studiestedbrukerId as Function)(this) : template.studiestedbrukerId): this.generate("StudiestedbrukerSignatarDto", "studiestedbrukerId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudiestedbrukerSignatarDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudiestedbrukerSignatarDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudiestedbrukerSignatarDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("StudiestedbrukerSignatarDto", "telefonnummer", "string", "null", false),
        };
    }
    sampleArrayStudiestedbrukerSignatarDto(template?: Factory<StudiestedbrukerSignatarDto>, length?: number): Array<StudiestedbrukerSignatarDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerSignatarDto")}).map(() => this.sampleStudiestedbrukerSignatarDto(template));
    }
    sampleStudiestedbrukerprofilDto(template?: Factory<StudiestedbrukerprofilDto>): StudiestedbrukerprofilDto {
        if (typeof this.sampleModelProperties["StudiestedbrukerprofilDto"] === "function") {
            return this.sampleModelProperties["StudiestedbrukerprofilDto"](this);
        }

        return {
            bruker: template && template.bruker ? (typeof template.bruker === "function" ? (template.bruker as Function)(this) : template.bruker): this.generate("StudiestedbrukerprofilDto", "bruker", "StudiestedbrukerDto", "null", false),
            omMeg: template && template.omMeg ? (typeof template.omMeg === "function" ? (template.omMeg as Function)(this) : template.omMeg): this.generate("StudiestedbrukerprofilDto", "omMeg", "string", "Jeg er veldig glad i øl", false),
            bildeUrl: template && template.bildeUrl ? (typeof template.bildeUrl === "function" ? (template.bildeUrl as Function)(this) : template.bildeUrl): this.generate("StudiestedbrukerprofilDto", "bildeUrl", "string", "bilde.png", false),
            kanRedigere: template && template.kanRedigere ? (typeof template.kanRedigere === "function" ? (template.kanRedigere as Function)(this) : template.kanRedigere): this.generate("StudiestedbrukerprofilDto", "kanRedigere", "boolean", "null", false),
            studiestedNavn: template && template.studiestedNavn ? (typeof template.studiestedNavn === "function" ? (template.studiestedNavn as Function)(this) : template.studiestedNavn): this.generate("StudiestedbrukerprofilDto", "studiestedNavn", "string", "Galtvort", false),
        };
    }
    sampleArrayStudiestedbrukerprofilDto(template?: Factory<StudiestedbrukerprofilDto>, length?: number): Array<StudiestedbrukerprofilDto> {
        return Array.from({length: length || this.arrayLength("StudiestedbrukerprofilDto")}).map(() => this.sampleStudiestedbrukerprofilDto(template));
    }
    sampleVurderingOppsummeringDto(template?: Factory<VurderingOppsummeringDto>): VurderingOppsummeringDto {
        if (typeof this.sampleModelProperties["VurderingOppsummeringDto"] === "function") {
            return this.sampleModelProperties["VurderingOppsummeringDto"](this);
        }

        return {
            oppsummering: template && template.oppsummering ? (typeof template.oppsummering === "function" ? (template.oppsummering as Function)(this) : template.oppsummering): this.generate("VurderingOppsummeringDto", "oppsummering", "string", "Studenten gjorde en god jobb.", false),
            ikkeBestatt: template && template.ikkeBestatt ? (typeof template.ikkeBestatt === "function" ? (template.ikkeBestatt as Function)(this) : template.ikkeBestatt): this.generate("VurderingOppsummeringDto", "ikkeBestatt", "boolean", "null", false),
            samletVurderingDelt: template && template.samletVurderingDelt ? (typeof template.samletVurderingDelt === "function" ? (template.samletVurderingDelt as Function)(this) : template.samletVurderingDelt): this.generate("VurderingOppsummeringDto", "samletVurderingDelt", "boolean", "null", false),
            vurderingBekreftet: template && template.vurderingBekreftet ? (typeof template.vurderingBekreftet === "function" ? (template.vurderingBekreftet as Function)(this) : template.vurderingBekreftet): this.generate("VurderingOppsummeringDto", "vurderingBekreftet", "boolean", "null", false),
            timerFravaer: template && template.timerFravaer ? (typeof template.timerFravaer === "function" ? (template.timerFravaer as Function)(this) : template.timerFravaer): this.generate("VurderingOppsummeringDto", "timerFravaer", "number", "null", false),
        };
    }
    sampleArrayVurderingOppsummeringDto(template?: Factory<VurderingOppsummeringDto>, length?: number): Array<VurderingOppsummeringDto> {
        return Array.from({length: length || this.arrayLength("VurderingOppsummeringDto")}).map(() => this.sampleVurderingOppsummeringDto(template));
    }
    sampleVurderingStudentDto(template?: Factory<VurderingStudentDto>): VurderingStudentDto {
        if (typeof this.sampleModelProperties["VurderingStudentDto"] === "function") {
            return this.sampleModelProperties["VurderingStudentDto"](this);
        }

        return {
            fsStudentId: template && template.fsStudentId ? (typeof template.fsStudentId === "function" ? (template.fsStudentId as Function)(this) : template.fsStudentId): this.generate("VurderingStudentDto", "fsStudentId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("VurderingStudentDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("VurderingStudentDto", "etternavn", "string", "Nordmann", false),
            studentnr: template && template.studentnr ? (typeof template.studentnr === "function" ? (template.studentnr as Function)(this) : template.studentnr): this.generate("VurderingStudentDto", "studentnr", "number", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("VurderingStudentDto", "epost", "string", "user@example.com", false),
            telefon: template && template.telefon ? (typeof template.telefon === "function" ? (template.telefon as Function)(this) : template.telefon): this.generate("VurderingStudentDto", "telefon", "string", "12345678", false),
        };
    }
    sampleArrayVurderingStudentDto(template?: Factory<VurderingStudentDto>, length?: number): Array<VurderingStudentDto> {
        return Array.from({length: length || this.arrayLength("VurderingStudentDto")}).map(() => this.sampleVurderingStudentDto(template));
    }
}
